webpackJsonp([0],{

/***/ 1000:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DependencyViewModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_mobx_store_vm_base_view_model__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_tracker__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_mobx_store_root_store__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_services_zt__ = __webpack_require__(1011);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 依赖 view model
 */var DependencyViewModel=function(_BaseViewModel){_inherits(DependencyViewModel,_BaseViewModel);function DependencyViewModel(){_classCallCheck(this,DependencyViewModel);return _possibleConstructorReturn(this,(DependencyViewModel.__proto__||Object.getPrototypeOf(DependencyViewModel)).apply(this,arguments));}_createClass(DependencyViewModel,[{key:'$ztServices',get:function get(){var _this2=this;if(!this._$ztServices){var ztServiceFactory=new __WEBPACK_IMPORTED_MODULE_3__src_services_zt__["a" /* default */]({checkIfComponentUnmount:function checkIfComponentUnmount(){return _this2.$$isUnmount;}});this._$ztServices=ztServiceFactory.createService();}return this._$ztServices;}},{key:'$tracker',get:function get(){return __WEBPACK_IMPORTED_MODULE_1__src_tracker__["a" /* $$tracker */];}},{key:'$rootStore',get:function get(){return __WEBPACK_IMPORTED_MODULE_2__src_mobx_store_root_store__["a" /* default */];}}]);return DependencyViewModel;}(__WEBPACK_IMPORTED_MODULE_0__src_mobx_store_vm_base_view_model__["a" /* default */]);

/***/ }),

/***/ 1001:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseViewModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__xfe_team_utils_src_intercept__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_error_UnmountError__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_error_EndThreadError__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__xfe_team_utils_src_common_util__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__xfe_team_utils_src_reload__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__xfe_team_utils_src_device_utils__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_error_protect__ = __webpack_require__(374);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var BaseViewModel=(_class=function(){function BaseViewModel(context){_classCallCheck(this,BaseViewModel);this.$$recycleQueue=[];this.$$componentDidMountQueue=[];_initDefineProp(this,'serviceState',_descriptor,this);this.enqueueComponentWillUnmount=this.enqueueRecycle;BaseViewModel.checkIfReactClassContext(context);this.context=context;this.createInterceptions();this.createEventListeners();this.createTime=new Date().getTime();// noinspection JSUnresolvedVariable
if(this.context.props.$prefetchProps){// noinspection JSUnresolvedVariable
this.serviceState=this.context.props.$prefetchProps;}}/**
   * @private
   *//**
   * 服务数据状态
   * @type {{}}
   *//**
   * 回收队列
   * @example
   *
   * componentDidMount() {
   *   window.addEventListener('click', this.onWindowClick, false);
   *   this.$$recycleQueue.push(() => window.removeEventListener('click', this.onWindowClick, false));
   * }
   *
   * @type {Array}
   */_createClass(BaseViewModel,[{key:'createEventListeners',value:function createEventListeners(){var _this=this;var visibilityChangeListener=function visibilityChangeListener(){// 监听网页是否进行唤起活动页面的操作 释义：用户进行息屏和灭屏或者切换到了其他应用后重新回到了当前页面
document.hidden?_this.$$onHide():_this.$$onShow();};// noinspection SpellCheckingInspection
document.addEventListener('visibilitychange',visibilityChangeListener);// noinspection SpellCheckingInspection
this.enqueueRecycle(function(){return document.removeEventListener('visibilitychange',visibilityChangeListener);});/**
     * 在手机连接断网和恢复联网时给用户进行相关提示
     * @param type
     */var onConnectionChange=function onConnectionChange(_ref){var type=_ref.type;if(type==='offline'){_this.$$onOffLine();}else if(type==='online'){_this.$$onOnline();}else{throw new Error('unknown network connection type = '+type);}};window.addEventListener('online',onConnectionChange);window.addEventListener('offline',onConnectionChange);}/**
   * @private
   */},{key:'enqueueRecycle',/**
   * 入队回收队列
   * @public
   * @param {Function} disposalAction - 回收操作
   */value:function enqueueRecycle(disposalAction){this.$$recycleQueue.push(disposalAction);}/**
   * 销毁时触发 action
   * enqueueRecycle alias
   * @type {BaseViewModel.enqueueComponentWillUnmount}
   */},{key:'enqueueComponentDidMount',value:function enqueueComponentDidMount(action){this.$$componentDidMountQueue.push(action);}/**
   * wp => 缩写 wrapPromise, 用于包裹 promise, 用于解决 promise 在组件卸载后的副作用
   * @param {Promise|Function} promise - promise 对象或 function
   * @return {*}
   */},{key:'wp',value:function wp(promise){var _this2=this;if(typeof promise==='function'){promise=promise();}return promise.then(function(result){_this2.mayThrowUnmountError();return result;},function(err){_this2.mayThrowUnmountError();throw err;});}/**
   * 可能会抛出"组件已卸载"异常
   */},{key:'mayThrowUnmountError',value:function mayThrowUnmountError(){if(this.$$isUnmount){throw new __WEBPACK_IMPORTED_MODULE_1__src_error_UnmountError__["a" /* default */]();}}},{key:'delay',value:function delay(ms){return this.wp(Object(__WEBPACK_IMPORTED_MODULE_4__xfe_team_utils_src_common_util__["c" /* delay */])(ms));}/**
   * 微任务回调
   * @param {Function} action - 操作事件
   * @return {Promise<void>}
   */},{key:'nextTick',value:function nextTick(action){return Promise.resolve().then(action);}/**
   * 重定向辅助方法,
   * 基本用法:
   * this.redirect('/detail/1', {query: {name: 'allen'}})
   * => /detail/1?name=allen
   *
   * @param {string} routePath - 重定向地址
   * @param {string} [type] - 重定向类型, 支持 push, replace, 默认: push
   * @param {object} [params] - 路由传入参数, 如: {name: 123, gender: 456}
   * @param {boolean} [endThread] - 是否中断线程
   * @param {object} query - query string
   */},{key:'redirect',value:function redirect(routePath){var _ref2=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},_ref2$type=_ref2.type,type=_ref2$type===undefined?'push':_ref2$type,_ref2$endThread=_ref2.endThread,endThread=_ref2$endThread===undefined?false:_ref2$endThread,params=_ref2.params,query=_ref2.query;var availableType={push:'push',replace:'replace'};__WEBPACK_IMPORTED_MODULE_2_invariant___default()(availableType[type],'\u91CD\u5B9A\u5411\u7C7B\u578B\u4E0D\u6B63\u786E, type = '+type);var $router=this.context.props.$router;__WEBPACK_IMPORTED_MODULE_2_invariant___default()($router,'请正确使用 withEnhanceRouter 对 page component 进行装饰');if(endThread){// noinspection JSIgnoredPromiseFromCall
setTimeout(function(){$router[type]({url:routePath,params:params,query:query});});throw new __WEBPACK_IMPORTED_MODULE_3__src_error_EndThreadError__["a" /* default */]();}else{$router[type]({url:routePath,params:params,query:query});}}/**
   * 获取路由 params 参数, #/article/1
   * @returns {{}} - 返回路由参数如: {id: 1}
   */},{key:'getRouteParams',value:function getRouteParams(){return this.context.props.$router.params;}/**
   * 获取路由 search params 参数, 如 #/article?id=1
   * @returns {{}} - 返回路由参数如: {id: 1}
   */},{key:'getRouteQueryParams',value:function getRouteQueryParams(){return this.context.props.$router.query;}/**
   * 强行跳转
   * @param {string} routePath - 重定向地址
   */},{key:'forceRedirect',value:function forceRedirect(routePath){__WEBPACK_IMPORTED_MODULE_2_invariant___default()(!(__WEBPACK_IMPORTED_MODULE_6__xfe_team_utils_src_device_utils__["a" /* default */].isWeiXin()&&__WEBPACK_IMPORTED_MODULE_6__xfe_team_utils_src_device_utils__["a" /* default */].isAndroid()&&window.location.href===routePath),'在微信安卓端中, 跳转路由地址不能与当前地址一样, 否者将不会有任何效果');window.location.href=routePath;throw new __WEBPACK_IMPORTED_MODULE_3__src_error_EndThreadError__["a" /* default */]();}},{key:'createInterceptions',value:function createInterceptions(){var _this3=this;// 在 react 16.8 后开始出现大量 warning, 故逐步不建议使用
// intercept(this.context, 'componentWillMount', this.$$componentWillMount, this);
// intercept(this.context, 'componentWillReceiveProps', this.$$componentWillReceiveProps, this);
// intercept(this.context, 'componentWillUpdate', this.$$componentWillUpdate, this);
Object(__WEBPACK_IMPORTED_MODULE_0__xfe_team_utils_src_intercept__["a" /* default */])(this.context,'componentDidMount',function(){return Object(__WEBPACK_IMPORTED_MODULE_8__src_error_protect__["a" /* default */])()(_this3.$$componentDidMount.bind(_this3));},this);Object(__WEBPACK_IMPORTED_MODULE_0__xfe_team_utils_src_intercept__["a" /* default */])(this.context,'shouldComponentUpdate',function(){return Object(__WEBPACK_IMPORTED_MODULE_8__src_error_protect__["a" /* default */])()(_this3.$$shouldComponentUpdate.bind(_this3));},this);Object(__WEBPACK_IMPORTED_MODULE_0__xfe_team_utils_src_intercept__["a" /* default */])(this.context,'componentDidUpdate',function(){return Object(__WEBPACK_IMPORTED_MODULE_8__src_error_protect__["a" /* default */])()(_this3.$$componentDidUpdate.bind(_this3));},this);Object(__WEBPACK_IMPORTED_MODULE_0__xfe_team_utils_src_intercept__["a" /* default */])(this.context,'componentWillUnmount',function(){return Object(__WEBPACK_IMPORTED_MODULE_8__src_error_protect__["a" /* default */])()(_this3.$$componentWillUnmount.bind(_this3));},this);}/**
   * 组件加载完成, 等效于组件中的 componentDidMount
   * 当用于发起服务请求等 <br />
   * this.$ztServices.getUserInfo();
   */},{key:'$$componentDidMount',value:function $$componentDidMount(){this.$$componentDidMountQueue.forEach(function(action){return action();});}},{key:'$$shouldComponentUpdate',value:function $$shouldComponentUpdate(){}},{key:'$$componentDidUpdate',value:function $$componentDidUpdate(){}/**
   * react 生命周期, 使用这个函数进行相关回收, 防止内存泄漏
   * @public
   */},{key:'$$componentWillUnmount',value:function $$componentWillUnmount(){this.$$isUnmount=true;this.$$recycleQueue.forEach(function(recycle){return recycle();});}/**
   * 计算差值
   * @returns {number}
   */},{key:'getDiffTimeBtwShowAndHide',value:function getDiffTimeBtwShowAndHide(){return this.$onShowTime-this.$onHideTime;}/**
   * 长时间离开当前页面
   */},{key:'isAfkForLongTime',value:function isAfkForLongTime(){return this.getDiffTimeBtwShowAndHide()>1000*60*60/* 1小时 */;}/**
   * 页面展示时, 如切换回当前页面 tab, 或手机后台回到页面时触发
   */},{key:'$$onShow',value:function $$onShow(){this.$onShowTime=+new Date();if(this.isAfkForLongTime()){Object(__WEBPACK_IMPORTED_MODULE_5__xfe_team_utils_src_reload__["a" /* default */])();throw new __WEBPACK_IMPORTED_MODULE_3__src_error_EndThreadError__["a" /* default */]();}}/**
   * 页面隐藏时, 如切换 chrome tab 离开当前页面, 或手机切换到后台时触发
   */},{key:'$$onHide',value:function $$onHide(){this.$onHideTime=+new Date();}/**
   * 当手机从离线切换到在线时触发
   */},{key:'$$onOnline',value:function $$onOnline(){}/**
   * 当手机从在线切换到离线时触发
   */},{key:'$$onOffLine',value:function $$onOffLine(){}}],[{key:'checkIfReactClassContext',value:function checkIfReactClassContext(context){__WEBPACK_IMPORTED_MODULE_2_invariant___default()(context&&context.isReactComponent,'请正确传入 react class 实例对象 this');}}]);return BaseViewModel;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'serviceState',[__WEBPACK_IMPORTED_MODULE_7_mobx__["n" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}})),_class);

/***/ }),

/***/ 1002:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = intercept;
/**@module intercept *//**
 * 拦截function
 * @param {object} context 上下文
 * @param {string} functionName 函数名
 * @param {Function} action
 * @param {object} bind
 */function intercept(context,functionName,action){var bind=arguments.length>3&&arguments[3]!==undefined?arguments[3]:context;var raw=context[functionName];context[functionName]=function(){// 绑回指定 context
action&&action.apply(bind);// 绑回原生
return raw&&raw.apply(context);};}

/***/ }),

/***/ 1003:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__device_utils__ = __webpack_require__(992);
/** @module reload *//**
 * 页面刷新, 针对微信中安卓 window.location['reload']() 无效的问题处理
 */function reload(){if(__WEBPACK_IMPORTED_MODULE_0__device_utils__["a" /* default */].isIOS()){/**
     * 绕过部署时检测, 允许这个行为
     */window.location.reload.apply(window.location);return;}var newTs='&ts='+Date.now();var search=window.location.search;var hasTs=/&ts=\d+/.test(search);if(hasTs){search=window.location.search.replace(/&ts=\d+/,newTs);}else{if(!search){search='?';}search+=newTs;}window.location.href=window.location.origin+window.location.pathname+search+window.location.hash;}

/***/ }),

/***/ 1004:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserAgent", function() { return getUserAgent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMobile", function() { return isMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAndroid", function() { return isAndroid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIOS", function() { return isIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isWeiXin", function() { return isWeiXin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMWeiXin", function() { return isMWeiXin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMQQ", function() { return isMQQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMWeibo", function() { return isMWeibo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isJianghuDaily", function() { return isJianghuDaily; });
/**
 * 获取 UA
 * @return {string}
 */
function getUserAgent() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return userAgent.toLowerCase();
}
/**
 * 判断是否是手机
 * @return {boolean}
 */
function isMobile() {
    var userAgent = getUserAgent();
    return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) ||
        // eslint-disable-next-line
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([ -\/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([ \/])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([- ])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(userAgent.substr(0, 4)));
}
/**
 * 判断是否是 android 设备
 * @return {boolean}
 */
function isAndroid() {
    return /android/i.test(getUserAgent());
}
/**
 * 判断是否 ios 设备
 * @return {boolean}
 */
function isIOS() {
    return (/iPad|iPhone|iPod/i.test(getUserAgent()) && !window.MSStream);
}
/**
 * 是否是 微信 设备
 * @return {boolean}
 */
function isWeiXin() {
    var userAgent = getUserAgent();
    return String(userAgent.match(/MicroMessenger/i)) === 'micromessenger';
}
/**
 * 判断是否是 mobile 微信
 * @return {boolean}
 */
function isMWeiXin() {
    return isMobile() && isWeiXin();
}
/**
 * 判断是否是手机qq
 * @return {boolean}
 */
function isMQQ() {
    var userAgent = getUserAgent();
    var isIOSQQ = isIOS() && / QQ/i.test(userAgent);
    var isAndroidQQ = isAndroid() &&
        /MQQBrowser/i.test(navigator.userAgent) &&
        /QQ/i.test(userAgent.split('mqqbrowser'));
    return isMobile() && (isIOSQQ || isAndroidQQ);
}
/**
 * 判断是否是手机微博 UA
 * @return {boolean}
 */
function isMWeibo() {
    var userAgent = getUserAgent();
    return isMobile() && /(weibo)/.test(userAgent);
}
/**
 * 判断是否是江湖 daily App
 */
function isJianghuDaily() {
    var userAgent = getUserAgent();
    return /jianghudaily/i.test(userAgent);
}


//# sourceMappingURL=index.es.js.map


/***/ }),

/***/ 1005:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return $$tracker; });
/* unused harmony export stReportSdk */
/* unused harmony export getDiffRouteTime */
/* unused harmony export report */
/* unused harmony export trackPageLoad */
/* unused harmony export trackPageLeave */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_tracker__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfe_team_tracker_src__ = __webpack_require__(1006);
var _initTracker=Object(__WEBPACK_IMPORTED_MODULE_1__xfe_team_tracker_src__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__create_tracker__["b" /* default */],__WEBPACK_IMPORTED_MODULE_0__create_tracker__["a" /* config */],{},true),$$tracker=_initTracker.$$tracker,stReportSdk=_initTracker.stReportSdk,getDiffRouteTime=_initTracker.getDiffRouteTime,report=_initTracker.report,trackPageLoad=_initTracker.trackPageLoad,trackPageLeave=_initTracker.trackPageLeave;

/***/ }),

/***/ 1006:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initTracker;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__report__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__track_page_load__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__track_page_leave__ = __webpack_require__(1010);
/**
 * 初始化tracker
 * @param {function} createTracker 生成的createTracker函数
 * @param {Object} config 埋点config
 * @param {Object} thirdPartyAuthStore 第三方授权store
 * @param {Boolean} isPc 是否是pc
 * @return {*}
 */function initTracker(createTracker,config,thirdPartyAuthStore){var isPc=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var _getReport=Object(__WEBPACK_IMPORTED_MODULE_0__report__["a" /* default */])(config,thirdPartyAuthStore,isPc),stReportSdk=_getReport.stReportSdk,getDiffRouteTime=_getReport.getDiffRouteTime,report=_getReport.report;var $$tracker=createTracker(report,getDiffRouteTime);var trackPageLoad=Object(__WEBPACK_IMPORTED_MODULE_1__track_page_load__["a" /* default */])(stReportSdk,report,getDiffRouteTime);var trackPageLeave=Object(__WEBPACK_IMPORTED_MODULE_2__track_page_leave__["a" /* default */])(stReportSdk);return{$$tracker:$$tracker,stReportSdk:stReportSdk,getDiffRouteTime:getDiffRouteTime,report:report,trackPageLoad:trackPageLoad,trackPageLeave:trackPageLeave};}

/***/ }),

/***/ 1007:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getReport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__xfe_st_report_sdk__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__xfe_st_report_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__xfe_st_report_sdk__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/**
 * 当登录后同时上报登录授权信息
 * @param thirdPartyAuthStore
 * @param isPc
 * @return {{wechat_uid: undefined, passport_uid: undefined, qq_uid: undefined}}
 */function getTrackerAuthInfo(thirdPartyAuthStore,isPc){if(isPc){return{};}// noinspection JSUnresolvedVariable
var thirdUid=thirdPartyAuthStore.data?thirdPartyAuthStore.data.uid_encode:undefined;// noinspection JSUnresolvedVariable,SpellCheckingInspection
var thirdPartyAuthStoreUa=thirdPartyAuthStore.ua;// noinspection SpellCheckingInspection
return{qq_uid:thirdPartyAuthStoreUa==='qq'?thirdUid:undefined,wechat_uid:thirdPartyAuthStoreUa==='wechat'?thirdUid:undefined,/* 春丽坚持使用 passport_uid, 个人建议过使用 */passport_uid:thirdPartyAuthStoreUa==='daily'?thirdUid:undefined};}/**
 * @type function
 * 计算上一次路由时间,
 * 对应买点中的: ev_d.td_pl(秒)
 */var getDiffRouteTime=__WEBPACK_IMPORTED_MODULE_0__xfe_st_report_sdk___default.a.getDiffRouteTime;/**
 *
 * @param config
 * @param thirdPartyAuthStore
 * @param isPc
 * @return {{ev_d: any}|{stReportSdk: *, getDiffRouteTime: Function, report: report}}
 */function getReport(config,thirdPartyAuthStore,isPc){var params={projectIdentifier:config.identify/* 项目标识: 如: jx3, 必须填写！！*/,eventTags:config.eventTags/* 必须填写！！专题tags，这个数组需要替换为埋点文档上的 ev_tag, 最后一个 js4_xxxx_20181204 往往是专题标识 */,eventGroup:config.eventGroup/* 必须填写！！专题tags，这个数组需要替换为埋点文档上的 ev_tag, 最后一个 js4_xxxx_20181204 往往是专题标识 */,// eslint-disable-next-line camelcase
beforeReport:function beforeReport(_ref){var ev_d=_ref.ev_d,restProps=_objectWithoutProperties(_ref,['ev_d']);return _extends({ev_d:_extends(ev_d,getTrackerAuthInfo(thirdPartyAuthStore,isPc))},restProps);}};var stReportSdk=__WEBPACK_IMPORTED_MODULE_0__xfe_st_report_sdk___default.a.getInstance(params,false/* 是否开日志上报的 logger，默认是生产环境不开，平时开；想要关可以直接设为false */);var report=function report(_ref2){var eventName=_ref2.eventName,eventDescription=_ref2.eventDescription,eventGroup=_ref2.eventGroup,_ref2$eventDataValue=_ref2.eventDataValue,eventDataValue=_ref2$eventDataValue===undefined?{}:_ref2$eventDataValue,types=_ref2.types,restProps=_objectWithoutProperties(_ref2,['eventName','eventDescription','eventGroup','eventDataValue','types']);if(eventName==='load_page'){throw new Error('禁止手动上报 load_page 事件, 模板 src/tracker/track-page-load.js 默认已调用 stReportSdk.trackPageLoad(); 请再三核对');}try{if(types&&eventDataValue){var errorMessages=Object.keys(eventDataValue).reduce(function(errorMessages,key){if(!types[key](eventDataValue[key])){errorMessages.push(eventName+' \u4E0A\u62A5\u7684 eventDataValue.'+key+' \u7684\u7C7B\u578B\u4E0D\u7B26\u5408');}return errorMessages;},[]);if(errorMessages.length){throw new Error(errorMessages.join('\r\n'));}}stReportSdk.report(_extends({eventName:eventName,eventDescription:eventDescription,eventDataValue:eventDataValue,eventGroup:eventGroup,eventTags:params.eventTags},restProps));}catch(e){// 为了能够继续往后走, 但是能够上报
setTimeout(function(){throw e;});}};return{stReportSdk:stReportSdk,getDiffRouteTime:getDiffRouteTime,report:report};}

/***/ }),

/***/ 1008:
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("StReportSdk", [], factory);
	else if(typeof exports === 'object')
		exports["StReportSdk"] = factory();
	else
		root["StReportSdk"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	var st_report_sdk_1 = __webpack_require__(1);
	module.exports = module.exports['default'] = st_report_sdk_1["default"];

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var __assign = undefined && undefined.__assign || Object.assign || function (t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) {
	            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	    }
	    return t;
	};
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	exports.__esModule = true;
	var queryString = __webpack_require__(2);
	var events_1 = __webpack_require__(5);
	var uuidv4 = __webpack_require__(6);
	var get_utm_source_by_ua_1 = __webpack_require__(9);
	window.addEventListener('DOMContentLoaded', refresh, false);
	window.addEventListener('hashchange', refresh, false);
	var routeStartTime;
	function refresh() {
	    routeStartTime = +new Date();
	}
	var StReportSdk = /** @class */function () {
	    /**
	     * 构造函数
	     * @param {boolean} disableGetRequireQsFromUrl - 是否禁止通过 url 拉取所需的 query string 以用于后续上报
	     * @param {string[]} qsWhiteList -  query string  白名单
	     * @param {string} apiAddress 上报 API 地址
	     * @param {string} projectIdentifier 项目标识（[A-Za-z_]+{4,32},内部约定）
	     * @param [string[]] eventTags - 事件标签数组（格式与时间分组一致），可选
	     * @param {string} eventGroup - 事件分组（[A-Za-z_\-]+{1,},内部约定），可选
	     * @param {string} autoDetectUtmSource - 是否自动识别 utm_source, 当 utm_source 为 js false 时才使用
	     * @param {boolean} debug 是否启用调试模式
	     * @param {Function} beforeReport - 上报前拦截
	     */
	    function StReportSdk(_a) {
	        var _b = _a === void 0 ? {} : _a,
	            _c = _b.disableGetRequireQsFromUrl,
	            disableGetRequireQsFromUrl = _c === void 0 ? false : _c,
	            _d = _b.qsWhiteList,
	            qsWhiteList = _d === void 0 ? [] : _d,
	            apiAddress = _b.apiAddress,
	            projectIdentifier = _b.projectIdentifier,
	            eventTags = _b.eventTags,
	            eventGroup = _b.eventGroup,
	            _e = _b.autoDetectUtmSource,
	            autoDetectUtmSource = _e === void 0 ? true : _e,
	            beforeReport = _b.beforeReport,
	            _f = _b.debug,
	            debug = _f === void 0 ? false : _f;
	        this.disableGetRequireQsFromUrl = disableGetRequireQsFromUrl;
	        this.qsWhiteList = qsWhiteList;
	        this.apiAddress = apiAddress;
	        this.eventTags = eventTags;
	        this.eventGroup = eventGroup;
	        this.projectIdentifier = projectIdentifier;
	        this.autoDetectUtmSource = autoDetectUtmSource;
	        this.debug = debug;
	        this.beforeReport = beforeReport;
	    }
	    /**
	     * 获取默认实例
	     * @param {string} projectIdentifier - 项目唯一标识
	     * @param eventTags [string[]] - 事件标签数组（格式与时间分组一致），可选
	     * @param {boolean} [debug] - 是否启用调试模式
	     * @param {string} [eventGroup] - 事件分组（[A-Za-z_\-]+{1,},内部约定），可选
	     * @param {*} [restProps]
	     * @return {StReportSdk} - 返回当前实例
	     */
	    StReportSdk.getInstance = function (_a, debug) {
	        if (_a === void 0) {
	            _a = {};
	        }
	        var projectIdentifier = _a.projectIdentifier,
	            eventTags = _a.eventTags,
	            eventGroup = _a.eventGroup,
	            restProps = __rest(_a, ["projectIdentifier", "eventTags", "eventGroup"]);
	        if (typeof arguments[0] === 'string') {
	            projectIdentifier = arguments[0];
	        }
	        return new StReportSdk(__assign({}, StReportSdk.defaultProps, { projectIdentifier: projectIdentifier,
	            eventTags: eventTags,
	            eventGroup: eventGroup,
	            debug: debug }, restProps));
	    };
	    /**
	     * 获取 page view id
	     * @return {string}
	     */
	    StReportSdk.getPageViewId = function () {
	        var uid = StReportSdk.pageViewCache.uid;
	        if (!uid) {
	            StReportSdk.pageViewCache = {
	                currentUrl: location.href,
	                uid: uuidv4()
	            };
	        }
	        return StReportSdk.pageViewCache.uid;
	    };
	    /**
	     * 上报
	     * @param projectIdentifier [string] - 项目标识（[A-Za-z_]+{4, },内部约定），必选
	     * @param eventName [string] - 事件名称，（格式与时间分组一致），可选
	     * @param eventGroup [string] - 事件分组（[A-Za-z_\-]+{1,},内部约定），可选
	     * @param eventDescription [string]- 事件描述（字符串）
	     * @param eventDataValue [object] - 事件额外数据对象，kv对，可选, 如: evd[k1]=v1&evd[k2]
	     * @param eventTags [string[]] - 事件标签数组（格式与时间分组一致），可选
	     * @param referer {string} - 事件标签数组（格式与时间分组一致），可选
	     * @param {Function} beforeReport - 上报前拦截
	     * @param shouldSendBeacon {boolean} - 是否以 navigator.sendBeacon 的形式发送请求
	     */
	    StReportSdk.prototype.report = function (_a) {
	        var _b = _a === void 0 ? {} : _a,
	            projectIdentifier = _b.projectIdentifier,
	            eventName = _b.eventName,
	            eventGroup = _b.eventGroup,
	            eventDescription = _b.eventDescription,
	            eventDataValue = _b.eventDataValue,
	            _c = _b.eventTags,
	            eventTags = _c === void 0 ? [] : _c,
	            referer = _b.referer,
	            _d = _b.beforeReport,
	            beforeReport = _d === void 0 ? this.beforeReport : _d,
	            shouldSendBeacon = _b.shouldSendBeacon;
	        var whiteListLocationSearchObject = this.disableGetRequireQsFromUrl ? {} : this.getWhiteListLocationSearchObject();
	        var apiAddress = this.apiAddress;
	        var p = projectIdentifier || this.projectIdentifier;
	        if (eventGroup && typeof eventGroup !== 'string') {
	            throw new Error('事件分组 event group 必须为 string 类型');
	        }
	        var ev_g = eventGroup || this.eventGroup;
	        var ev_desc = eventDescription;
	        var ev_d = eventDataValue;
	        var ev_n = eventName;
	        var ev_tag = Array.isArray(eventTags) && eventTags.length ? eventTags : this.eventTags;
	        var pv_id = StReportSdk.getPageViewId();
	        var prev_ref = document.referrer;
	        var full_ref = window.location.href;
	        var customRequestParams = __assign({ p: p, ev_g: ev_g, ev_desc: ev_desc, ev_d: ev_d, ev_n: ev_n, ev_tag: ev_tag, pv_id: pv_id, prev_ref: prev_ref, full_ref: full_ref }, StReportSdk.getDeviceSize());
	        var requestParams = _extends(customRequestParams, whiteListLocationSearchObject);
	        if (beforeReport) {
	            requestParams = beforeReport(requestParams);
	        }
	        var requestParamString = StReportSdk.convertObjectToRequestParams(requestParams);
	        var finalRequestUrl = apiAddress + "?" + encodeURIComponent(requestParamString);
	        this.debugLog("report custom request params: ", customRequestParams);
	        this.debugLog("report white list location search object: ", whiteListLocationSearchObject);
	        this.debugLog("report request params: ", requestParams);
	        this.debugLog("report api address: ", apiAddress);
	        // this.debugLog(`report final request url: `, finalRequestUrl); 没有人关注最后的链接
	        if (StReportSdk.isSendBeaconSupported() && shouldSendBeacon) {
	            StReportSdk.reportRequestViaBeacon(finalRequestUrl);
	        } else {
	            StReportSdk.reportRequestViaImage(finalRequestUrl);
	        }
	    };
	    /**
	     * 获取设备宽高
	     * @return {object} e.g. {ua_cw: 1920, ua_ch: 1080, ua_cwh: "1920x1080", ua_cdr: "16:9", ua_co: "landscape"}
	     */
	    StReportSdk.getDeviceSize = function () {
	        var innerWidth = window.innerWidth || 0;
	        var innerHeight = window.innerHeight || 0;
	        return {
	            // 设备实际屏幕宽度:ua_cw(client width)  整型 例如 1440 ，没有上报默认0  （整型方便做数值运算类的统计，例如分辨率大于多少XXX）
	            ua_cw: innerWidth,
	            // 设备实际屏幕高度:ua_ch(client height) 整型 例如 900，没有上报默认0
	            ua_ch: innerHeight,
	            // 设备实际屏幕宽度x设备屏幕高度:ua_cwh 字符串，例如：“1440x900” ，没有上报默认 "0x0" （这个可以做聚合）
	            ua_cwh: innerWidth + "x" + innerHeight,
	            // 设备屏幕宽高:ua_device_cwh(client device width height) 例如：“1440x900” ，没有上报默认 "0x0" （这个可以做聚合）
	            ua_device_cwh: window.screen.width + "x" + window.screen.height,
	            // 设备屏幕宽高比例: ua_device_csr(client device screen ratio) 设备比例, 以9为基数计算 (如: 9:16)
	            ua_device_csr: StReportSdk.getScreenRatioArr(window.screen.width, window.screen.height).join(':'),
	            // ua_cdr(client screen ratio) 设备比例, 以9为基数计算 (如: 9:16)
	            ua_csr: StReportSdk.getScreenRatioArr(innerWidth, innerHeight).join(':'),
	            // ua client orientation 设备横竖屏方向
	            ua_co: window.innerHeight > window.innerWidth ? 'portrait' : 'landscape'
	        };
	    };
	    /**
	     * 获取屏幕比例
	     * @param {number} width - 长度
	     * @param {number} height - 高度
	     */
	    StReportSdk.getScreenRatioArr = function (width, height) {
	        if (!width || !height) {
	            return [width, height];
	        }
	        var biggerValue = Math.max(width, height);
	        var smallerValue = Math.min(width, height);
	        var clientDeviceRatioArr = [9, Number((biggerValue / smallerValue * 9).toFixed(2))];
	        if (width > height) {
	            clientDeviceRatioArr.reverse();
	        }
	        return clientDeviceRatioArr;
	    };
	    /**
	     * 追踪点击事件。
	     * trackClick('ViewProduct');
	     * @param eventName {string} - 必选。表示要追踪的事件名。
	     * @param properties {object} - 可选。为了保证统一接口，properties可选填，但对于百度统计无效。
	     */
	    StReportSdk.prototype.trackClick = function (eventName, properties) {
	        this.report({ eventName: eventName, eventDataValue: properties });
	    };
	    /**
	     * 页面载入上报共用方法
	     * @param extra
	     */
	    StReportSdk.prototype.pageLoad = function (extra) {
	        if (extra === void 0) {
	            extra = {};
	        }
	        var _a = extra.eventDataValue,
	            eventDataValue = _a === void 0 ? {} : _a,
	            restProps = __rest(extra, ["eventDataValue"]);
	        eventDataValue = _extends(eventDataValue, { td_pl: StReportSdk.getDiffRouteTime(), ts: +new Date() });
	        this.report(__assign({ eventName: 'load_page', eventDataValue: eventDataValue }, restProps));
	    };
	    /**
	     * 页面载入上报共用方法
	     * @param extra
	     */
	    StReportSdk.prototype.pageLeave = function (extra) {
	        if (extra === void 0) {
	            extra = {};
	        }
	        var _a = extra.eventDataValue,
	            eventDataValue = _a === void 0 ? {} : _a,
	            restProps = __rest(extra, ["eventDataValue"]);
	        eventDataValue = _extends(eventDataValue, { td_pl: StReportSdk.getDiffRouteTime(), ts: +new Date() });
	        this.report(__assign({ eventName: 'page_leave', shouldSendBeacon: true, eventDataValue: eventDataValue }, restProps));
	    };
	    /**
	     * 跟踪页面初始化时候上报 用于记录PV
	     */
	    StReportSdk.prototype.trackPageLoad = function (extra) {
	        var _this = this;
	        if (extra === void 0) {
	            extra = {};
	        }
	        events_1["default"]('load', function () {
	            _this.pageLoad(extra);
	        });
	    };
	    /**
	     * 跟踪页面离开
	     */
	    StReportSdk.prototype.trackPageLeave = function (extra) {
	        var _this = this;
	        if (extra === void 0) {
	            extra = {};
	        }
	        window.addEventListener('beforeunload', function () {
	            _this.pageLeave(extra);
	        }, true);
	    };
	    /**
	     * 当react或vue路由切换页面时上报
	     */
	    StReportSdk.prototype.trackRoutePageLoad = function (extra) {
	        this.pageLoad(extra);
	    };
	    /**
	     * 计算 route 时间差异
	     */
	    StReportSdk.getDiffRouteTime = function () {
	        if (routeStartTime) {
	            return +new Date() - routeStartTime;
	        } else {
	            return 0;
	        }
	    };
	    /**
	     * 根据当前白名单过滤获取 Location Search Object
	     * @return {ILocationObject}
	     */
	    StReportSdk.prototype.getWhiteListLocationSearchObject = function () {
	        var qsWhiteList = this.qsWhiteList;
	        var locationSearchObject = StReportSdk.getLocationSearchObject();
	        if (this.autoDetectUtmSource) {
	            if (!locationSearchObject['utm_source']) {
	                locationSearchObject['utm_source'] = get_utm_source_by_ua_1["default"]();
	            }
	        }
	        return Object.keys(locationSearchObject).reduce(function (result, key) {
	            if (qsWhiteList.indexOf(key) > -1) {
	                result[key] = locationSearchObject[key];
	            }
	            return result;
	        }, {});
	    };
	    /**
	     * 移除对象中 undefined 的属性
	     * @private
	     * @param {object} obj - 任意 js 对象
	     */
	    StReportSdk.removeObjectUndefinedProps = function (obj) {
	        var result = {};
	        for (var key in obj) {
	            if (obj.hasOwnProperty(key) && obj[key] !== undefined) {
	                result[key] = obj[key];
	            }
	        }
	        return result;
	    };
	    /**
	     * 调试log
	     * @param {string} message
	     * @param {*} extraMessage
	     */
	    StReportSdk.prototype.debugLog = function (message, extraMessage) {
	        if (this.debug) {
	            var PREFIX = 'st-report-sdk: ';
	            try {
	                if ((typeof extraMessage === "undefined" ? "undefined" : _typeof(extraMessage)) === 'object') {
	                    console.log("" + PREFIX + message);
	                    console.table(StReportSdk.removeObjectUndefinedProps(extraMessage));
	                } else {
	                    console.log("" + PREFIX + message, extraMessage);
	                }
	            } catch (e) {
	                console.log("" + PREFIX + message, extraMessage);
	            }
	        }
	    };
	    /**
	     * 获取 location.search 中 query string 对象
	     * 输入: "?foo=bar"
	     * 输出 {foo: 'bar'}
	     * @return {ILocationObject}
	     */
	    StReportSdk.getLocationSearchObject = function () {
	        return queryString.parse(location.search);
	    };
	    /**
	     * 将请求对象转换
	     * @param obj
	     * @return {string}
	     */
	    StReportSdk.convertObjectToRequestParams = function (obj) {
	        return JSON.stringify(obj);
	    };
	    /**
	     * 判断 navigator.sendBeacon 是否被当前浏览器支持
	     */
	    StReportSdk.isSendBeaconSupported = function () {
	        return navigator && navigator.sendBeacon;
	    };
	    /**
	     * 通过"图片请求"上报请求
	     * @private
	     * @param {string} requestUrl
	     */
	    StReportSdk.reportRequestViaImage = function (requestUrl) {
	        new Image().src = requestUrl;
	    };
	    /**
	     * 通过"navigator.sendBeacon请求"上报请求
	     * @private
	     * @param {string} requestUrl
	     */
	    StReportSdk.reportRequestViaBeacon = function (requestUrl) {
	        navigator.sendBeacon(requestUrl);
	    };
	    /**
	     * 默认 props
	     */
	    StReportSdk.defaultProps = {
	        qsWhiteList: ['utm_source', 'utm_medium', 'utm_term', 'utm_content', 'utm_campaign'],
	        apiAddress: '//st.xoyo.com/report/web'
	    };
	    /**
	     * 单例值, 用于存储 url 和 uid,
	     * 请勿直接使用该变量, 请使用 getPageViewId 访问内部值
	     * @type {IPageViewCache}
	     */
	    StReportSdk.pageViewCache = {};
	    return StReportSdk;
	}();
	exports["default"] = StReportSdk;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var strictUriEncode = __webpack_require__(3);
	var decodeComponent = __webpack_require__(4);
	function encoderForArrayFormat(options) {
	    switch (options.arrayFormat) {
	        case 'index':
	            return function (key, value, index) {
	                return value === null ? [encode(key, options), '[', index, ']'].join('') : [encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('');
	            };
	        case 'bracket':
	            return function (key, value) {
	                return value === null ? [encode(key, options), '[]'].join('') : [encode(key, options), '[]=', encode(value, options)].join('');
	            };
	        default:
	            return function (key, value) {
	                return value === null ? encode(key, options) : [encode(key, options), '=', encode(value, options)].join('');
	            };
	    }
	}
	function parserForArrayFormat(options) {
	    var result;
	    switch (options.arrayFormat) {
	        case 'index':
	            return function (key, value, accumulator) {
	                result = /\[(\d*)\]$/.exec(key);
	                key = key.replace(/\[\d*\]$/, '');
	                if (!result) {
	                    accumulator[key] = value;
	                    return;
	                }
	                if (accumulator[key] === undefined) {
	                    accumulator[key] = {};
	                }
	                accumulator[key][result[1]] = value;
	            };
	        case 'bracket':
	            return function (key, value, accumulator) {
	                result = /(\[\])$/.exec(key);
	                key = key.replace(/\[\]$/, '');
	                if (!result) {
	                    accumulator[key] = value;
	                    return;
	                }
	                if (accumulator[key] === undefined) {
	                    accumulator[key] = [value];
	                    return;
	                }
	                accumulator[key] = [].concat(accumulator[key], value);
	            };
	        default:
	            return function (key, value, accumulator) {
	                if (accumulator[key] === undefined) {
	                    accumulator[key] = value;
	                    return;
	                }
	                accumulator[key] = [].concat(accumulator[key], value);
	            };
	    }
	}
	function encode(value, options) {
	    if (options.encode) {
	        return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	    }
	    return value;
	}
	function decode(value, options) {
	    if (options.decode) {
	        return decodeComponent(value);
	    }
	    return value;
	}
	function keysSorter(input) {
	    if (Array.isArray(input)) {
	        return input.sort();
	    }
	    if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object') {
	        return keysSorter(Object.keys(input)).sort(function (a, b) {
	            return Number(a) - Number(b);
	        }).map(function (key) {
	            return input[key];
	        });
	    }
	    return input;
	}
	function extract(input) {
	    var queryStart = input.indexOf('?');
	    if (queryStart === -1) {
	        return '';
	    }
	    return input.slice(queryStart + 1);
	}
	function parse(input, options) {
	    options = _extends({ decode: true, arrayFormat: 'none' }, options);
	    var formatter = parserForArrayFormat(options);
	    // Create an object with no prototype
	    var ret = Object.create(null);
	    if (typeof input !== 'string') {
	        return ret;
	    }
	    input = input.trim().replace(/^[?#&]/, '');
	    if (!input) {
	        return ret;
	    }
	    for (var _i = 0, _a = input.split('&'); _i < _a.length; _i++) {
	        var param = _a[_i];
	        var _b = param.replace(/\+/g, ' ').split('='),
	            key = _b[0],
	            value = _b[1];
	        // Missing `=` should be `null`:
	        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
	        value = value === undefined ? null : decode(value, options);
	        formatter(decode(key, options), value, ret);
	    }
	    return Object.keys(ret).sort().reduce(function (result, key) {
	        var value = ret[key];
	        if (Boolean(value) && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !Array.isArray(value)) {
	            // Sort object keys, not values
	            result[key] = keysSorter(value);
	        } else {
	            result[key] = value;
	        }
	        return result;
	    }, Object.create(null));
	}
	exports.extract = extract;
	exports.parse = parse;
	exports.stringify = function (obj, options) {
	    var defaults = {
	        encode: true,
	        strict: true,
	        arrayFormat: 'none'
	    };
	    options = _extends(defaults, options);
	    if (options.sort === false) {
	        options.sort = function () {};
	    }
	    var formatter = encoderForArrayFormat(options);
	    return obj ? Object.keys(obj).sort(options.sort).map(function (key) {
	        var value = obj[key];
	        if (value === undefined) {
	            return '';
	        }
	        if (value === null) {
	            return encode(key, options);
	        }
	        if (Array.isArray(value)) {
	            var result = [];
	            for (var _i = 0, _a = value.slice(); _i < _a.length; _i++) {
	                var value2 = _a[_i];
	                if (value2 === undefined) {
	                    continue;
	                }
	                result.push(formatter(key, value2, result.length));
	            }
	            return result.join('&');
	        }
	        return encode(key, options) + '=' + encode(value, options);
	    }).filter(function (x) {
	        return x.length > 0;
	    }).join('&') : '';
	};
	exports.parseUrl = function (input, options) {
	    return {
	        url: input.split('?')[0] || '',
	        query: parse(extract(input), options)
	    };
	};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (str) {
	  return encodeURIComponent(str).replace(/[!'()*]/g, function (x) {
	    return "%" + x.charCodeAt(0).toString(16).toUpperCase();
	  });
	};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var token = '%[a-f0-9]{2}';
	var singleMatcher = new RegExp(token, 'gi');
	var multiMatcher = new RegExp('(' + token + ')+', 'gi');
	function decodeComponents(components, split) {
	    try {
	        // Try to decode the entire string first
	        return decodeURIComponent(components.join(''));
	    } catch (err) {
	        // Do nothing
	    }
	    if (components.length === 1) {
	        return components;
	    }
	    split = split || 1;
	    // Split the array in 2 parts
	    var left = components.slice(0, split);
	    var right = components.slice(split);
	    return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
	}
	function decode(input) {
	    try {
	        return decodeURIComponent(input);
	    } catch (err) {
	        var tokens = input.match(singleMatcher);
	        for (var i = 1; i < tokens.length; i++) {
	            input = decodeComponents(tokens, i).join('');
	            tokens = input.match(singleMatcher);
	        }
	        return input;
	    }
	}
	function customDecodeURIComponent(input) {
	    // Keep track of all the replacements and prefill the map with the `BOM`
	    var replaceMap = {
	        '%FE%FF': '\uFFFD\uFFFD',
	        '%FF%FE': '\uFFFD\uFFFD'
	    };
	    var match = multiMatcher.exec(input);
	    while (match) {
	        try {
	            // Decode as big chunks as possible
	            replaceMap[match[0]] = decodeURIComponent(match[0]);
	        } catch (err) {
	            var result = decode(match[0]);
	            if (result !== match[0]) {
	                replaceMap[match[0]] = result;
	            }
	        }
	        match = multiMatcher.exec(input);
	    }
	    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	    replaceMap['%C2'] = '\uFFFD';
	    var entries = Object.keys(replaceMap);
	    for (var i = 0; i < entries.length; i++) {
	        // Replace all decoded components
	        var key = entries[i];
	        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	    }
	    return input;
	}
	module.exports = function (encodedURI) {
	    if (typeof encodedURI !== 'string') {
	        throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + (typeof encodedURI === 'undefined' ? 'undefined' : _typeof(encodedURI)) + '`');
	    }
	    try {
	        encodedURI = encodedURI.replace(/\+/g, ' ');
	        // Try the built in decoder first
	        return decodeURIComponent(encodedURI);
	    } catch (err) {
	        // Fallback to a more advanced decoder
	        return customDecodeURIComponent(encodedURI);
	    }
	};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function register(type, fn) {
	    if (window.attachEvent) {
	        window['e' + type + fn] = fn;
	        window[type + fn] = function () {
	            window['e' + type + fn](window.event);
	        };
	        window.attachEvent('on' + type, window[type + fn]);
	    } else {
	        window.addEventListener(type, fn, false);
	    }
	}
	exports["default"] = register;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var rng = __webpack_require__(7);
	var bytesToUuid = __webpack_require__(8);
	function v4(options, buf, offset) {
	    var i = buf && offset || 0;
	    if (typeof options == 'string') {
	        buf = options === 'binary' ? new Array(16) : null;
	        options = null;
	    }
	    options = options || {};
	    var rnds = options.random || (options.rng || rng)();
	    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	    rnds[6] = rnds[6] & 0x0f | 0x40;
	    rnds[8] = rnds[8] & 0x3f | 0x80;
	    // Copy bytes to buffer, if provided
	    if (buf) {
	        for (var ii = 0; ii < 16; ++ii) {
	            buf[i + ii] = rnds[ii];
	        }
	    }
	    return buf || bytesToUuid(rnds);
	}
	module.exports = v4;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
	var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && msCrypto.getRandomValues.bind(msCrypto);
	if (getRandomValues) {
	    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	    module.exports = function whatwgRNG() {
	        getRandomValues(rnds8);
	        return rnds8;
	    };
	} else {
	    // Math.random()-based (RNG)
	    //
	    // If all else fails, use Math.random().  It's fast, but is of unspecified
	    // quality.
	    var rnds = new Array(16);
	    module.exports = function mathRNG() {
	        for (var i = 0, r; i < 16; i++) {
	            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	            rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	        }
	        return rnds;
	    };
	}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	    byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	function bytesToUuid(buf, offset) {
	    var i = offset || 0;
	    var bth = byteToHex;
	    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
	}
	module.exports = bytesToUuid;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	var deviceUtils = __webpack_require__(10);
	/**
	 * 通过 user agent 获取对应 utm_source
	 */
	function getUtmSourceByUA() {
	    if (deviceUtils.isJianghuDaily()) {
	        return 'daily';
	    } else if (deviceUtils.isWeiXin()) {
	        return 'wx';
	    } else if (deviceUtils.isMWeibo()) {
	        return 'wb';
	    } else if (deviceUtils.isMQQ()) {
	        return 'qq';
	    }
	    return undefined;
	}
	exports["default"] = getUtmSourceByUA;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	/**
	 * 获取 UA
	 * @return {string}
	 */
	function getUserAgent() {
	    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	    return userAgent.toLowerCase();
	}
	/**
	 * 判断是否是手机
	 * @return {boolean}
	 */
	function isMobile() {
	    var userAgent = getUserAgent();
	    return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) ||
	        // eslint-disable-next-line
	        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([ -\/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([ \/])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([- ])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(userAgent.substr(0, 4))
	    );
	}
	/**
	 * 判断是否是 android 设备
	 * @return {boolean}
	 */
	function isAndroid() {
	    return (/android/i.test(getUserAgent())
	    );
	}
	/**
	 * 判断是否 ios 设备
	 * @return {boolean}
	 */
	function isIOS() {
	    return (/iPad|iPhone|iPod/i.test(getUserAgent()) && !window.MSStream
	    );
	}
	/**
	 * 是否是 微信 设备
	 * @return {boolean}
	 */
	function isWeiXin() {
	    var userAgent = getUserAgent();
	    return String(userAgent.match(/MicroMessenger/i)) === 'micromessenger';
	}
	/**
	 * 判断是否是 mobile 微信
	 * @return {boolean}
	 */
	function isMWeiXin() {
	    return isMobile() && isWeiXin();
	}
	/**
	 * 判断是否是手机qq
	 * @return {boolean}
	 */
	function isMQQ() {
	    var userAgent = getUserAgent();
	    var isIOSQQ = isIOS() && / QQ/i.test(userAgent);
	    var isAndroidQQ = isAndroid() && /MQQBrowser/i.test(navigator.userAgent) && /QQ/i.test(userAgent.split('mqqbrowser'));
	    return isMobile() && (isIOSQQ || isAndroidQQ);
	}
	/**
	 * 判断是否是手机微博 UA
	 * @return {boolean}
	 */
	function isMWeibo() {
	    var userAgent = getUserAgent();
	    return isMobile() && /(weibo)/.test(userAgent);
	}
	/**
	 * 判断是否是江湖 daily App
	 */
	function isJianghuDaily() {
	    var userAgent = getUserAgent();
	    return (/jianghudaily/i.test(userAgent)
	    );
	}
	exports.getUserAgent = getUserAgent;
	exports.isMobile = isMobile;
	exports.isAndroid = isAndroid;
	exports.isIOS = isIOS;
	exports.isWeiXin = isWeiXin;
	exports.isMWeiXin = isMWeiXin;
	exports.isMQQ = isMQQ;
	exports.isMWeibo = isMWeibo;
	exports.isJianghuDaily = isJianghuDaily;

/***/ })
/******/ ])
});
;
//# sourceMappingURL=st-report-sdk.js.map

/***/ }),

/***/ 1009:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initTrackPageLoad;
/**
 * 初始化pageLoad埋点函数
 * @param stReportSdk
 * @param report
 * @param getDiffRouteTime
 * @return {Function}
 */function initTrackPageLoad(stReportSdk,report,getDiffRouteTime){return function(){stReportSdk.trackPageLoad();report({eventName:'load_page_start',eventDescription:'页面加载',eventDataValue:{td_pl:getDiffRouteTime()}});};}

/***/ }),

/***/ 1010:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initTrackPageLeave;
/**
 * 初始化pageLeave函数
 * @param {Object} stReportSdk
 * @return {*}
 */function initTrackPageLeave(stReportSdk){return function(){stReportSdk.trackPageLeave();};}

/***/ }),

/***/ 1011:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZtServiceFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_constants_urls__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__business_service_factory__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_error_UnmountError__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__zt__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_error_ServiceResponseError__ = __webpack_require__(232);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ZtServiceFactory=function(_BusinessServiceFacto){_inherits(ZtServiceFactory,_BusinessServiceFacto);_createClass(ZtServiceFactory,null,[{key:'getDefaultInstance',/**
   * 获取默认实例方法, 用于非 component 中使用等情况
   * @return {*}
   */value:function getDefaultInstance(){if(!ZtServiceFactory._defaultServiceInstance){ZtServiceFactory._defaultServiceInstance=new ZtServiceFactory().createService();}return ZtServiceFactory._defaultServiceInstance;}}]);function ZtServiceFactory(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},checkIfComponentUnmount=_ref.checkIfComponentUnmount;_classCallCheck(this,ZtServiceFactory);var _this=_possibleConstructorReturn(this,(ZtServiceFactory.__proto__||Object.getPrototypeOf(ZtServiceFactory)).call(this,{/**
       * 队列映射
       * 详细请参考: https://gitlab.xsjcs.cn/xfe/xfe-iframe-application/blob/request-queue/parent/README.md
       * @type {{'jx3/ticket190728/create_order': string}}
       */queueMap:{/* 'jx3/ticket190728/create_order': 'jx3master' */},/**
       * 缓存时间, 默认: 100ms
       */optimizeUsingCache:100}));_this.handleCheckIfComponentUnmount(checkIfComponentUnmount);return _this;}/**
   * 处理检查组件是否被卸载
   * @private
   */_createClass(ZtServiceFactory,[{key:'handleCheckIfComponentUnmount',value:function handleCheckIfComponentUnmount(checkIfComponentUnmount){if(!checkIfComponentUnmount){return;}var action=function action(){if(checkIfComponentUnmount()===true){throw new __WEBPACK_IMPORTED_MODULE_2__src_error_UnmountError__["a" /* default */]();}};this.beforeRequests.push(action);this.afterRequestSuccessList.push(action);this.afterRequestErrorList.push(action);}/**
   * 创建服务
   */},{key:'createService',value:function createService(){return Object(__WEBPACK_IMPORTED_MODULE_3__zt__["a" /* default */])({jsonp:this.request.bind(this)},function(response){return Promise.reject(new __WEBPACK_IMPORTED_MODULE_4__src_error_ServiceResponseError__["a" /* default */](response));},__WEBPACK_IMPORTED_MODULE_0__src_constants_urls__["c" /* ZT_ROOT_ADDRESS */]);}}]);return ZtServiceFactory;}(__WEBPACK_IMPORTED_MODULE_1__business_service_factory__["a" /* default */]);

/***/ }),

/***/ 1012:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BusinessServiceFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_factory__ = __webpack_require__(1013);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BusinessServiceFactory=function(_ServiceFactory){_inherits(BusinessServiceFactory,_ServiceFactory);// eslint-disable-next-line
function BusinessServiceFactory(){var _ref;_classCallCheck(this,BusinessServiceFactory);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}// noinspection JSCheckFunctionSignatures
return _possibleConstructorReturn(this,(_ref=BusinessServiceFactory.__proto__||Object.getPrototypeOf(BusinessServiceFactory)).call.apply(_ref,[this].concat(args)));}return BusinessServiceFactory;}(__WEBPACK_IMPORTED_MODULE_0__service_factory__["a" /* default */]);

/***/ }),

/***/ 1013:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServiceFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfe_xoyo_queue__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xfe_xoyo_queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__xfe_xoyo_queue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfe_team_utils_src_jsonp_util__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_utils_wrap_after_service_promise__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_constants_urls__ = __webpack_require__(371);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ServiceFactory=function(){/**
   * @param {object} queueMap - 排队映射, 如: {'jx3/ticket190728/create_order': 'jx3master'}, 详细请参考: https://gitlab.xsjcs.cn/xfe/xfe-iframe-application/blob/request-queue/parent/README.md
   * @param {boolean} optimizeConcurrentSameRequest - 优化相同并发的请求
   * @param {number} optimizeUsingCache - 优化缓存时间, 默认 0, 单位毫秒, 设置大于0值启用, 用于确保同一个请求能够被正确被缓存和获取
   */function ServiceFactory(_ref){var queueMap=_ref.queueMap,optimizeConcurrentSameRequest=_ref.optimizeConcurrentSameRequest,_ref$optimizeUsingCac=_ref.optimizeUsingCache,optimizeUsingCache=_ref$optimizeUsingCac===undefined?0:_ref$optimizeUsingCac;_classCallCheck(this,ServiceFactory);this.queueMap=queueMap;this.beforeRequests=[];this.afterRequestSuccessList=[];this.afterRequestErrorList=[];this.optimizeConcurrentSameRequest=optimizeConcurrentSameRequest;optimizeConcurrentSameRequest&&(this.concurrentRequestQueue={});this.optimizeUsingCache=optimizeUsingCache;optimizeUsingCache&&(this.cache={});}/**
   * 获取排队映射 key 值
   * @private
   *
   * @param {string} url - 请求 url 地址
   * 如: 请求地址为 http://zt-ws.xoyo.com/zt/2019/08/test/get-user-info
   *
   * 当 this.queueMap = { 'test/get-user-info': 'jx3master' }
   * 返回: 'jx3master'
   *
   * @returns {string}
   */_createClass(ServiceFactory,[{key:'getQueueMapKey',value:function getQueueMapKey(url){var queueMap=this.queueMap||{};/**
     * 用于匹配 url 末段是否一致
     */return Object.keys(queueMap).find(function(mapUrl){var mapUrlLength=mapUrl.length;// 匹配命中最后字符串是否一致
return url.slice(-mapUrlLength)===mapUrl;});}/**
   * 请求
   * @public
   *
   * @param {string} rawUrl - 请求地址
   * @param {object} rawParams - 请求参数
   */},{key:'request',value:function request(rawUrl,rawParams){var _this=this;return this.handleCache(function(){return JSON.stringify({rawUrl:rawUrl,rawParams:rawParams});},_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref3,url,params,queueMapKey,requestPromise;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.interceptBeforeRequest({rawUrl:rawUrl,rawParams:rawParams});case 2:_ref3=_context2.sent;url=_ref3.url;params=_ref3.params;queueMapKey=_this.getQueueMapKey(url);requestPromise=void 0;if(queueMapKey){requestPromise=_this.makeQueueRequest(_this.queueMap[queueMapKey],params);}else{requestPromise=_this.makeNativeJsonpRequest(url,params);}return _context2.abrupt('return',requestPromise.then(function(responseValue){return _this.interceptAfterRequestSuccess({requestOptions:{url:url,params:params},responseValue:responseValue});}).catch(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(errorResponseValue){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.interceptAfterRequestError({requestOptions:{url:url,params:params},errorResponseValue:errorResponseValue});case 2:throw _context.sent;case 3:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref4.apply(this,arguments);};}()));case 9:case'end':return _context2.stop();}}},_callee2,_this);})));}/**
   * 创建缓存
   * @param {string} key - 缓存 key 值
   * @param {object} promise - 返回值 promise
   * @return {{response: object, createTime: number}}
   */},{key:'createCache',value:function createCache(key,promise){this.cache[key]={createTime:+new Date(),promise:promise};}/**
   * 缓存是否过期
   * @param {object} cache - 缓存
   * @return {boolean}
   */},{key:'isCacheExpired',value:function isCacheExpired(cache){return!(cache&&cache.createTime+this.optimizeUsingCache>+new Date());}/**
   * 获取缓存
   * @param key
   * @return {*}
   */},{key:'getCache',value:function getCache(key){return this.cache[key];}/**
   * 清除 cache
   * @param {string} key - 缓存 key 值
   */},{key:'clearCache',value:function clearCache(key){var cache=this.cache;cache[key]&&delete cache[key];}/**
   * 清除 cache
   */},{key:'clearAllCache',value:function clearAllCache(){this.cache={};}/**
   * 处理缓存
   * @param {Function} getKey - 获取 cache key
   * @param {Function} action - 实际请求
   * @return {any | Object | AuthenticatorResponse}
   */},{key:'handleCache',value:function handleCache(getKey,action){var _this2=this;if(this.optimizeUsingCache){var key=getKey();var cache=this.getCache(key);if(!this.isCacheExpired(cache)){return cache.promise;}this.clearCache(key);var promise=action();this.createCache(key,promise);promise.catch(function(){_this2.clearCache(key);});return promise;}return action();}/**
   * 处理并发请求, 确保同一个请求只能有一个 out going 请求
   * @param {Function} getKey - 请求唯一 key, 使用方法目的为了性能优化
   * @param {Function} action - 请求具体实现方法
   * @return {Promise}
   */},{key:'handleConcurrentRequest',value:function handleConcurrentRequest(getKey,action){var _this3=this;if(!this.optimizeConcurrentSameRequest){return action();}var key=getKey();var promise=this.concurrentRequestQueue[key];if(!promise){this.concurrentRequestQueue[key]=action();promise=this.concurrentRequestQueue[key];}else{return promise;}promise.finally(function(){delete _this3.concurrentRequestQueue[key];});return promise;}/**
   * 请求前拦截
   * @private
   *
   * @param {string} rawUrl - 请求地址
   * @param {object} rawParams - 请求参数
   */},{key:'interceptBeforeRequest',value:function interceptBeforeRequest(_ref5){var _this4=this;var rawUrl=_ref5.rawUrl,rawParams=_ref5.rawParams;return this.beforeRequests.reduce(function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(previousRequestOptions,beforeRequest){var nextRequestOptions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.t0=beforeRequest;_context3.next=3;return previousRequestOptions;case 3:_context3.t1=_context3.sent;_context3.next=6;return(0,_context3.t0)(_context3.t1);case 6:nextRequestOptions=_context3.sent;if(!(nextRequestOptions===undefined)){_context3.next=11;break;}return _context3.abrupt('return',previousRequestOptions);case 11:return _context3.abrupt('return',nextRequestOptions);case 12:case'end':return _context3.stop();}}},_callee3,_this4);}));return function(_x2,_x3){return _ref6.apply(this,arguments);};}(),Promise.resolve({url:rawUrl,params:rawParams}));}/**
   * 拦截请求成功后
   * @private
   *
   * @param {{rawUrl, object}} requestOptions - 请求参数, 开发者可以使用该参数进行相关拦截判断
   * @param {object} responseValue - 请求参数
   *
   * 如果拦截函数在这个过程中返回 undefined, 则判断为取消当次拦截, 使用上一次拦截返回的结果
   *
   * @returns {object} - 类型应等同 responseValue, 作为拦截后的返回值
   */},{key:'interceptAfterRequestSuccess',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(_ref7){var _this5=this;var requestOptions=_ref7.requestOptions,responseValue=_ref7.responseValue;var _ref9,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return this.afterRequestSuccessList.reduce(function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(previousAfterRequestSuccessParams,afterRequestSuccess){var nextRequestSuccessReturnResponseValue;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return afterRequestSuccess(previousAfterRequestSuccessParams);case 2:nextRequestSuccessReturnResponseValue=_context4.sent;if(!(nextRequestSuccessReturnResponseValue===undefined)){_context4.next=7;break;}return _context4.abrupt('return',previousAfterRequestSuccessParams);case 7:return _context4.abrupt('return',{requestOptions:requestOptions,responseValue:nextRequestSuccessReturnResponseValue});case 8:case'end':return _context4.stop();}}},_callee4,_this5);}));return function(_x5,_x6){return _ref10.apply(this,arguments);};}(),{requestOptions:requestOptions,responseValue:responseValue});case 2:_ref9=_context5.sent;result=_ref9.responseValue;return _context5.abrupt('return',result);case 5:case'end':return _context5.stop();}}},_callee5,this);}));function interceptAfterRequestSuccess(_x4){return _ref8.apply(this,arguments);}return interceptAfterRequestSuccess;}()/**
   * 拦截请求成功后, 注意: 当前方法设计暂时不支持逆转, 即请求认定为失败后无法逆转会成功
   * @private
   *
   * 如果拦截函数在这个过程中返回 undefined, 则判断为取消当次拦截, 使用上一次拦截返回的结果
   *
   * @param {{rawUrl, object}} requestOptions - 请求参数, 开发者可以使用该参数进行相关拦截判断
   * @param {object} errorResponseValue - 请求参数
   */},{key:'interceptAfterRequestError',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(_ref11){var _this6=this;var requestOptions=_ref11.requestOptions,errorResponseValue=_ref11.errorResponseValue;var _ref13,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return this.afterRequestErrorList.reduce(function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(previousAfterRequestErrorParams,afterRequestError){var nextRequestErrorReturnResponseValue;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return afterRequestError(previousAfterRequestErrorParams);case 2:nextRequestErrorReturnResponseValue=_context6.sent;if(!(nextRequestErrorReturnResponseValue===undefined)){_context6.next=7;break;}return _context6.abrupt('return',previousAfterRequestErrorParams);case 7:return _context6.abrupt('return',{requestOptions:requestOptions,responseValue:nextRequestErrorReturnResponseValue});case 8:case'end':return _context6.stop();}}},_callee6,_this6);}));return function(_x8,_x9){return _ref14.apply(this,arguments);};}(),{requestOptions:requestOptions,errorResponseValue:errorResponseValue});case 2:_ref13=_context7.sent;result=_ref13.errorResponseValue;return _context7.abrupt('return',result);case 5:case'end':return _context7.stop();}}},_callee7,this);}));function interceptAfterRequestError(_x7){return _ref12.apply(this,arguments);}return interceptAfterRequestError;}()/**
   * 请求排队请求
   * @private
   *
   * @param {string} scope - 排队 scope, 具体请阅读: https://gitlab.xsjcs.cn/xfe/xfe-iframe-application/blob/request-queue/parent/README.md
   * @param {object} params - 请求参数
   * @returns {Promise<any>}
   */},{key:'makeQueueRequest',value:function makeQueueRequest(scope,params){return Object(__WEBPACK_IMPORTED_MODULE_3__src_utils_wrap_after_service_promise__["a" /* default */])(function(){return __WEBPACK_IMPORTED_MODULE_1__xfe_xoyo_queue___default()({scope:scope,params:params,host:__WEBPACK_IMPORTED_MODULE_4__src_constants_urls__["c" /* ZT_ROOT_ADDRESS */],preAuth:{url:''}}).promise;},{requestOptions:params});}/**
   * 发起普通原始 jsonp 请求
   * @private
   *
   * @param {string} url - 请求地址
   * @param {object} params - 请求参数
   * @returns {Promise<ServiceResponse>}
   */},{key:'makeNativeJsonpRequest',value:function makeNativeJsonpRequest(url,params){return Object(__WEBPACK_IMPORTED_MODULE_2__xfe_team_utils_src_jsonp_util__["a" /* default */])(url,params);}/**
   * 创建服务
   * @protected
   */},{key:'createService',value:function createService(){throw new Error('please implement');}}]);return ServiceFactory;}();

/***/ }),

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.xoyoQueue=t():e.xoyoQueue=t()}(window,function(){return function(e){var t={};function n(o){if(t[o])return t[o].exports;var r=t[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,o){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)n.d(o,r,function(t){return e[t]}.bind(null,r));return o},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=3)}([function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.DATA_CLONE_ERROR=t.MESSAGE=t.REJECTED=t.FULFILLED=t.REPLY=t.CALL=t.HANDSHAKE_REPLY=t.HANDSHAKE=void 0;t.HANDSHAKE="handshake";t.HANDSHAKE_REPLY="handshake-reply";t.CALL="call";t.REPLY="reply";t.FULFILLED="fulfilled";t.REJECTED="rejected";t.MESSAGE="message";t.DATA_CLONE_ERROR="DataCloneError"},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.ERR_NO_IFRAME_SRC=t.ERR_NOT_IN_IFRAME=t.ERR_CONNECTION_TIMEOUT=t.ERR_CONNECTION_DESTROYED=void 0;t.ERR_CONNECTION_DESTROYED="ConnectionDestroyed";t.ERR_CONNECTION_TIMEOUT="ConnectionTimeout";t.ERR_NOT_IN_IFRAME="NotInIframe";t.ERR_NO_IFRAME_SRC="NoIframeSrc"},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.deserializeError=t.serializeError=void 0;t.serializeError=function(e){return{name:e.name,message:e.message,stack:e.stack}};t.deserializeError=function(e){var t=new Error;return Object.keys(e).forEach(function(n){return t[n]=e[n]}),t}},function(e,t,n){"use strict";var o=n(4);Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e){var t=e.scope,n=e.host,o=e.params,i=e.shouldUseProductionHost,s=e.preAuth,f=void 0===s?{}:s,E=e.iframeSrc,p=void 0===E?"//zhcdn01.xoyo.com/xassets/iframe/xoyo-queue/0.0.1-alpha/index.html":E,v=e.fadeTime,m=void 0===v?100:v,y=e.delayIframeDisplay,_=void 0===y?300:y,h=e.cancelQueue,O=void 0===h?l:h,R=e.shouldCancelQueueWhenInvokeCancel,g=void 0===R||R;if(!n){if("boolean"!=typeof i)throw new Error("当 host 值没有设置时, 请手动标识 <shouldUseProductionHost> 布尔字段, 当 shouldUseProductionHost = true 时为正式环境 host, false 时使用测试环境");n=d(i)}var S,T,w,P,A=function(e){var t=e.iframeSrc,n=document.createElement("iframe");return n.src=t,n.frameborder=0,n.style.backgroundColor="transparent",n.style.position="fixed",n.style.top="0",n.style.left="0",n.style.right="0",n.style.bottom="0",n.style.width="100%",n.style.height="100%",n.style.transition="opacity 300ms",n.style.opacity="0",n.style.zIndex="10010",n.style.border="0",n.style.display="none",n.allowtransparency="true",n}({iframeSrc:p}),b=(0,r.default)({iframe:A}),N=new Promise(function(e,r){S=r,function(e){var t=e.url,n=e.disableCheck;if(t){if(!n&&(t.indexOf("?")>-1||t.indexOf("#")>-1))throw new Error("当前 pre-auth url 不允许携带 ? 或 #, 推荐格式: https://xxx.com/path/api");return u(t,{callback:c})}return Promise.resolve()}(f).then(function(){return b.promise.then(function(e){return e.onload().then(function(){if(!w)return P=function(e){var t=e.iframe,n=e.fadeTime,o=e.delayIframeDisplay;return setTimeout(function(){t.style.display="block",(0,a.fadeIn)(t,n)},o)}({iframe:A,fadeTime:m,delayIframeDisplay:_}),e.startQueue({scope:t,host:n,params:o})})})}).then(e,r)});document.body.appendChild(A),N.finally(function(){!function(e){var t=e.iframe,n=e.fadeTime,o=e.animate;(void 0===o||o)&&(0,a.fadeOut)(t,n);setTimeout(function(){t&&document.body.removeChild(t)},n+60)}({iframe:A,fadeTime:m,animate:T})});var I=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=e.fadeOutAnimation,o=e.isSendBeaconDisable;return w=!0,T=n,clearTimeout(void 0),clearTimeout(P),S({type:"cancel"}),g?Promise.resolve(O({shouldUseProductionHost:i,scope:t,isSendBeaconDisable:o})):Promise.resolve()};return N.cancel=I,{promise:N,cancel:I}},t.cancelQueue=void 0;var r=o(n(5)),a=n(12),i=n(13),c="__XOYO_QUEUE_JSONP_NOOP__";function u(e,t){var n=t?"?".concat(function(e){var t=[];for(var n in e)e.hasOwnProperty(n)&&t.push("".concat(encodeURIComponent(n),"=").concat(encodeURIComponent(e[n])));return t.join("&")}(t)):"";return new Promise(function(t,o){var r=document.createElement("script");r.onload=t,r.onerror=o,r.src=e+n,document.head.appendChild(r)})}function s(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};arguments.length>2&&arguments[2];return navigator.sendBeacon?navigator.sendBeacon(e,JSON.stringify(t)):u(e,{callback:c,scope:scope})}function d(e){return e?i.QUEUE_HOST_API:i.TEST_QUEUE_HOST_API}function l(e){var t=e.scope,n=e.shouldUseProductionHost,o=e.isSendBeaconDisable;return s("".concat(d(n),"/queueproxy/"),{scope:t},o)}window[c]=function(e){return e};var f=l;t.cancelQueue=f},function(e,t,n){"use strict";e.exports=function(e){return e&&e.__esModule?e:{default:e}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(0),r=n(1),a=d(n(6)),i=d(n(7)),c=d(n(8)),u=d(n(9)),s=d(n(10));function d(e){return e&&e.__esModule?e:{default:e}}t.default=function(e){var t=e.iframe,n=e.methods,d=void 0===n?{}:n,l=e.childOrigin,f=e.timeout,E=e.debug,p=(0,c.default)(E),v=window,m=(0,a.default)(),y=m.destroy,_=m.onDestroy;if(!l){if(!t.src&&!t.srcdoc){var h=new Error("Iframe must have src or srcdoc property defined.");throw h.code=r.ERR_NO_IFRAME_SRC,h}l=(0,i.default)(t.src)}var O="null"===l?"*":l;return{promise:new Promise(function(e,n){var a;void 0!==f&&(a=setTimeout(function(){var e=new Error("Connection to child timed out after ".concat(f,"ms"));e.code=r.ERR_CONNECTION_TIMEOUT,n(e),y()},f));var i,c,E={},m=function(n){var r=t.contentWindow;if(n.source===r&&n.data.penpal===o.HANDSHAKE)if(n.origin===l){p("Parent: Received handshake, sending reply"),n.source.postMessage({penpal:o.HANDSHAKE_REPLY,methodNames:Object.keys(d)},O);var f={localName:"Parent",local:v,remote:r,originForSending:O,originForReceiving:l};c&&c(),c=(0,u.default)(f,d,p),_(c),i&&i.forEach(function(e){delete E[e]}),i=n.data.methodNames;var m=(0,s.default)(E,f,i,y,p);_(m),clearTimeout(a),e(E)}else p("Parent received handshake from origin ".concat(n.origin," which did not match expected origin ").concat(l))};v.addEventListener(o.MESSAGE,m),p("Parent: Awaiting handshake");var h=setInterval(function(){document.contains(t)||(clearInterval(h),y())},6e4);_(function(){v.removeEventListener(o.MESSAGE,m),clearInterval(h);var e=new Error("Connection destroyed");e.code=r.ERR_CONNECTION_DESTROYED,n(e)})}),destroy:y}},e.exports=t.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default=function(){var e=[],t=!1;return{destroy:function(){t=!0,e.forEach(function(e){e()})},onDestroy:function(n){t?n():e.push(n)}}},e.exports=t.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o={"http:":"80","https:":"443"},r=/^(https?:)?\/\/([^\/:]+)?(:(\d+))?/,a=["file:","data:"];t.default=function(e){if(e&&a.find(function(t){return e.startsWith(t)}))return"null";var t,n,i,c=document.location,u=r.exec(e);u?(t=u[1]?u[1]:c.protocol,n=u[2],i=u[4]):(t=c.protocol,n=c.hostname,i=c.port);var s=i&&i!==o[t]?":".concat(i):"";return"".concat(t,"//").concat(n).concat(s)},e.exports=t.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default=function(e){return function(){if(e){for(var t,n=arguments.length,o=new Array(n),r=0;r<n;r++)o[r]=arguments[r];(t=console).log.apply(t,["[Penpal]"].concat(o))}}},e.exports=t.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(0),r=n(2);t.default=function(e,t,n){var a=e.localName,i=e.local,c=e.remote,u=e.originForSending,s=e.originForReceiving,d=!1;n("".concat(a,": Connecting call receiver"));var l=function(e){if(e.source===c&&e.data.penpal===o.CALL)if(e.origin===s){var i=e.data,l=i.methodName,f=i.args,E=i.id;n("".concat(a,": Received ").concat(l,"() call"));var p=function(e){return function(t){if(n("".concat(a,": Sending ").concat(l,"() reply")),d)n("".concat(a,": Unable to send ").concat(l,"() reply due to destroyed connection"));else{var i={penpal:o.REPLY,id:E,resolution:e,returnValue:t};e===o.REJECTED&&t instanceof Error&&(i.returnValue=(0,r.serializeError)(t),i.returnValueIsError=!0);try{c.postMessage(i,u)}catch(e){throw e.name===o.DATA_CLONE_ERROR&&c.postMessage({penpal:o.REPLY,id:E,resolution:o.REJECTED,returnValue:(0,r.serializeError)(e),returnValueIsError:!0},u),e}}}};new Promise(function(e){return e(t[l].apply(t,f))}).then(p(o.FULFILLED),p(o.REJECTED))}else n("".concat(a," received message from origin ").concat(e.origin," which did not match expected origin ").concat(s))};return i.addEventListener(o.MESSAGE,l),function(){d=!0,i.removeEventListener(o.MESSAGE,l)}},e.exports=t.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o,r=n(0),a=n(1),i=(o=n(11))&&o.__esModule?o:{default:o},c=n(2);t.default=function(e,t,n,o,u){var s=t.localName,d=t.local,l=t.remote,f=t.originForSending,E=t.originForReceiving,p=!1;u("".concat(s,": Connecting call sender"));return n.reduce(function(e,t){return e[t]=function(e){return function(){for(var t=arguments.length,n=new Array(t),v=0;v<t;v++)n[v]=arguments[v];var m;u("".concat(s,": Sending ").concat(e,"() call"));try{l.closed&&(m=!0)}catch(e){m=!0}if(m&&o(),p){var y=new Error("Unable to send ".concat(e,"() call due ")+"to destroyed connection");throw y.code=a.ERR_CONNECTION_DESTROYED,y}return new Promise(function(t,o){var a=(0,i.default)();d.addEventListener(r.MESSAGE,function n(i){if(i.source===l&&i.data.penpal===r.REPLY&&i.data.id===a)if(i.origin===E){u("".concat(s,": Received ").concat(e,"() reply")),d.removeEventListener(r.MESSAGE,n);var f=i.data.returnValue;i.data.returnValueIsError&&(f=(0,c.deserializeError)(f)),(i.data.resolution===r.FULFILLED?t:o)(f)}else u("".concat(s," received message from origin ").concat(i.origin," which did not match expected origin ").concat(E))}),l.postMessage({penpal:r.CALL,id:a,methodName:e,args:n},f)})}}(t),e},e),function(){p=!0}},e.exports=t.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=0;t.default=function(){return++o},e.exports=t.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.fadeIn=function(e,t){e.style.opacity=0;var n=+new Date;!function r(){e.style.opacity=+e.style.opacity+(new Date-n)/t,n=+new Date,+e.style.opacity<1&&(o?o(r):setTimeout(r,16))}()},t.fadeOut=function(e,t){e.style.opacity=1;var n=+new Date;!function r(){e.style.opacity=+e.style.opacity-(new Date-n)/t,n=+new Date,+e.style.opacity>=0&&(o?o(r):setTimeout(r,16))}()};var o=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.QUEUE_HOST_API=t.TEST_QUEUE_HOST_API=void 0;t.TEST_QUEUE_HOST_API="//test-ws.xoyo.com";t.QUEUE_HOST_API="//ws.xoyo.com"}])});

/***/ }),

/***/ 1015:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp_promise__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsonp_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__query_string_util__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_ServiceResponse__ = __webpack_require__(1016);
var _this=this;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/** @module jsonp-util *//**
 * jsonp 请求
 * @param {string} url - 请求地址
 * @param {object} params - 请求参数
 * @param {bool} isMockOn - 是否使用mock
 * @returns {Promise<ServiceResponse>}
 */function jsonp(url){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var isMockOn=arguments[2];var requestOptions={url:url,params:params};/**
   * 当网络离线时, 直接返回离线异常
   */if(navigator&&navigator.onLine===false){return Promise.reject(new __WEBPACK_IMPORTED_MODULE_3__models_ServiceResponse__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3__models_ServiceResponse__["a" /* default */].ClientError.Offline));}try{// 使用 __ts__ 确保请求不会被各种原因缓存
params=_extends({},{__ts__:+new Date()},params);var promise=__WEBPACK_IMPORTED_MODULE_1_jsonp_promise___default()(url+'?'+__WEBPACK_IMPORTED_MODULE_2__query_string_util__["a" /* default */].stringify(params),{// 明确命名空间
prefix:'__xfe',// 保证在 mock 开启时不超时
timeout:isMockOn?9999999:undefined}).promise;return promise.then(function(response){return new __WEBPACK_IMPORTED_MODULE_3__models_ServiceResponse__["a" /* default */](_extends({},response));}).catch(function(error){if(__WEBPACK_IMPORTED_MODULE_3__models_ServiceResponse__["a" /* default */].isApiResponseShape(error)){// noinspection JSCheckFunctionSignatures
error=new __WEBPACK_IMPORTED_MODULE_3__models_ServiceResponse__["a" /* default */](_extends({},error,{requestOptions:requestOptions}));}throw error;});}catch(err){if(err.message==='Timeout'){return Promise.reject(new __WEBPACK_IMPORTED_MODULE_3__models_ServiceResponse__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3__models_ServiceResponse__["a" /* default */].ClientError.Timeout));}throw err;}}jsonp.customWrap=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url,params){var serviceResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return jsonp(url,params);case 2:serviceResponse=_context.sent;if(!serviceResponse.isSuccess()){_context.next=7;break;}return _context.abrupt('return',serviceResponse.data);case 7:return _context.abrupt('return',Promise.reject(serviceResponse));case 8:case'end':return _context.stop();}}},_callee,_this);}));return function(_x2,_x3){return _ref.apply(this,arguments);};}();/* harmony default export */ __webpack_exports__["a"] = (jsonp);

/***/ }),

/***/ 1016:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServiceResponse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_schema_validator__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_schema_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_schema_validator__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/**
 * 服务端返回结构体
 */var ServiceResponse=(_temp=_class=function(){_createClass(ServiceResponse,null,[{key:'isApiResponseShape',/**
   * 判断是不是 api 返回的 response 结构
   * @param {object} data - 判断对象数据
   * @return {boolean}
   */value:function isApiResponseShape(data){var apiResponseSchema={code:{type:Number,required:true},data:{type:Object,required:true},message:{type:String,required:true}};var validator=new __WEBPACK_IMPORTED_MODULE_0_schema_validator___default.a(apiResponseSchema);var _validator$check=validator.check(data),_error=_validator$check._error;return!_error;}/**
   * @type {number} code - 错误码
   *//**
   * @type {number} status - 错误码
   *//**
   * @type {object} data - 服务端返回具体数据
   *//**
   * @type {string} msg - 错误信息
   *//**
   * @type {string} message - 错误信息
   *//**
   * @type {object} [requestOptions] - 请求配置, 可用于 resend 重试请求
   */}]);/**
   * @param {string} message - 提示信息, 通常只会在异常的时候返回
   * @param {number|string} code - 错误码
   * @param {object} [data] - 数据主体
   * @param {object} [requestOptions] - 请求配置, 可用于 resend 重试请求
   */function ServiceResponse(_ref){var message=_ref.message,code=_ref.code,_ref$data=_ref.data,data=_ref$data===undefined?{}:_ref$data,requestOptions=_ref.requestOptions;_classCallCheck(this,ServiceResponse);this.message=message;this.msg=message;this.code=Number(code);this.status=this.code;this.data=data;this.requestOptions=requestOptions;}_createClass(ServiceResponse,[{key:'isSuccess',value:function isSuccess(){return this.code===1;}},{key:'isError',value:function isError(){return!this.isSuccess();}}]);return ServiceResponse;}(),_class.ClientError={Offline:{code:'c:-1',message:'没有网络哦'},Timeout:{code:'c:-2',message:'网络超时了'}},_temp);

/***/ }),

/***/ 1017:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_error_ServiceResponseError__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_models_ServiceResponse__ = __webpack_require__(1018);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/* harmony default export */ __webpack_exports__["a"] = ((function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(requestFn,_ref){var useRawResponse=_ref.useRawResponse,requestOptions=_ref.requestOptions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(navigator&&navigator.onLine===false)){_context.next=2;break;}throw new __WEBPACK_IMPORTED_MODULE_1__src_error_ServiceResponseError__["a" /* default */](new __WEBPACK_IMPORTED_MODULE_2__src_models_ServiceResponse__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2__src_models_ServiceResponse__["a" /* default */].ClientError.Offline));case 2:return _context.abrupt('return',requestFn().then(function(response){if(useRawResponse){return response;}return new __WEBPACK_IMPORTED_MODULE_2__src_models_ServiceResponse__["a" /* default */](response);}).catch(function(error){if(error.message==='Timeout'){throw new __WEBPACK_IMPORTED_MODULE_1__src_error_ServiceResponseError__["a" /* default */](new __WEBPACK_IMPORTED_MODULE_2__src_models_ServiceResponse__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2__src_models_ServiceResponse__["a" /* default */].ClientError.Timeout));}if(__WEBPACK_IMPORTED_MODULE_2__src_models_ServiceResponse__["a" /* default */].isApiResponseShape(error)){// noinspection JSCheckFunctionSignatures
error=new __WEBPACK_IMPORTED_MODULE_2__src_models_ServiceResponse__["a" /* default */](_extends({},error,{requestOptions:requestOptions}));throw new __WEBPACK_IMPORTED_MODULE_1__src_error_ServiceResponseError__["a" /* default */](error);}throw error;}));case 3:case'end':return _context.stop();}}},_callee,this);}));function wrapAfterServicePromise(_x,_x2){return _ref2.apply(this,arguments);}return wrapAfterServicePromise;})());

/***/ }),

/***/ 1018:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServiceResponse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_schema_validator__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_schema_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_schema_validator__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/**
 * 服务端返回结构体
 */var ServiceResponse=(_temp=_class=function(){_createClass(ServiceResponse,null,[{key:'isApiResponseShape',/**
   * 判断是不是 api 返回的 response 结构
   * @param {object} data - 判断对象数据
   * @return {boolean}
   */value:function isApiResponseShape(data){var apiResponseSchema={code:{type:Number,required:true},data:{type:Object,required:true},message:{type:String,required:true}};var validator=new __WEBPACK_IMPORTED_MODULE_0_schema_validator___default.a(apiResponseSchema);var _validator$check=validator.check(data),_error=_validator$check._error;return!_error;}/**
   * @type {number} code - 错误码
   *//**
   * @type {number} status - 错误码
   *//**
   * @type {object} data - 服务端返回具体数据
   *//**
   * @type {string} msg - 错误信息
   *//**
   * @type {string} message - 错误信息
   *//**
   * @type {object} [requestOptions] - 请求配置, 可用于 resend 重试请求
   */}]);/**
   * @param {string} message - 提示信息, 通常只会在异常的时候返回
   * @param {number|string} code - 错误码
   * @param {object} [data] - 数据主体
   * @param {object} [requestOptions] - 请求配置, 可用于 resend 重试请求
   */function ServiceResponse(_ref){var message=_ref.message,code=_ref.code,_ref$data=_ref.data,data=_ref$data===undefined?{}:_ref$data,requestOptions=_ref.requestOptions;_classCallCheck(this,ServiceResponse);this.message=message;this.msg=message;this.code=Number(code);this.status=this.code;this.data=data;this.requestOptions=requestOptions;}_createClass(ServiceResponse,[{key:'isSuccess',value:function isSuccess(){return this.code===1;}},{key:'isError',value:function isError(){return!this.isSuccess();}}]);return ServiceResponse;}(),_class.ClientError={Offline:{code:'c:-1',message:'没有网络哦'},Timeout:{code:'c:-2',message:'网络超时了'}},_temp);

/***/ }),

/***/ 1019:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(request,reject,rootAddress){var service={};/**
		获取全局配置
		请求方法: GET, POST
		请求示例: http://<domain>/jx/modifyphone/get_config

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "is_bind_phone": true,
		        "bind_phone": "159***248",
		        "session_id": "kL2aoCT2B3DNFJ0pSX8mhnkPj0wblVJ2ETVHd6Qh",
		        "request_id": "6158d7903ae9496d6fcbf560d0df2c1c7ac38af0"
		    }
		}
		*/service.getConfig=function(){return request.jsonp(rootAddress+'/jx/modifyphone/get_config',{}).then(function(response){if(response.status===1/* 成功 */){/**
        {
          "data{}": {
            "bind_phone": "绑定手机号(加密)",
            "is_bind_phone": "是否有绑定手机"
          }
        }
        		*/return response.data;}/**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-12801",
        "description": "调用活动平台接口失败"
      }, {
        "code": "-12802",
        "description": "系统错误"
      }, {
        "code": "-12803",
        "description": "参数错误"
      }, {
        "code": "-12804",
        "description": "编码错误"
      }, {
        "code": "-12805",
        "description": "签名错误"
      }, {
        "code": "-12806",
        "description": "时间戳错误"
      }, {
        "code": "-12807",
        "description": "登录账号不存在"
      }, {
        "code": "-12808",
        "description": "玩家账号不存在"
      }, {
        "code": "-12809",
        "description": "区不存在"
      }, {
        "code": "-12810",
        "description": "流水号重复"
      }, {
        "code": "-12811",
        "description": "没有资格领取时间奖励"
      }, {
        "code": "-12812",
        "description": "已领取时间奖励"
      }, {
        "code": "-12813",
        "description": "未知错误"
      }, {
        "code": "-12814",
        "description": "游戏或者区服不存在"
      }, {
        "code": "-12815",
        "description": "未绑定手机号"
      }, {
        "code": "-12816",
        "description": "账号未登录"
      }, {
        "code": "-12817",
        "description": "操作失败"
      }, {
        "code": "-12818",
        "description": "账号已存在"
      }, {
        "code": "-12819",
        "description": "激活码不存在"
      }, {
        "code": "-12820",
        "description": "激活码已使用"
      }, {
        "code": "-12821",
        "description": "需要激活码"
      }, {
        "code": "-12822",
        "description": "游戏已关闭激活码激活玩家账号开关"
      }, {
        "code": "-12823",
        "description": "验证oldValue失败"
      }, {
        "code": "-12824",
        "description": "key不存在"
      }, {
        "code": "-12825",
        "description": "未知key类型"
      }, {
        "code": "-12826",
        "description": "网关名不存在"
      }, {
        "code": "-12827",
        "description": "大区内的账号不存在"
      }, {
        "code": "-12828",
        "description": "激活时间超时"
      }, {
        "code": "-12829",
        "description": "账号已申请过退款"
      }, {
        "code": "-12830",
        "description": "在线时长超时"
      }, {
        "code": "-12831",
        "description": "大区充值金额不足要求"
      }, {
        "code": "-12832",
        "description": "账号已是收费状态"
      }, {
        "code": "-12833",
        "description": "账号被冻结"
      }, {
        "code": "-12834",
        "description": "账号不允许充值"
      }, {
        "code": "-12835",
        "description": "查询账号数量超过16个"
      }, {
        "code": "-12836",
        "description": "账号不合法"
      }, {
        "code": "-12837",
        "description": "起始时间不能等于或晚于结束时间"
      }, {
        "code": "-12838",
        "description": "Paylog库访问异常"
      }, {
        "code": "-12839",
        "description": "用户没有可退款订单"
      }, {
        "code": "-12840",
        "description": "账号或者密码错误"
      }]
      		*/return reject(response);});};/**
		验证真实姓名和身份证是否一致
		请求方法: GET, POST
		请求示例: http://<domain>/jx/modifyphone/verify_identify?real_name=谭健成&id_num_last_six_num=318038

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "token": "5f856b9d51dc5",
		        "session_id": "uAq4uVV5yuHLIL8SjxG9J4JDa3jDkAmlKqCJyRFa",
		        "request_id": "fa496aaec7d1b42feac9dcd6ecba267dc8b539c6"
		    }
		}
		*/service.verifyIdentify=function(real_name,id_num_last_six_num){return request.jsonp(rootAddress+'/jx/modifyphone/verify_identify',{real_name:real_name/*  真实姓名 */,id_num_last_six_num:id_num_last_six_num/*  身份证后6位 */}).then(function(response){if(response.status===1/* 成功 */){/**
        {
          "data{}": {
            "token": "校验token（用于bind_new_phone_with_tokenA接口）"
          }
        }
        		*/return response.data;}/**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10113",
        "description": "姓名为空"
      }, {
        "code": "-10114",
        "description": "姓名格式不合法"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-12801",
        "description": "调用活动平台接口失败"
      }, {
        "code": "-12802",
        "description": "系统错误"
      }, {
        "code": "-12803",
        "description": "参数错误"
      }, {
        "code": "-12804",
        "description": "编码错误"
      }, {
        "code": "-12805",
        "description": "签名错误"
      }, {
        "code": "-12806",
        "description": "时间戳错误"
      }, {
        "code": "-12807",
        "description": "登录账号不存在"
      }, {
        "code": "-12808",
        "description": "玩家账号不存在"
      }, {
        "code": "-12809",
        "description": "区不存在"
      }, {
        "code": "-12810",
        "description": "流水号重复"
      }, {
        "code": "-12811",
        "description": "没有资格领取时间奖励"
      }, {
        "code": "-12812",
        "description": "已领取时间奖励"
      }, {
        "code": "-12813",
        "description": "未知错误"
      }, {
        "code": "-12814",
        "description": "游戏或者区服不存在"
      }, {
        "code": "-12815",
        "description": "未绑定手机号"
      }, {
        "code": "-12816",
        "description": "账号未登录"
      }, {
        "code": "-12817",
        "description": "操作失败"
      }, {
        "code": "-12818",
        "description": "账号已存在"
      }, {
        "code": "-12819",
        "description": "激活码不存在"
      }, {
        "code": "-12820",
        "description": "激活码已使用"
      }, {
        "code": "-12821",
        "description": "需要激活码"
      }, {
        "code": "-12822",
        "description": "游戏已关闭激活码激活玩家账号开关"
      }, {
        "code": "-12823",
        "description": "验证oldValue失败"
      }, {
        "code": "-12824",
        "description": "key不存在"
      }, {
        "code": "-12825",
        "description": "未知key类型"
      }, {
        "code": "-12826",
        "description": "网关名不存在"
      }, {
        "code": "-12827",
        "description": "大区内的账号不存在"
      }, {
        "code": "-12828",
        "description": "激活时间超时"
      }, {
        "code": "-12829",
        "description": "账号已申请过退款"
      }, {
        "code": "-12830",
        "description": "在线时长超时"
      }, {
        "code": "-12831",
        "description": "大区充值金额不足要求"
      }, {
        "code": "-12832",
        "description": "账号已是收费状态"
      }, {
        "code": "-12833",
        "description": "账号被冻结"
      }, {
        "code": "-12834",
        "description": "账号不允许充值"
      }, {
        "code": "-12835",
        "description": "查询账号数量超过16个"
      }, {
        "code": "-12836",
        "description": "账号不合法"
      }, {
        "code": "-12837",
        "description": "起始时间不能等于或晚于结束时间"
      }, {
        "code": "-12838",
        "description": "Paylog库访问异常"
      }, {
        "code": "-12839",
        "description": "用户没有可退款订单"
      }, {
        "code": "-12840",
        "description": "账号或者密码错误"
      }, {
        "code": "-20101",
        "description": "请填写真实姓名"
      }, {
        "code": "-20102",
        "description": "请填写身份证后六位"
      }, {
        "code": "-20201",
        "description": "该通行证没有绑定身份证"
      }, {
        "code": "-20202",
        "description": "该通行证没有真实姓名相关信息"
      }, {
        "code": "-20203",
        "description": "真实姓名不匹配"
      }, {
        "code": "-20204",
        "description": "身份证后6位不匹配"
      }]
      		*/return reject(response);});};/**
		get_phone_code
		请求方法: GET, POST
		请求示例:
		响应示例:
		*/service.getPhoneCode=function(params){return request.jsonp(rootAddress+'/jx/modifyphone/get_phone_code',{phone:params.phone,check_old_phone:params.checkOldPhone,captcha:'',geetest_challenge:params.geetest_challenge,geetest_seccode:params.geetest_seccode,geetest_validate:params.geetest_validate}).then(function(response){if(response.status===1/* 成功 */){/**
        {
          "data{}": []
        }
        		*/return response.data;}/**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10303",
        "description": "短信内容为空"
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10308",
        "description": "短信验证码发送数量达到每日上限"
      }, {
        "code": "-10309",
        "description": "短信验证码发送频率太快"
      }, {
        "code": "-10601",
        "description": "图片验证码为空"
      }, {
        "code": "-10602",
        "description": "图片验证码错误"
      }, {
        "code": "-10603",
        "description": "验证失败"
      }, {
        "code": "-10604",
        "description": "图片验证码参数错误"
      }]
      		*/return reject(response);});};/**
		绑定新手机(用户没有绑定过手机的情况)
		请求方法: GET, POST
		请求示例: http://<domain>/jx/modifyphone/bind_new_phone_with_token?token=5f85717abc92c&phone=15919175248&code=1234

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "session_id": "ognZGnrvkki8NdC2ogl0CZPhUtNXiP7imxbvGIWs",
		        "request_id": "667816421d5f72f2593f738b9694657437b71a81"
		    }
		}
		*/service.bindNewPhoneWithToken=function(token,phone,code){return request.jsonp(rootAddress+'/jx/modifyphone/bind_new_phone_with_token',{token:token/*  校验token */,phone:phone/*  手机号码 */,code:code/*  手机验证码 */}).then(function(response){if(response.status===1/* 成功 */){/**
        {
          "data{}": []
        }
        		*/return response.data;}/**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10310",
        "description": "短信验证码不存在"
      }, {
        "code": "-10311",
        "description": "短信验证码为空"
      }, {
        "code": "-10312",
        "description": "短信验证码错误"
      }, {
        "code": "-10313",
        "description": "短信验证码超过有效期"
      }, {
        "code": "-10314",
        "description": "短信验证码已失效"
      }, {
        "code": "-12801",
        "description": "调用活动平台接口失败"
      }, {
        "code": "-12802",
        "description": "系统错误"
      }, {
        "code": "-12803",
        "description": "参数错误"
      }, {
        "code": "-12804",
        "description": "编码错误"
      }, {
        "code": "-12805",
        "description": "签名错误"
      }, {
        "code": "-12806",
        "description": "时间戳错误"
      }, {
        "code": "-12807",
        "description": "登录账号不存在"
      }, {
        "code": "-12808",
        "description": "玩家账号不存在"
      }, {
        "code": "-12809",
        "description": "区不存在"
      }, {
        "code": "-12810",
        "description": "流水号重复"
      }, {
        "code": "-12811",
        "description": "没有资格领取时间奖励"
      }, {
        "code": "-12812",
        "description": "已领取时间奖励"
      }, {
        "code": "-12813",
        "description": "未知错误"
      }, {
        "code": "-12814",
        "description": "游戏或者区服不存在"
      }, {
        "code": "-12815",
        "description": "未绑定手机号"
      }, {
        "code": "-12816",
        "description": "账号未登录"
      }, {
        "code": "-12817",
        "description": "操作失败"
      }, {
        "code": "-12818",
        "description": "账号已存在"
      }, {
        "code": "-12819",
        "description": "激活码不存在"
      }, {
        "code": "-12820",
        "description": "激活码已使用"
      }, {
        "code": "-12821",
        "description": "需要激活码"
      }, {
        "code": "-12822",
        "description": "游戏已关闭激活码激活玩家账号开关"
      }, {
        "code": "-12823",
        "description": "验证oldValue失败"
      }, {
        "code": "-12824",
        "description": "key不存在"
      }, {
        "code": "-12825",
        "description": "未知key类型"
      }, {
        "code": "-12826",
        "description": "网关名不存在"
      }, {
        "code": "-12827",
        "description": "大区内的账号不存在"
      }, {
        "code": "-12828",
        "description": "激活时间超时"
      }, {
        "code": "-12829",
        "description": "账号已申请过退款"
      }, {
        "code": "-12830",
        "description": "在线时长超时"
      }, {
        "code": "-12831",
        "description": "大区充值金额不足要求"
      }, {
        "code": "-12832",
        "description": "账号已是收费状态"
      }, {
        "code": "-12833",
        "description": "账号被冻结"
      }, {
        "code": "-12834",
        "description": "账号不允许充值"
      }, {
        "code": "-12835",
        "description": "查询账号数量超过16个"
      }, {
        "code": "-12836",
        "description": "账号不合法"
      }, {
        "code": "-12837",
        "description": "起始时间不能等于或晚于结束时间"
      }, {
        "code": "-12838",
        "description": "Paylog库访问异常"
      }, {
        "code": "-12839",
        "description": "用户没有可退款订单"
      }, {
        "code": "-12840",
        "description": "账号或者密码错误"
      }, {
        "code": "-20301",
        "description": "token为空"
      }, {
        "code": "-20302",
        "description": "短信验证码为空"
      }, {
        "code": "-20303",
        "description": "token无效"
      }]
      		*/return reject(response);});};/**
		验证原手机
		请求方法: GET, POST
		请求示例: http://<domain>/jx/modifyphone/verify_old_phone?phone=15919175249&code=1234

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "session_id": "iE3XHdyLK8iK8cJmT008hKKcx3SOXnnP0Bokrl0u",
		        "request_id": "9e1e96787ad27f24ebc4dfa3b95aaced73bd835d"
		    }
		}
		*/service.verifyOldPhone=function(phone,code){return request.jsonp(rootAddress+'/jx/modifyphone/verify_old_phone',{phone:phone/*  新手机号码 */,code:code/*  手机验证码 */}).then(function(response){if(response.status===1/* 成功 */){/**
        {
          "data{}": []
        }
        		*/return response.data;}/**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10303",
        "description": "短信内容为空"
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10310",
        "description": "短信验证码不存在"
      }, {
        "code": "-10311",
        "description": "短信验证码为空"
      }, {
        "code": "-10312",
        "description": "短信验证码错误"
      }, {
        "code": "-10313",
        "description": "短信验证码超过有效期"
      }, {
        "code": "-10314",
        "description": "短信验证码已失效"
      }, {
        "code": "-12801",
        "description": "调用活动平台接口失败"
      }, {
        "code": "-12802",
        "description": "系统错误"
      }, {
        "code": "-12803",
        "description": "参数错误"
      }, {
        "code": "-12804",
        "description": "编码错误"
      }, {
        "code": "-12805",
        "description": "签名错误"
      }, {
        "code": "-12806",
        "description": "时间戳错误"
      }, {
        "code": "-12807",
        "description": "登录账号不存在"
      }, {
        "code": "-12808",
        "description": "玩家账号不存在"
      }, {
        "code": "-12809",
        "description": "区不存在"
      }, {
        "code": "-12810",
        "description": "流水号重复"
      }, {
        "code": "-12811",
        "description": "没有资格领取时间奖励"
      }, {
        "code": "-12812",
        "description": "已领取时间奖励"
      }, {
        "code": "-12813",
        "description": "未知错误"
      }, {
        "code": "-12814",
        "description": "游戏或者区服不存在"
      }, {
        "code": "-12815",
        "description": "未绑定手机号"
      }, {
        "code": "-12816",
        "description": "账号未登录"
      }, {
        "code": "-12817",
        "description": "操作失败"
      }, {
        "code": "-12818",
        "description": "账号已存在"
      }, {
        "code": "-12819",
        "description": "激活码不存在"
      }, {
        "code": "-12820",
        "description": "激活码已使用"
      }, {
        "code": "-12821",
        "description": "需要激活码"
      }, {
        "code": "-12822",
        "description": "游戏已关闭激活码激活玩家账号开关"
      }, {
        "code": "-12823",
        "description": "验证oldValue失败"
      }, {
        "code": "-12824",
        "description": "key不存在"
      }, {
        "code": "-12825",
        "description": "未知key类型"
      }, {
        "code": "-12826",
        "description": "网关名不存在"
      }, {
        "code": "-12827",
        "description": "大区内的账号不存在"
      }, {
        "code": "-12828",
        "description": "激活时间超时"
      }, {
        "code": "-12829",
        "description": "账号已申请过退款"
      }, {
        "code": "-12830",
        "description": "在线时长超时"
      }, {
        "code": "-12831",
        "description": "大区充值金额不足要求"
      }, {
        "code": "-12832",
        "description": "账号已是收费状态"
      }, {
        "code": "-12833",
        "description": "账号被冻结"
      }, {
        "code": "-12834",
        "description": "账号不允许充值"
      }, {
        "code": "-12835",
        "description": "查询账号数量超过16个"
      }, {
        "code": "-12836",
        "description": "账号不合法"
      }, {
        "code": "-12837",
        "description": "起始时间不能等于或晚于结束时间"
      }, {
        "code": "-12838",
        "description": "Paylog库访问异常"
      }, {
        "code": "-12839",
        "description": "用户没有可退款订单"
      }, {
        "code": "-12840",
        "description": "账号或者密码错误"
      }, {
        "code": "-20401",
        "description": "该通行证没有绑定手机"
      }, {
        "code": "-20402",
        "description": "请输入新绑定的手机号"
      }]
      		*/return reject(response);});};/**
		更改绑定手机(用户已绑定过手机的情况)
		请求方法: GET, POST
		请求示例: http://<domain>/jx/modifyphone/bind_new_phone_with_upsms?phone=15919175249

		响应示例:

		{
		    "code": 1,
		    "status": 1,
		    "msg": "",
		    "message": "",
		    "data": {
		        "session_id": "xWYsVRFHqEJqpetEDbEgJ6QY0gsxhvN090QVS1s3",
		        "request_id": "795e539e2994c87cec98c37970f5be8db3d77b69"
		    }
		}
		*/service.bindNewPhoneWithUpsms=function(phone){return request.jsonp(rootAddress+'/jx/modifyphone/bind_new_phone_with_upsms',{phone:phone/*  新手机号码 */}).then(function(response){if(response.status===1/* 成功 */){/**
        {
          "data{}": []
        }
        		*/return response.data;}/**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-12801",
        "description": "调用活动平台接口失败"
      }, {
        "code": "-12802",
        "description": "系统错误"
      }, {
        "code": "-12803",
        "description": "参数错误"
      }, {
        "code": "-12804",
        "description": "编码错误"
      }, {
        "code": "-12805",
        "description": "签名错误"
      }, {
        "code": "-12806",
        "description": "时间戳错误"
      }, {
        "code": "-12807",
        "description": "登录账号不存在"
      }, {
        "code": "-12808",
        "description": "玩家账号不存在"
      }, {
        "code": "-12809",
        "description": "区不存在"
      }, {
        "code": "-12810",
        "description": "流水号重复"
      }, {
        "code": "-12811",
        "description": "没有资格领取时间奖励"
      }, {
        "code": "-12812",
        "description": "已领取时间奖励"
      }, {
        "code": "-12813",
        "description": "未知错误"
      }, {
        "code": "-12814",
        "description": "游戏或者区服不存在"
      }, {
        "code": "-12815",
        "description": "未绑定手机号"
      }, {
        "code": "-12816",
        "description": "账号未登录"
      }, {
        "code": "-12817",
        "description": "操作失败"
      }, {
        "code": "-12818",
        "description": "账号已存在"
      }, {
        "code": "-12819",
        "description": "激活码不存在"
      }, {
        "code": "-12820",
        "description": "激活码已使用"
      }, {
        "code": "-12821",
        "description": "需要激活码"
      }, {
        "code": "-12822",
        "description": "游戏已关闭激活码激活玩家账号开关"
      }, {
        "code": "-12823",
        "description": "验证oldValue失败"
      }, {
        "code": "-12824",
        "description": "key不存在"
      }, {
        "code": "-12825",
        "description": "未知key类型"
      }, {
        "code": "-12826",
        "description": "网关名不存在"
      }, {
        "code": "-12827",
        "description": "大区内的账号不存在"
      }, {
        "code": "-12828",
        "description": "激活时间超时"
      }, {
        "code": "-12829",
        "description": "账号已申请过退款"
      }, {
        "code": "-12830",
        "description": "在线时长超时"
      }, {
        "code": "-12831",
        "description": "大区充值金额不足要求"
      }, {
        "code": "-12832",
        "description": "账号已是收费状态"
      }, {
        "code": "-12833",
        "description": "账号被冻结"
      }, {
        "code": "-12834",
        "description": "账号不允许充值"
      }, {
        "code": "-12835",
        "description": "查询账号数量超过16个"
      }, {
        "code": "-12836",
        "description": "账号不合法"
      }, {
        "code": "-12837",
        "description": "起始时间不能等于或晚于结束时间"
      }, {
        "code": "-12838",
        "description": "Paylog库访问异常"
      }, {
        "code": "-12839",
        "description": "用户没有可退款订单"
      }, {
        "code": "-12840",
        "description": "账号或者密码错误"
      }, {
        "code": "-20402",
        "description": "请输入新绑定的手机号"
      }, {
        "code": "-20403",
        "description": "请先按相关短信内容提示操作回复短信"
      }, {
        "code": "-20404",
        "description": "手机号非之前验证短信的号码"
      }]
      		*/return reject(response);});};/**
		上行短信回调地址
		请求方法: GET, POST
		请求示例:
		响应示例:
		*/service.callback=function(){return request.jsonp(rootAddress+'/jx/modifyphone/callback',{}).then(function(response){if(response.status===1/* 成功 */){/**
        {
          "data{}": []
        }
        		*/return response.data;}/**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
      		*/return reject(response);});};return service;});

/***/ }),

/***/ 1020:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__xfe_captcha_handler__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__xfe_captcha_handler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__xfe_captcha_handler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_utils_jsonp_util__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_constants_urls__ = __webpack_require__(371);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/**
 * 极验的账号, 用于区分专题或通用登录极验账号
 */var geetestGt=void 0;/**
 * 极验设置
 * @type {{requestPreAuthImpl(*=, *=): *}}
 */var getGeeTestSettings=function getGeeTestSettings(){var captchaUrl=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_2__src_constants_urls__["a" /* CAPTCHA_ZT_PRE_AUTH */];return{url:captchaUrl,requestPreAuthImpl:function requestPreAuthImpl(url,params){/**
       * 要求请求后返回 {message, data} 的数据结构
       */return Object(__WEBPACK_IMPORTED_MODULE_1__src_utils_jsonp_util__["a" /* default */])(url,params).then(function(response){if(response.code===1&&response.data.mode===2/* 极验验证码模式 */){geetestGt=response.data.config.gt;}return response;});}};};/**
 * 二次封装装饰函数
 * @return {*}
 */var captchaHandlerDecorate=function captchaHandlerDecorate(){var captchaUrl=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_2__src_constants_urls__["a" /* CAPTCHA_ZT_PRE_AUTH */];return __WEBPACK_IMPORTED_MODULE_0__xfe_captcha_handler___default.a.decorate({geeTestSettings:getGeeTestSettings(captchaUrl)},function(_ref,captchaData){var _ref2=_slicedToArray(_ref,1),params=_ref2[0];var newParams=_extends({},params,captchaData,{geetest_gt:geetestGt});return[newParams];});};/**
 * API对外暴露,
 * 用例:
 *
 * 原函数:
 *  // 发起登录请求
 *  async loginAsync({account, password}) {
 *   const {login} = this.props;
 *   return await login({account, password});
 * }
 *
 * 加入极验验证码:
 * @captchaHandlerDecorate()
 *  async loginAsync({account, password, ...authParams}) {
 *   const {login} = this.props;
 *   return await login({account, password, ...authParams});
 * }
 *
 * 效果:
 * 点击或者触发上述方法后自动弹出极验验证码
 *//* harmony default export */ __webpack_exports__["a"] = (captchaHandlerDecorate);

/***/ }),

/***/ 1021:
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CaptchaHandler", [], factory);
	else if(typeof exports === 'object')
		exports["CaptchaHandler"] = factory();
	else
		root["CaptchaHandler"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	
	Object.defineProperty(exports, "__esModule", { value: true });
	var captcha_handler_1 = __webpack_require__(1);
	var gee_test_reject_error_1 = __webpack_require__(11);
	exports.GeeTestRejectError = gee_test_reject_error_1["default"];
	var src_1 = __webpack_require__(2);
	exports.VerifyRejectState = src_1.VerifyRejectState;
	var version = ("1.1.0");
	exports.version = version;
	exports["default"] = captcha_handler_1["default"];
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(2);
	var geetest_captcha_model_1 = __webpack_require__(5);
	var picture_captcha_model_1 = __webpack_require__(7);
	var abstract_captcha_model_1 = __webpack_require__(6);
	var gee_test_reject_error_1 = __webpack_require__(11);

	var CaptchaHandler = function () {
	    function CaptchaHandler() {
	        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	            _ref$geeTestSettings = _ref.geeTestSettings,
	            geeTestSettings = _ref$geeTestSettings === undefined ? {} : _ref$geeTestSettings,
	            _ref$pictureSettings = _ref.pictureSettings,
	            pictureSettings = _ref$pictureSettings === undefined ? {} : _ref$pictureSettings;

	        _classCallCheck(this, CaptchaHandler);

	        this.geeTestSettings = geeTestSettings;
	        this.pictureSettings = pictureSettings;
	    }

	    CaptchaHandler.decorate = function decorate(params) {
	        var intercept = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (f) {
	            return f;
	        };

	        /**
	         * overload
	         */
	        if (typeof params === 'function') {
	            intercept = params;
	            params = undefined;
	        }
	        var captchaHandler = new CaptchaHandler(params);
	        var Mode = void 0;
	        (function (Mode) {
	            Mode[Mode["MethodDecorate"] = 1] = "MethodDecorate";
	            Mode[Mode["ES5Function"] = 2] = "ES5Function";
	        })(Mode || (Mode = {}));
	        return function (target, name) {
	            var descriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var mode = void 0;
	            if (target && name && descriptor) {
	                mode = 1 /* MethodDecorate */;
	            } else if (typeof target === 'function') {
	                mode = 2 /* ES5Function */;
	                descriptor.value = target;
	            }
	            var submit = descriptor.value;
	            descriptor.value = function () {
	                var $args = arguments;return new Promise(function ($return, $error) {
	                    var _ref2, state, data, _len, args, _key, newArgs;

	                    return Promise.resolve(captchaHandler.verify()).then(function ($await_2) {
	                        try {
	                            _ref2 = $await_2, state = _ref2.state, data = _ref2.data;

	                            if (state === index_1.VerifyRejectState.Success) {
	                                /**
	                                 * 由于极验reset并不会发起请求, 拿到凭证后可直接重置captchaHandler即可
	                                 * 放置在submit.apply前面也能防止后续异常导致没有正确重置
	                                 */
	                                captchaHandler.reset();

	                                for (_len = $args.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                                    args[_key] = $args[_key];
	                                }

	                                newArgs = intercept(args, data);
	                                if (Object.prototype.toString.call(newArgs) === '[object Array]') {
	                                    return $return(submit.apply(this, intercept(newArgs)));
	                                }
	                                return $error(new Error('<intercept> 函数必须返回数组类型'));
	                            } else if (state === index_1.VerifyRejectState.Cancel) {
	                                return $return(Promise.resolve(new gee_test_reject_error_1["default"](state, data)));
	                            }
	                            return $return(Promise.reject(new gee_test_reject_error_1["default"](state, data)));
	                        } catch ($boundEx) {
	                            return $error($boundEx);
	                        }
	                    }.bind(this), $error);
	                }.bind(this));
	            };
	            if (mode === 1 /* MethodDecorate */) {
	                    return descriptor;
	                } else if (mode === 2 /* ES5Function */) {
	                    return descriptor.value;
	                } else {
	                throw new Error('unexpected condition. please contact the author');
	            }
	        };
	    };

	    CaptchaHandler.prototype.init = function init() {
	        return new Promise(function ($return, $error) {
	            var pictureSettings, geeTestSettings, geeTestCaptchaObject;

	            if (this.captchaModel) {
	                /**
	                 * 当前为图片验证码时候且状态不为reset
	                 */
	                if (this.captchaModel instanceof picture_captcha_model_1["default"] && this.captchaModel.getState() !== abstract_captcha_model_1.CaptchaModelStateEnum.Reset) {
	                    return $return();
	                }
	                if (this.captchaModel instanceof geetest_captcha_model_1["default"]) {
	                    return $return();
	                }
	            }
	            pictureSettings = this.pictureSettings, geeTestSettings = this.geeTestSettings;

	            /**
	             * 预处理极验配置项
	             */
	            CaptchaHandler.preProcessGeetestSettings(geeTestSettings);
	            var $Try_1_Post = function () {
	                try {
	                    return $return();
	                } catch ($boundEx) {
	                    return $error($boundEx);
	                }
	            }.bind(this);var $Try_1_Catch = function (e) {
	                try {
	                    if (e instanceof Error) {
	                        throw e;
	                    }
	                    this.captchaModel = new picture_captcha_model_1["default"](pictureSettings);
	                    return $Try_1_Post();
	                } catch ($boundEx) {
	                    return $error($boundEx);
	                }
	            }.bind(this);try {
	                return Promise.resolve(index_1["default"].authAndInit(geeTestSettings)).then(function ($await_3) {
	                    try {
	                        geeTestCaptchaObject = $await_3;
	                        this.captchaModel = new geetest_captcha_model_1["default"](geeTestCaptchaObject);
	                        return $Try_1_Post();
	                    } catch ($boundEx) {
	                        return $Try_1_Catch($boundEx);
	                    }
	                }.bind(this), $Try_1_Catch);
	            } catch (e) {
	                $Try_1_Catch(e)
	            }
	        }.bind(this));
	    };

	    CaptchaHandler.preProcessGeetestSettings = function preProcessGeetestSettings() {
	        var geeTestSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	        var geeTestOptions = geeTestSettings.options = geeTestSettings.options || {};
	        if (!geeTestOptions.product) {
	            geeTestOptions.product = 'bind';
	        }
	        if (geeTestOptions.product && geeTestOptions.product !== 'bind') {
	            throw new Error('captcha handler 仅支持极验为 {product: \'bind\'} 的模式');
	        }
	    };

	    CaptchaHandler.prototype.verify = function verify() {
	        return new Promise(function ($return, $error) {
	            return Promise.resolve(this.init()).then(function ($await_4) {
	                try {
	                    return $return(this.captchaModel.verify());
	                } catch ($boundEx) {
	                    return $error($boundEx);
	                }
	            }.bind(this), $error);
	        }.bind(this));
	    };

	    CaptchaHandler.prototype.reset = function reset() {
	        this.captchaModel.reset();
	    };

	    return CaptchaHandler;
	}();

	exports["default"] = CaptchaHandler;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	Object.defineProperty(exports, "__esModule", { value: true });
	var _init = __webpack_require__(3);
	var pre_auth_1 = __webpack_require__(4);
	/**
	 * 极验/图形验证码校验失败的状态
	 */
	var VerifyRejectState;
	(function (VerifyRejectState) {
	    VerifyRejectState[VerifyRejectState["Cancel"] = 0] = "Cancel";
	    VerifyRejectState[VerifyRejectState["Error"] = -1] = "Error";
	    VerifyRejectState[VerifyRejectState["Success"] = 1] = "Success";
	})(VerifyRejectState = exports.VerifyRejectState || (exports.VerifyRejectState = {}));

	var WebGeeTest = function () {
	    function WebGeeTest() {
	        _classCallCheck(this, WebGeeTest);
	    }

	    WebGeeTest.authAndInit = function authAndInit(preAuthParams) {
	        return pre_auth_1["default"](preAuthParams);
	    };

	    WebGeeTest.init = function init(settings) {
	        /**
	         * 重置为 100%， 让父类去控制
	         */
	        settings.width = settings.width || '100%';
	        return new Promise(function (resolve) {
	            _init(settings, function (captchaObj) {
	                captchaObj.onReady(function () {
	                    return resolve(captchaObj);
	                });
	            });
	        });
	    };

	    WebGeeTest.verify = function verify(captchaObj) {
	        return new Promise(function (resolve, reject) {
	            captchaObj.onSuccess(function () {
	                var validation = captchaObj.getValidate();
	                resolve({ state: VerifyRejectState.Success, data: validation });
	            });
	            captchaObj.onClose(function () {
	                resolve({ state: VerifyRejectState.Cancel });
	            });
	            captchaObj.onError(function () {
	                reject({ state: VerifyRejectState.Error, message: '出错啦，请稍后重试' });
	            });
	            captchaObj.verify();
	        });
	    };

	    WebGeeTest.reset = function reset(captchaObj) {
	        captchaObj.reset();
	    };

	    return WebGeeTest;
	}();

	exports["default"] = WebGeeTest;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/* initGeetest 1.0.0
	 * 用于加载id对应的验证码库，并支持宕机模式
	 * 暴露 initGeetest 进行验证码的初始化
	 * 一般不需要用户进行修改
	 */
	(function(global, factory) {
	    "use strict";
	    if (typeof module === "object" && typeof module.exports === "object") {
	        // CommonJS
	        module.exports = global.document ?
	            factory(global, true) :
	            function(w) {
	                if (!w.document) {
	                    throw new Error("Geetest requires a window with a document");
	                }
	                return factory(w);
	            };
	    } else {
	        factory(global);
	    }
	})(typeof window !== "undefined" ? window : this, function(window, noGlobal) {
	    "use strict";
	    if (typeof window === 'undefined') {
	        throw new Error('Geetest requires browser environment');
	    }
	    var document = window.document;
	    var Math = window.Math;
	    var head = document.getElementsByTagName("head")[0];
	    function _Object(obj) {
	        this._obj = obj;
	    }
	    _Object.prototype = {
	        _each: function(process) {
	            var _obj = this._obj;
	            for (var k in _obj) {
	                if (_obj.hasOwnProperty(k)) {
	                    process(k, _obj[k]);
	                }
	            }
	            return this;
	        }
	    };
	    function Config(config) {
	        var self = this;
	        new _Object(config)._each(function(key, value) {
	            self[key] = value;
	        });
	    }
	    Config.prototype = {
	        api_server: 'api.geetest.com',
	        protocol: 'http://',
	        type_path: '/gettype.php',
	        fallback_config: {
	            slide: {
	                static_servers: ["static.geetest.com", "dn-staticdown.qbox.me"],
	                type: 'slide',
	                slide: '/static/js/geetest.0.0.0.js'
	            },
	            fullpage: {
	                static_servers: ["static.geetest.com", "dn-staticdown.qbox.me"],
	                type: 'fullpage',
	                fullpage: '/static/js/fullpage.0.0.0.js'
	            }
	        },
	        _get_fallback_config: function() {
	            var self = this;
	            if (isString(self.type)) {
	                return self.fallback_config[self.type];
	            } else if (self.new_captcha) {
	                return self.fallback_config.fullpage;
	            } else {
	                return self.fallback_config.slide;
	            }
	        },
	        _extend: function(obj) {
	            var self = this;
	            new _Object(obj)._each(function(key, value) {
	                self[key] = value;
	            })
	        }
	    };
	    var isNumber = function(value) {
	        return (typeof value === 'number');
	    };
	    var isString = function(value) {
	        return (typeof value === 'string');
	    };
	    var isBoolean = function(value) {
	        return (typeof value === 'boolean');
	    };
	    var isObject = function(value) {
	        return (typeof value === 'object' && value !== null);
	    };
	    var isFunction = function(value) {
	        return (typeof value === 'function');
	    };
	    var callbacks = {};
	    var status = {};
	    var random = function() {
	        return parseInt(Math.random() * 10000) + (new Date()).valueOf();
	    };
	    var loadScript = function(url, cb) {
	        var script = document.createElement("script");
	        script.charset = "UTF-8";
	        script.async = true;
	        script.onerror = function() {
	            cb(true);
	        };
	        var loaded = false;
	        script.onload = script.onreadystatechange = function() {
	            if (!loaded &&
	                (!script.readyState ||
	                    "loaded" === script.readyState ||
	                    "complete" === script.readyState)) {
	                loaded = true;
	                setTimeout(function() {
	                    cb(false);
	                }, 0);
	            }
	        };
	        script.src = url;
	        head.appendChild(script);
	    };
	    var normalizeDomain = function(domain) {
	        return domain.replace(/^https?:\/\/|\/$/g, '');
	    };
	    var normalizePath = function(path) {
	        path = path.replace(/\/+/g, '/');
	        if (path.indexOf('/') !== 0) {
	            path = '/' + path;
	        }
	        return path;
	    };
	    var normalizeQuery = function(query) {
	        if (!query) {
	            return '';
	        }
	        var q = '?';
	        new _Object(query)._each(function(key, value) {
	            if (isString(value) || isNumber(value) || isBoolean(value)) {
	                q = q + encodeURIComponent(key) + '=' + encodeURIComponent(value) + '&';
	            }
	        });
	        if (q === '?') {
	            q = '';
	        }
	        return q.replace(/&$/, '');
	    };
	    var makeURL = function(protocol, domain, path, query) {
	        domain = normalizeDomain(domain);
	        var url = normalizePath(path) + normalizeQuery(query);
	        if (domain) {
	            url = protocol + domain + url;
	        }
	        return url;
	    };
	    var load = function(protocol, domains, path, query, cb) {
	        var tryRequest = function(at) {
	            var url = makeURL(protocol, domains[at], path, query);
	            loadScript(url, function(err) {
	                if (err) {
	                    if (at >= domains.length - 1) {
	                        cb(true);
	                    } else {
	                        tryRequest(at + 1);
	                    }
	                } else {
	                    cb(false);
	                }
	            });
	        };
	        tryRequest(0);
	    };
	    var jsonp = function(domains, path, config, callback) {
	        if (isObject(config.getLib)) {
	            config._extend(config.getLib);
	            callback(config);
	            return;
	        }
	        if (config.offline) {
	            callback(config._get_fallback_config());
	            return;
	        }
	        var cb = "geetest_" + random();
	        window[cb] = function(data) {
	            if (data.status === 'success') {
	                callback(data.data);
	            } else if (!data.status) {
	                callback(data);
	            } else {
	                callback(config._get_fallback_config());
	            }
	            window[cb] = undefined;
	            try {
	                delete window[cb];
	            } catch (e) {}
	        };
	        load(config.protocol, domains, path, {
	            gt: config.gt,
	            callback: cb
	        }, function(err) {
	            if (err) {
	                callback(config._get_fallback_config());
	            }
	        });
	    };
	    var throwError = function(errorType, config) {
	        var errors = {
	            networkError: '网络错误'
	        };
	        if (typeof config.onError === 'function') {
	            config.onError(errors[errorType]);
	        } else {
	            throw new Error(errors[errorType]);
	        }
	    };
	    var detect = function() {
	        return !!window.Geetest;
	    };
	    if (detect()) {
	        status.slide = "loaded";
	    }
	    var initGeetest = function(userConfig, callback) {
	        var config = new Config(userConfig);
	        if (userConfig.https) {
	            config.protocol = 'https://';
	        } else if (!userConfig.protocol) {
	            config.protocol = window.location.protocol + '//';
	        }
	        jsonp([config.api_server || config.apiserver], config.type_path, config, function(newConfig) {
	            var type = newConfig.type;
	            var init = function() {
	                config._extend(newConfig);
	                callback(new window.Geetest(config));
	            };
	            callbacks[type] = callbacks[type] || [];
	            var s = status[type] || 'init';
	            if (s === 'init') {
	                status[type] = 'loading';
	                callbacks[type].push(init);
	                load(config.protocol, newConfig.static_servers || newConfig.domains, newConfig[type] || newConfig.path, null, function(err) {
	                    if (err) {
	                        status[type] = 'fail';
	                        throwError('networkError', config);
	                    } else {
	                        status[type] = 'loaded';
	                        var cbs = callbacks[type];
	                        for (var i = 0, len = cbs.length; i < len; i = i + 1) {
	                            var cb = cbs[i];
	                            if (isFunction(cb)) {
	                                cb();
	                            }
	                        }
	                        callbacks[type] = [];
	                    }
	                });
	            } else if (s === "loaded") {
	                init();
	            } else if (s === "fail") {
	                throwError('networkError', config);
	            } else if (s === "loading") {
	                callbacks[type].push(init);
	            }
	        });
	    };
	    window.initGeetest = initGeetest;
	    return initGeetest;
	});


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(2);
	/**
	 * 验证码模式
	 */
	var CaptchaMode;
	(function (CaptchaMode) {
	    CaptchaMode[CaptchaMode["Picture"] = 1] = "Picture";
	    CaptchaMode[CaptchaMode["GeeTest"] = 2] = "GeeTest";
	})(CaptchaMode || (CaptchaMode = {}));
	/**
	 * 默认pre auth请求地址
	 */
	var defaultPreAuthUrls = {
	    http: 'http://apps-ws.xoyo.com/passport/pre_auth',
	    https: 'https://apps-ws.xoyo.com/passport/pre_auth'
	};
	function getNormalizeProtocol() {
	    return window.location.protocol.slice(0, -1).toLowerCase();
	}
	/**
	 * 获取默认url地址
	 * @returns {string} - 正确返回请求地址
	 */
	function getDefaultUrl() {
	    var preAuthUrl = defaultPreAuthUrls[getNormalizeProtocol()];
	    if (!preAuthUrl) {
	        throw new Error('若使用默认url地址时，请确保浏览器 url protocol 为 http 或 https');
	    }
	    return preAuthUrl;
	}
	/**
	 * 校验请求是否是xfe-request
	 * @param request
	 */
	function invariantRequest(request) {
	    if (!request.jsonp) {
	        throw new Error('请使用xfe-request完成以下操作');
	    }
	}
	/**
	 *
	 * @param {Object} params - 请求参数
	 * @param {{jsonp: ((url: string, params: Object) => Promise<IPreAuthResponse>)}} request - 请求实现， 默认使用 xfe-request
	 * @param {string} url - 请求地址，默认使用内部配置地址
	 * @param {IInitSettings} options - 极验配置项
	 * @param {(url: string, params: Object) => Promise<IPreAuthResponse>} requestImpl
	 * @returns {Promise<any>}
	 */
	function preAuth(_ref) {
	    return new Promise(function ($return, $error) {
	        var params, request, _ref$url, url, options, requestImpl, requestPreAuthImpl, response, _response, _response$data, mode, config, code, state;

	        params = _ref.params, request = _ref.request, _ref$url = _ref.url, url = _ref$url === undefined ? getDefaultUrl() : _ref$url, options = _ref.options, requestImpl = _ref.requestImpl, requestPreAuthImpl = _ref.requestPreAuthImpl;

	        request && invariantRequest(request);
	        /**
	         * requestPreAuthImpl 作为别名, 也为了兼容
	         */
	        if (requestPreAuthImpl) {
	            requestImpl = requestPreAuthImpl;
	        }
	        if ((typeof url === "undefined" ? "undefined" : _typeof(url)) === 'object') {
	            url = url[getNormalizeProtocol()];
	        }
	        response = void 0;
	        if (request) {
	            return Promise.resolve(request.jsonp(url, params)).then(function ($await_3) {
	                try {
	                    response = $await_3;
	                    return $If_1.call(this);
	                } catch ($boundEx) {
	                    return $error($boundEx);
	                }
	            }.bind(this), $error);
	        } else {
	            if (requestImpl) {
	                return Promise.resolve(requestImpl(url, params)).then(function ($await_4) {
	                    try {
	                        response = $await_4;
	                        return $If_2.call(this);
	                    } catch ($boundEx) {
	                        return $error($boundEx);
	                    }
	                }.bind(this), $error);
	            } else {
	                return $error(new Error('请传入 request 或 requestImpl'));
	            }

	            function $If_2() {
	                return $If_1.call(this);
	            }

	            return $If_2.call(this);
	        }
	        function $If_1() {
	            _response = response, _response$data = _response.data, mode = _response$data.mode, config = _response$data.config, code = _response.code, state = _response.state;

	            /**
	             * code 和 state 表达一样的含义, 当 state 出现时, 为了兼容旧系统, state 直接赋值给 code
	             */
	            if (state) {
	                code = state;
	            }
	            if (code === 1 /*成功*/) {
	                    if (mode === 2 /* GeeTest */) {
	                            return $return(index_1["default"].init(_extends({}, config, options)));
	                        } else if (mode === 1 /* Picture */) {
	                            return $return(Promise.reject(response));
	                        } else {
	                        return $error(new Error("\u672A\u77E5 pre auth mode\uFF0Cmode = " + mode));
	                    }
	                }
	            return $return(Promise.reject(response));
	        }
	    }.bind(this));
	}
	exports["default"] = preAuth;
	//# sourceMappingURL=pre-auth.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(2);
	var abstract_captcha_model_1 = __webpack_require__(6);

	var GeetestCaptchaModel = function (_abstract_captcha_mod) {
	    _inherits(GeetestCaptchaModel, _abstract_captcha_mod);

	    function GeetestCaptchaModel(captchaObj) {
	        _classCallCheck(this, GeetestCaptchaModel);

	        var _this = _possibleConstructorReturn(this, _abstract_captcha_mod.call(this));

	        _this.captchaObj = captchaObj;
	        return _this;
	    }

	    GeetestCaptchaModel.prototype.verifyProcess = function verifyProcess() {
	        return new Promise(function ($return, $error) {
	            return $return(index_1["default"].verify(this.captchaObj));
	        }.bind(this));
	    };

	    GeetestCaptchaModel.prototype.resetProcess = function resetProcess() {
	        this.captchaObj.reset();
	    };

	    return GeetestCaptchaModel;
	}(abstract_captcha_model_1["default"]);

	exports["default"] = GeetestCaptchaModel;
	//# sourceMappingURL=geetest-captcha-model.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	Object.defineProperty(exports, "__esModule", { value: true });
	var CaptchaModelStateEnum;
	(function (CaptchaModelStateEnum) {
	    CaptchaModelStateEnum[CaptchaModelStateEnum["Initialized"] = 1] = "Initialized";
	    CaptchaModelStateEnum[CaptchaModelStateEnum["Reset"] = -1] = "Reset";
	    CaptchaModelStateEnum[CaptchaModelStateEnum["Verified"] = 2] = "Verified";
	})(CaptchaModelStateEnum = exports.CaptchaModelStateEnum || (exports.CaptchaModelStateEnum = {}));

	var AbstractCaptchaModel = function () {
	    function AbstractCaptchaModel() {
	        _classCallCheck(this, AbstractCaptchaModel);

	        this.setState(CaptchaModelStateEnum.Initialized);
	    }

	    AbstractCaptchaModel.prototype.setState = function setState(state) {
	        this.state = state;
	    };

	    AbstractCaptchaModel.prototype.getState = function getState() {
	        return this.state;
	    };

	    AbstractCaptchaModel.prototype.verify = function verify() {
	        return new Promise(function ($return, $error) {
	            var result;
	            return Promise.resolve(this.verifyProcess()).then(function ($await_1) {
	                try {
	                    result = $await_1;
	                    this.setState(CaptchaModelStateEnum.Verified);
	                    return $return(result);
	                } catch ($boundEx) {
	                    return $error($boundEx);
	                }
	            }.bind(this), $error);
	        }.bind(this));
	    };

	    AbstractCaptchaModel.prototype.reset = function reset() {
	        this.resetProcess();
	        this.setState(CaptchaModelStateEnum.Reset);
	    };

	    return AbstractCaptchaModel;
	}();

	exports["default"] = AbstractCaptchaModel;
	//# sourceMappingURL=abstract-captcha-model.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable prefer-arrow-callback */
	var index_1 = __webpack_require__(2);
	var abstract_captcha_model_1 = __webpack_require__(6);
	var uid = __webpack_require__(8);
	var picture_model_html_template_1 = __webpack_require__(9);
	var utils_1 = __webpack_require__(10);

	var PictureCaptchaModel = function (_abstract_captcha_mod) {
	    _inherits(PictureCaptchaModel, _abstract_captcha_mod);

	    function PictureCaptchaModel() {
	        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	            _ref$captchaPicUrl = _ref.captchaPicUrl,
	            captchaPicUrl = _ref$captchaPicUrl === undefined ? 'https://apps-ws.xoyo.com/passport/captcha' : _ref$captchaPicUrl,
	            _ref$elementId = _ref.elementId,
	            elementId = _ref$elementId === undefined ? PictureCaptchaModel.getRandomElementId() : _ref$elementId;

	        _classCallCheck(this, PictureCaptchaModel);

	        var _this = _possibleConstructorReturn(this, _abstract_captcha_mod.call(this));

	        _this.captchaPicUrl = captchaPicUrl;
	        _this.elementId = elementId;
	        _this.onPicCaptchaClick = _this.onPicCaptchaClick.bind(_this);
	        return _this;
	    }

	    PictureCaptchaModel.getRandomElementId = function getRandomElementId() {
	        return String(uid());
	    };

	    PictureCaptchaModel.prototype.verifyProcess = function verifyProcess() {
	        var _this2 = this;

	        return new Promise(function (resolve) {
	            _this2.resolve = resolve;
	            _this2.open();
	        });
	    };

	    PictureCaptchaModel.prototype.resetProcess = function resetProcess() {
	        if (this.$pictureCaptcha) {
	            this.close();
	            this.$pictureCaptcha.parentNode.removeChild(this.$pictureCaptcha);
	            this.$pictureCaptcha = null;
	        }
	    };

	    PictureCaptchaModel.prototype.onSubmitClick = function onSubmitClick() {
	        var captchaValue = this.$input.value;
	        if (captchaValue) {
	            this.resolve({
	                state: index_1.VerifyRejectState.Success,
	                data: { phrase: captchaValue, tag: this.elementId }
	            });
	            this.close();
	        } else {
	            alert('请填写验证码!');
	        }
	    };

	    PictureCaptchaModel.prototype.onPicCaptchaClick = function onPicCaptchaClick(e) {
	        e.target.src = this.refreshPicCaptchaSrc();
	    };

	    PictureCaptchaModel.prototype.refreshPicCaptchaSrc = function refreshPicCaptchaSrc() {
	        return this.captchaPicUrl + "?tag=" + this.elementId + "&" + +new Date();
	    };

	    PictureCaptchaModel.prototype.onCloseButtonClick = function onCloseButtonClick() {
	        this.resolve({
	            state: index_1.VerifyRejectState.Cancel,
	            data: null
	        });
	        this.close();
	    };

	    PictureCaptchaModel.prototype.open = function open() {
	        if (!this.$pictureCaptcha) {
	            this.$pictureCaptcha = this.renderPictureCaptcha();
	        }
	        this.$pictureCaptcha.style.display = 'block';
	        document.body.appendChild(this.$pictureCaptcha);
	    };

	    PictureCaptchaModel.prototype.close = function close() {
	        var $pictureCaptcha = this.$pictureCaptcha;

	        if ($pictureCaptcha) {
	            $pictureCaptcha.style.display = 'none';
	        }
	    };

	    PictureCaptchaModel.prototype.renderPictureCaptcha = function renderPictureCaptcha() {
	        var _this3 = this;

	        var div = document.createElement('div');
	        div.innerHTML = picture_model_html_template_1["default"];
	        var result = div.firstChild;
	        var $close = utils_1.getElementsByClassName('xsj-pic-captcha-close', result)[0];
	        this.$input = utils_1.getElementsByClassName('xsj-pic-captcha-input', result)[0];
	        var $captchaImg = utils_1.getElementsByClassName('xsj-pic-captcha-img', result)[0];
	        $captchaImg.src = this.refreshPicCaptchaSrc();
	        utils_1.addEventListener($captchaImg, 'click', this.onPicCaptchaClick);
	        var $submitBtn = utils_1.getElementsByClassName('xsj-pic-captcha-btn', result)[0];
	        utils_1.addEventListener($close, 'click', function () {
	            return _this3.onCloseButtonClick();
	        });
	        utils_1.addEventListener($captchaImg, 'click', this.onPicCaptchaClick);
	        utils_1.addEventListener($submitBtn, 'click', function () {
	            return _this3.onSubmitClick();
	        });
	        utils_1.addEventListener(this.$input, 'keyup', function (event) {
	            event.preventDefault();
	            if (event.keyCode === 13) {
	                $submitBtn.click();
	            }
	        });
	        return result;
	    };

	    return PictureCaptchaModel;
	}(abstract_captcha_model_1["default"]);

	exports["default"] = PictureCaptchaModel;
	//# sourceMappingURL=picture-captcha-model.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	/**
	 * Export `uid`
	 */

	module.exports = uid;

	/**
	 * Create a `uid`
	 *
	 * @param {String} len
	 * @return {String} uid
	 */

	function uid(len) {
	  len = len || 7;
	  return Math.random().toString(35).substr(2, len);
	}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var templateString = "<div class=\"xsj-pic-captcha\"><div class=\"xsj-pic-captcha-sliver\" style=\"background: #808080; background-color: rgba(0, 0, 0, 0.5); bottom: 0; left: 0; position: absolute; right: 0; top: 0; z-index: 9000;\"></div><div class=\"xsj-pic-captcha-box\" style=\"background: #fff; left: 50%; margin-left: -160px; padding: 20px; position: absolute; top: 50%; width: 300px; z-index: 9999;\"><img class=\"xsj-pic-captcha-close\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAe0lEQVQ4T7WT0Q2AMAhE7zZyFEdwNEdwFDfCkFRjEVqaxv60TeABB1BETgAbSb3TR0QWADvL4wCwZiGVj4YcgVhb3jlnIJ7NA+hlEgWoABGkld0HYCGlxFBkF2Ag+g079A/gXfNwCZ5gaRFbht02Tg1Sxjma2Pllml3nC2ohigWIYK4xAAAAAElFTkSuQmCC\" style=\"cursor: pointer; font-size: 12px; position: absolute; right: -20px; top: 0;\"><div class=\"xsj-pic-captcha-wrap\" style=\"overflow: hidden; width: 100%;\"><input class=\"xsj-pic-captcha-input\" placeholder=\"&#x8BF7;&#x8F93;&#x5165;&#x9A8C;&#x8BC1;&#x7801;\" style=\"-moz-border-radius: 4px; -moz-box-sizing: content-box; -ms-border-radius: 4px; -o-border-radius: 4px; -webkit-border-radius: 4px; -webkit-box-sizing: content-box; background-color: #fff; border: 1px solid #e6e6e6; border-radius: 4px; box-sizing: content-box; color: #333; float: left; font-size: 14px; height: 48px; line-height: 48px !important; padding: 0 8px; vertical-align: middle; width: 164px;\"> <img class=\"xsj-pic-captcha-img\" style=\"-moz-box-sizing: content-box; -webkit-box-sizing: content-box; box-sizing: content-box; cursor: pointer; float: right; height: 48px; vertical-align: middle; width: 104px;\"></div><button class=\"xsj-pic-captcha-btn\" style=\"background: #1890ff; border: 1px #1890ff solid; border-radius: 5px; color: #fff; cursor: pointer; display: block; font-size: 16px; height: 44px; margin-top: 10px; width: 100%;\">\u786E\u8BA4</button></div></div>";

	exports["default"] = templateString;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	
	Object.defineProperty(exports, "__esModule", { value: true });
	function addEventListener(ele, event, fn) {
	    if (ele.addEventListener) {
	        ele.addEventListener(event, fn, false);
	    } else {
	        ele.attachEvent("on" + event, fn.bind(ele));
	    }
	}
	exports.addEventListener = addEventListener;
	function removeEventListener(ele, event, fn) {
	    if (ele.removeEventListener) {
	        ele.removeEventListener(event, fn, false);
	    } else {
	        ele.detachEvent("on" + event, fn.bind(ele));
	    }
	}
	exports.removeEventListener = removeEventListener;
	exports.addEventListenerOnce = function () {
	    var isFirst = [];
	    return function (ele, event, fn) {
	        var eleArray = isFirst.filter(function (item) {
	            return item === ele;
	        });
	        if (eleArray.length) return false;
	        if (ele.addEventListener) {
	            ele.addEventListener(event, fn, false);
	        } else {
	            ele.attachEvent("on" + event, fn.bind(ele));
	        }
	        isFirst.push(ele);
	    };
	}();
	function getElementsByClassName(cls, context) {
	    context = context || document;
	    if (context.getElementsByClassName) {
	        return context.getElementsByClassName(cls);
	    }
	    var result = [];
	    var arr = context.getElementsByTagName('*');
	    var re = new RegExp("\\b" + cls + "\\b"); //""前面必须加上/
	    for (var i = 0; i < arr.length; i++) {
	        if (re.test(arr[i].className)) {
	            result.push(arr[i]);
	        }
	    }
	    return result;
	}
	exports.getElementsByClassName = getElementsByClassName;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	Object.defineProperty(exports, "__esModule", { value: true });

	var GeeTestRejectError = function GeeTestRejectError($state, $data) {
	    _classCallCheck(this, GeeTestRejectError);

	    this.$state = $state;
	    this.$data = $data;
	};

	exports["default"] = GeeTestRejectError;
	//# sourceMappingURL=gee-test-reject-error.js.map

/***/ })
/******/ ])
});
;

/***/ }),

/***/ 1022:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = append;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_utils_intercept_component_will_unmount__ = __webpack_require__(1031);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/**
 * 直接通过 append 方法添加到 body 子节点, 常用语弹窗
 * @param {object} ModalElement - react 组件, 常用语弹窗, 也可自行自定义类弹窗组件, 自定义组件请自行实现 onClose visible afterClose 的 props 方法
 * @param {object} componentContext - react 组件实例 this, 传入其他 this 时报错处理
 * @returns {{close: Function, promise: Promise}}
 *
 * {Function} close - 开发者可以通过 close() 方法直接调用, 这样便于自定义场景直接控制关闭弹窗
 * {Promise} promise - 开发者可以通过该方法指导当前弹窗什么时候关闭(销毁), 用法: promise.finally(()=> {...})
 *
 */function append(ModalElement,componentContext){var div=document.createElement('div');var close=void 0;var promise=new Promise(function(resolve){var setVisibility=void 0;close=function close(){setVisibility(false);return promise;};var afterClose=function afterClose(){__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(div);resolve();};var element=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(function(){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState2=_slicedToArray(_useState,2),visible=_useState2[0],_setVisibility=_useState2[1];setVisibility=_setVisibility;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalElement,{visible:visible,onClose:function onClose(){return setVisibility(false);},afterClose:afterClose});});__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(element,div);if(componentContext){if(componentContext.__proto__ instanceof __WEBPACK_IMPORTED_MODULE_0_react___default.a.Component){Object(__WEBPACK_IMPORTED_MODULE_2__src_utils_intercept_component_will_unmount__["a" /* default */])(componentContext,close);}else{throw new Error('modal: invalid component context. 请确保 append 传入中的 componentContext (常用 this) 为 react component 实例 this');}}});return{close:close,promise:promise};}

/***/ }),

/***/ 1023:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeviceUtils; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/* eslint-disable */var DeviceUtils=function(){function DeviceUtils(){_classCallCheck(this,DeviceUtils);}_createClass(DeviceUtils,null,[{key:'getUserAgent',value:function getUserAgent(){var userAgent=navigator.userAgent||navigator.vendor||window.opera;return userAgent.toLowerCase();}},{key:'isMobile',value:function isMobile(){var userAgent=DeviceUtils.getUserAgent();return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([ -\/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([ \/])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([- ])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(userAgent.substr(0,4));}},{key:'isAndroid',value:function isAndroid(){return /android/i.test(DeviceUtils.getUserAgent());}},{key:'isIOS',value:function isIOS(){return /iPad|iPhone|iPod/i.test(DeviceUtils.getUserAgent())&&!window.MSStream;}/**
   * 判断是否是微信
   * @returns {boolean}
   */},{key:'isWeiXin',value:function isWeiXin(){var userAgent=DeviceUtils.getUserAgent();return String(userAgent.match(/MicroMessenger/i))==='micromessenger';}}]);return DeviceUtils;}();

/***/ }),

/***/ 1024:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_vm_component_compute__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_vm_component_entry__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_vm_component_mapper__ = __webpack_require__(1027);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function business(vmInstance){var viewState=vmInstance.viewState,computes=vmInstance.computes,mappers=vmInstance.mappers,_entry=vmInstance.entry;if(viewState){vmInstance.viewState=Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["n" /* observable */])(viewState);}if(computes){Object(__WEBPACK_IMPORTED_MODULE_2__src_components_vm_component_compute__["a" /* default */])(vmInstance,'computes');}if(_entry){Object(__WEBPACK_IMPORTED_MODULE_3__src_components_vm_component_entry__["a" /* default */])(vmInstance,'entry');}if(mappers){Object(__WEBPACK_IMPORTED_MODULE_4__src_components_vm_component_mapper__["a" /* default */])(vmInstance,'mappers');}return vmInstance;}var VMComponent=function VMComponent(VM){return function(_React$Component){_inherits(_class,_React$Component);function _class(props,context){_classCallCheck(this,_class);var _this=_possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).call(this,props,context));_this.vm=business(new VM(_this));return _this;}return _class;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);};/* harmony default export */ __webpack_exports__["a"] = (VMComponent);

/***/ }),

/***/ 1025:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(43);
var bind=function bind(){return function(instance,methodName,descriptor){var context=this;var get=descriptor.get;descriptor.get=function(){return get.call(context);};};};function compute(instance,methodName){var descriptor=arguments.length>2&&arguments[2]!==undefined?arguments[2]:Object.getOwnPropertyDescriptor(instance,methodName);var _ref=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{},disableCompute=_ref.disableCompute;var value=instance[methodName]||descriptor.initializer&&descriptor.initializer.call(this);Object.keys(value).forEach(function(key){var descriptor=Object.getOwnPropertyDescriptor(value,key);!disableCompute&&Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["g" /* computed */])(value,key,descriptor);bind().apply(instance,[value,key,descriptor]);Object.defineProperty(value,key,descriptor);});return{get:function get(){return value;}};}

/***/ }),

/***/ 1026:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__xfe_team_utils_src_lock_async__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_error_protect__ = __webpack_require__(374);
var _this=this;/**
 * 守护 events, 确保入口函数异常能够被正确捕获
 * @param {object} clazz - 装饰器属性
 * @param {string} methodName - 装饰器属性
 * @param {object} descriptor - 装饰器属性
 * @return {{set(), get(): any}}
 */var entry=function entry(instance,methodName){var descriptor=arguments.length>2&&arguments[2]!==undefined?arguments[2]:Object.getOwnPropertyDescriptor(instance,methodName);var value=instance[methodName]||descriptor.initializer&&descriptor.initializer.call(_this);Object.keys(value).forEach(function(key){var descriptor=Object.getOwnPropertyDescriptor(value,key);var nativeFunc=descriptor.value;var locker=Object(__WEBPACK_IMPORTED_MODULE_0__xfe_team_utils_src_lock_async__["a" /* default */])();value[key]=function(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return Object(__WEBPACK_IMPORTED_MODULE_1__src_error_protect__["a" /* default */])()(function(){return locker(function(){return nativeFunc.call.apply(nativeFunc,[instance].concat(args));});});};});return{get:function get(){return value;}};};/* harmony default export */ __webpack_exports__["a"] = (entry);

/***/ }),

/***/ 1027:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapper;
function mapper(instance,methodName){var value=instance[methodName];Object.keys(value).forEach(function(key){var rawValue=value[key];value[key]=function(){return rawValue.apply(instance,arguments);};});return{value:value};}

/***/ }),

/***/ 1028:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = com;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_route_with_enhance_router__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_decorators__ = __webpack_require__(121);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};/**
 * com 作为 component 缩写
 */function com(staticMethods){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var disableWithEnhanceRouter=options.disableWithEnhanceRouter;return function(TargetComponent){TargetComponent=[!disableWithEnhanceRouter&&__WEBPACK_IMPORTED_MODULE_0__src_components_route_with_enhance_router__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2_core_decorators__["a" /* autobind */],__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* observer */]].reduceRight(function(Component,hoc){if(typeof hoc==='function'){return hoc(Component)||Component;}return Component;},TargetComponent);return _extends(TargetComponent,staticMethods);};}

/***/ }),

/***/ 1029:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommonModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_components_modal_helper_extend_append__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_modal__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_link__ = __webpack_require__(998);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=__webpack_require__(1039);var CommonModal=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__src_components_modal_helper_extend_append__["a" /* default */])({withoutDefaultWrapModal:true}),_dec(_class=function(_React$PureComponent){_inherits(CommonModal,_React$PureComponent);function CommonModal(props){_classCallCheck(this,CommonModal);var _this=_possibleConstructorReturn(this,(CommonModal.__proto__||Object.getPrototypeOf(CommonModal)).call(this,props));_this.state={visible:true};return _this;}/**
   * 关闭弹窗
   */_createClass(CommonModal,[{key:'onCloseClick',value:function onCloseClick(){this.setState({visible:false});}},{key:'render',value:function render(){var _this2=this;var visible=this.state.visible;var _props=this.props,desc=_props.desc,onConfirmClick=_props.onConfirmClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_modal__["a" /* default */],{visible:visible},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'xfe-common-modal-root'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'xfe-main-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'xfe-group-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'xfe-layer-2',dangerouslySetInnerHTML:{__html:'<div>'+desc+'</div>'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles.btnGroup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'\u786E  \u5B9A',className:styles.inputButton,onClick:function onClick(){onConfirmClick();_this2.onCloseClick();}}))))));}}]);return CommonModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent))||_class);

/***/ }),

/***/ 1030:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_modal_helper_append__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_modal_modal_hoc__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extend_append_less__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extend_append_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__extend_append_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};/**
 * 拓展 append 静态方法
 * e.g.
 *
 * @extendAppend
 * export default class Test extends React.Component {
 *   ...
 * }
 *
 * // 此时, Test 组件会被自动注入 append 的静态方法
 *
 * 调用 Test.append(undefined, this) 后即可弹出弹窗
 * 注意: Test.append(<参数1: modal 弹窗 props, 可以自定义拓展部分 props 属性>, <react component 环境变量, 这样可以便于弹窗关闭后自动回收>)
 *
 * @param {string} [staticMethodName] - 静态方法名, 默认: append
 * @param {string} [modalClassName] - 弹窗 css name
 * @param {boolean} [withoutDefaultWrapModal] - 默认情况下 extendAppend 会自动包裹一层 modal, 但用户可以使用参数 withoutDefaultWrapModal 禁用该行为
 * @returns {Function}
 */var extendAppend=function extendAppend(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},_ref$staticMethodName=_ref.staticMethodName,staticMethodName=_ref$staticMethodName===undefined?'append':_ref$staticMethodName,modalClassName=_ref.modalClassName,withoutDefaultWrapModal=_ref.withoutDefaultWrapModal;return function(ComponentClazz){if(ComponentClazz[staticMethodName]){throw new Error('target property ['+staticMethodName+'] \u5DF2\u7ECF\u5B58\u5728, \u8BF7\u4F7F\u7528\u5176\u4ED6\u9759\u6001\u65B9\u6CD5\u540D');}ComponentClazz[staticMethodName]=function(){var props=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var componentContext=arguments[1];var FinalComponent=Object(__WEBPACK_IMPORTED_MODULE_2__src_components_modal_modal_hoc__["a" /* default */])({wrapClassName:__WEBPACK_IMPORTED_MODULE_4_classnames___default()(modalClassName,__WEBPACK_IMPORTED_MODULE_3__extend_append_less___default.a.extendAppend),withoutDefaultWrapModal:withoutDefaultWrapModal})(ComponentClazz);return Object(__WEBPACK_IMPORTED_MODULE_0__src_components_modal_helper_append__["a" /* default */])(function(appendProps){/**
       * 开发环境
       */// if (!DEPLOY_ENV) {
//   Object.keys(appendProps).forEach(key => {
//     invariant(props[key] === undefined, `禁止使用保留字段 key = ${key}`);
//   });
// }
return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](FinalComponent,_extends({modal:appendProps},props));},componentContext);};return ComponentClazz;};};/* harmony default export */ __webpack_exports__["a"] = (extendAppend);

/***/ }),

/***/ 1031:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = interceptComponentWillUnmount;
/**
 * 拦截 componentWillUnmount
 * @param componentContext
 * @param action
 */function interceptComponentWillUnmount(componentContext,action){if(componentContext){var raw=componentContext.componentWillUnmount;componentContext.componentWillUnmount=function(){action&&action.apply(componentContext);/**
       * 传入 componentContext 为了修正 react hot loader 的二次处理
       */raw&&raw.apply(componentContext);};}}

/***/ }),

/***/ 1032:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_components_modal__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xfe_team_utils_src_data_utils__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_utils_is_window_onload__ = __webpack_require__(1036);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalHOC=function ModalHOC(){var extraProps=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return function(Component){var excludeProps=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];return function(_React$PureComponent){_inherits(_class,_React$PureComponent);function _class(){_classCallCheck(this,_class);return _possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).apply(this,arguments));}_createClass(_class,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var visible=this.props.visible;if(!visible){this.handleWindowOnLoad=function(){// // noinspection JSUnusedLocalSymbols
// const { visible, ...restProps } = this.props;
// const { close } = Modal.append(() => (
//   // display: none 背景图片不加载
//   <div
//     style={{
//       width: 0,
//       height: 0,
//       visibility: 'hidden',
//       overflow: 'hidden',
//       position: 'absolute'
//     }}
//   >
//     <Component {...withoutProps(restProps, excludeProps)} />
//   </div>
// ));
//
// this.close = close;
};Object(__WEBPACK_IMPORTED_MODULE_3__src_utils_is_window_onload__["a" /* default */])().then(function(){_this2.handleWindowOnLoad();});}}},{key:'removeWindowOnLoadListener',value:function removeWindowOnLoadListener(){this.handleWindowOnLoad=function(f){return f;};}},{key:'componentWillUpdate',value:function componentWillUpdate(){var visible=this.props.visible;visible&&this.removeWindowOnLoadListener();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.close&&this.close();this.removeWindowOnLoadListener();}},{key:'render',value:function render(){var _props=this.props,modal=_props.modal,restProps=_objectWithoutProperties(_props,['modal']);var withoutDefaultWrapModal=extraProps.withoutDefaultWrapModal,finalModalExtraProps=_objectWithoutProperties(extraProps,['withoutDefaultWrapModal']);if(withoutDefaultWrapModal){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,_extends({},modal,Object(__WEBPACK_IMPORTED_MODULE_2__xfe_team_utils_src_data_utils__["a" /* withoutProps */])(restProps,excludeProps)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__src_components_modal__["a" /* default */],_extends({},finalModalExtraProps,modal),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,_extends({modal:modal},Object(__WEBPACK_IMPORTED_MODULE_2__xfe_team_utils_src_data_utils__["a" /* withoutProps */])(restProps,excludeProps))));}}]);return _class;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);};};/* harmony default export */ __webpack_exports__["a"] = (ModalHOC);

/***/ }),

/***/ 1033:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Modal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_index_m_less__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_index_m_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_index_m_less__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modal=(_temp=_class=function(_React$Component){_inherits(Modal,_React$Component);function Modal(){_classCallCheck(this,Modal);return _possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).apply(this,arguments));}_createClass(Modal,[{key:'preventLongClick',/**
   * 优化:
   * 由于按钮使用 a 标签, 在移动端长按会弹出右键菜单
   * 所以决定禁用右键菜单
   */value:function preventLongClick(){var $target=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.$dom);Modal.disableContextMenu($target,'am-modal-button');}},{key:'enableAutoCloseTimeout',value:function enableAutoCloseTimeout(func,duration){this.clearAutoCloseTimeout();this.autoCloseTimeoutHook=setTimeout(func,duration);}},{key:'clearAutoCloseTimeout',value:function clearAutoCloseTimeout(){clearTimeout(this.autoCloseTimeoutHook);}/**
   * 是否应该自动关闭
   */},{key:'shouldAutoClose',value:function shouldAutoClose(){var _props=this.props,duration=_props.duration,onClose=_props.onClose;if(duration&&onClose){this.enableAutoCloseTimeout(onClose,duration);}}},{key:'componentDidMount',value:function componentDidMount(){/**
     * 禁止长按
     */this.preventLongClick();/**
     * 判断是否自动关闭
     */this.shouldAutoClose();}},{key:'componentWillUnmount',value:function componentWillUnmount(){/**
     * 清除 timeout 钩子
     */this.clearAutoCloseTimeout();}},{key:'renderDescription',value:function renderDescription(_ref){var description=_ref.description,prefixCls=_ref.prefixCls;if(Array.isArray(description)){return description.map(function(item,key){if((typeof item==='undefined'?'undefined':_typeof(item))==='object'){switch(item.type){case'img':return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img',{key:key,className:prefixCls+'-des-img',src:item.src,alt:item.alt});default:throw new Error('unknown description item type = '+item.type);}}return item;});}return description;}},{key:'renderChildren',value:function renderChildren(_ref2){var children=_ref2.children,title=_ref2.title,prefixCls=_ref2.prefixCls,extra=_ref2.extra,description=_ref2.description;if(children){return children;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,Modal.renderHeader({title:title,prefixCls:prefixCls}),description&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:prefixCls+'-des'},this.renderDescription({description:description,prefixCls:prefixCls})),Modal.renderExtra({extra:extra,prefixCls:prefixCls}));}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,prefixCls=_props2.prefixCls,visible=_props2.visible,footer=_props2.footer,title=_props2.title,description=_props2.description,extra=_props2.extra,children=_props2.children,className=_props2.className,frameless=_props2.frameless,_props2$finalClassNam=_props2.finalClassName,finalClassName=_props2$finalClassNam===undefined?__WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__style_index_m_less___default.a.root,className):_props2$finalClassNam,wrapClassName=_props2.wrapClassName,props=_objectWithoutProperties(_props2,['prefixCls','visible','footer','title','description','extra','children','className','frameless','finalClassName','wrapClassName']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_mobile__["a" /* Modal */],_extends({ref:function ref($ref){return _this2.$dom=$ref;},className:finalClassName,transparent:true,maskClosable:true},props,{wrapClassName:__WEBPACK_IMPORTED_MODULE_4_classnames___default()(prefixCls,frameless&&prefixCls+'-frameless',wrapClassName),visible:visible,footer:footer}),this.renderChildren({prefixCls:prefixCls,title:title,description:description,extra:extra,children:children}));}}],[{key:'disableContextMenu',value:function disableContextMenu($dom,childrenClassName){if($dom&&$dom.getElementsByClassName){Array.prototype.forEach.call($dom.getElementsByClassName(childrenClassName),function($button){$button.oncontextmenu=function(event){event.preventDefault();event.stopPropagation();return false;};});}}/**
   * 确认按钮的 Footer 常量
   * @type {*[]}
   */},{key:'renderHeader',value:function renderHeader(_ref3){var title=_ref3.title,prefixCls=_ref3.prefixCls;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('header',{className:prefixCls+'-title'},title);}},{key:'renderExtra',value:function renderExtra(_ref4){var extra=_ref4.extra,prefixCls=_ref4.prefixCls;if(extra){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:prefixCls+'-extra'},extra);}return null;}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.defaultProps={prefixCls:'xc-modal'},_class.CONFIRM_FOOTER=[{text:'确定',onPress:function onPress(props){props.onClose();}}],_temp);Modal.propTypes={/**
   * 是否可见
   */visible:__WEBPACK_IMPORTED_MODULE_3_prop_types__["bool"],/**
   * 对话框底部, 主要用于关于按钮点击
   */footer:Object(__WEBPACK_IMPORTED_MODULE_3_prop_types__["arrayOf"])(Object(__WEBPACK_IMPORTED_MODULE_3_prop_types__["shape"])({/**
       * 按钮文案
       */text:__WEBPACK_IMPORTED_MODULE_3_prop_types__["string"],/**
       * 点击事件, (props) => void | promise
       */onPress:__WEBPACK_IMPORTED_MODULE_3_prop_types__["func"]}))};

/***/ }),

/***/ 1034:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"index-m-root-2yA0F"};

/***/ }),

/***/ 1035:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(996);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var alert=function alert(extraProps){var _Modal$append=__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */].append(function(props){var finalProps=_extends({},props,extraProps);if(Array.isArray(finalProps.footer)){finalProps.footer=finalProps.footer.map(function(button){var originPress=button.onPress||function(){};button.onPress=function(){var res=originPress(finalProps);if(res&&res.then){res.then(function(){close();}).catch(function(){});}else{close();}};return button;});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */],_extends({},props,extraProps));}),close=_Modal$append.close;return close;};/* harmony default export */ __webpack_exports__["a"] = (alert);

/***/ }),

/***/ 1036:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isWindowOnload;
var onloadListenerHOF=function onloadListenerHOF(resolve){return function listener(){window.removeEventListener('load',listener);resolve(true);};};/**
 * 判断当前 window 是否已经 onload 完成
 *
 * e.g.
 * const loaded = await isWindowOnload();
 *
 * e.g.
 * const loaded = isWindowOnload();
 * if (loaded === true) {
 *     console.log('window 已经 onload');
 * } else {
 *     loaded.then(()=> {
 *      console.log('window onload 了');
 *     })
 * }
 *
 * @returns {boolean|Promise<boolean>}
 * @param {boolean} alwaysPromisify - 总是使用 promise, 默认为 true, 这样可以保证当前方法只返回 promise 进行使用. 设置 false 时, 当 window onload 后返回 true 布尔值, 这样减少 async await 调度时间
 * @returns {boolean|Promise<boolean>}
 */function isWindowOnload(){var alwaysPromisify=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;if(document.readyState==='complete'){if(alwaysPromisify){return Promise.resolve(true);}else{return true;}}return new Promise(function(resolve){window.addEventListener('load',onloadListenerHOF(resolve));});}

/***/ }),

/***/ 1037:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"extendAppend":"extend-append-extendAppend-1dlBQ"};

/***/ }),

/***/ 1038:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"link":"index-link-2ulTf","opacity":"index-opacity-cxnrM","brightness":"index-brightness-3uztJ"};

/***/ }),

/***/ 1039:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"moveIn":"index-moveIn-8Uqzb","btnGroup":"index-btnGroup-1L3Mw","inputButton":"index-inputButton-1QsoR"};

/***/ }),

/***/ 1040:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_link__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_services_general__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_toast__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_utils_lock_async__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_utils_custom_event__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_utils_reload__ = __webpack_require__(997);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_desc,_value,_class,_class2,_temp;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}var styles=__webpack_require__(1047);var AccountInfo=(_dec=Object(__WEBPACK_IMPORTED_MODULE_5__src_utils_lock_async__["a" /* default */])(),_dec2=Object(__WEBPACK_IMPORTED_MODULE_5__src_utils_lock_async__["a" /* default */])(),(_class=(_temp=_class2=function(_PureComponent){_inherits(AccountInfo,_PureComponent);function AccountInfo(){_classCallCheck(this,AccountInfo);return _possibleConstructorReturn(this,(AccountInfo.__proto__||Object.getPrototypeOf(AccountInfo)).apply(this,arguments));}_createClass(AccountInfo,[{key:'logout',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _props,onBeforeLogoutSuccess,makeLogoutRequest,onLogoutSuccess,onLogoutClick;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props=this.props,onBeforeLogoutSuccess=_props.onBeforeLogoutSuccess,makeLogoutRequest=_props.makeLogoutRequest,onLogoutSuccess=_props.onLogoutSuccess,onLogoutClick=_props.onLogoutClick;_context.prev=1;_context.next=4;return onLogoutClick();case 4:_context.next=9;break;case 6:_context.prev=6;_context.t0=_context['catch'](1);alert(_context.t0.message);// Toast.fail(e.message);
case 9:case'end':return _context.stop();}}},_callee,this,[[1,6]]);}));function logout(){return _ref.apply(this,arguments);}return logout;}()/**
   * 渲染登出链接
   * @returns {null|ReactDOM}
   */},{key:'renderLogoutLink',value:function renderLogoutLink(){var isAllowLogout=this.props.isAllowLogout;if(isAllowLogout){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_link__["a" /* default */],{className:styles.logout,onClick:this.logout},'\u3010\u9000\u51FA\u3011');}return null;}/**
   * 创建文本掩码
   * @param {string} text - 文本
   */},{key:'createTextMask',value:function createTextMask(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var textLength=text.length;var accountArr=text.substring(3,textLength-3);return text.replace(accountArr,'******');}/**
   * 触发登录事件
   */},{key:'onLogin',value:function onLogin(){var _props2=this.props,onLoginSuccess=_props2.onLoginSuccess,onLoginClick=_props2.onLoginClick;onLoginClick&&onLoginClick();// const { close } = LoginModal.append(
//   {
//     onLoginSuccess({ account: username, res }) {
//       // noinspection JSIgnoredPromiseFromCall
//       close();
//       AccountInfo.emitLoginStatus(AccountInfo.Events.Login);
//       onLoginSuccess(username, res);
//     }
//   },
//   this
// );
}},{key:'isLogin',value:function isLogin(){return!!this.props.username;}},{key:'render',value:function render(){var _props3=this.props,username=_props3.username,isUsingMaskToUsername=_props3.isUsingMaskToUsername,renderDisplayUsername=_props3.renderDisplayUsername,renderLoginDisplayContent=_props3.renderLoginDisplayContent,className=_props3.className,style=_props3.style;if(this.isLogin()){/**
       * 计算后获取最终用于展示的 username
       */var displayUsername=isUsingMaskToUsername?this.createTextMask(username):username;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_8_classnames___default()(styles.textRoot,className),style:style},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:styles.displayName},renderDisplayUsername(displayUsername,this)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:styles.inlineText},this.renderLogoutLink()));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_8_classnames___default()(styles.textRoot,className),style:style},renderLoginDisplayContent(this.onLogin));}}],[{key:'subscribeLoginStatus',/**
   * 监听登录状态, 当登录状态因 AccountInfo 发生变化时将触发回调
   * @param {Function} callback - 回调方法
   * @example
   * 基本用法:
   *
   * AccountInfo.subscribeLoginStatus(({ status }) => {
   *
   * this.destroyAccountInfoListener = AccountInfo.subscribeLoginStatus(({ status }) => {
   *   if (status === AccountInfo.Events.Login) {
   *     alert('登录成功');
   *   } else {
   *     alert('退出成功');
   *   }
   * });
   *
   * ...
   *
   * componentWillUnmount() {
   *   this.destroyAccountInfoListener();
   * }
   *
   * @returns {Function}
   */value:function subscribeLoginStatus(callback){return Object(__WEBPACK_IMPORTED_MODULE_7__src_utils_custom_event__["b" /* listenCustomEvent */])(AccountInfo.Events.LoginStatus,callback);}/**
   * 发送登录状态变更事件
   * @private
   * @param status
   */},{key:'emitLoginStatus',value:function emitLoginStatus(status){Object(__WEBPACK_IMPORTED_MODULE_7__src_utils_custom_event__["a" /* dispatchCustomEvent */])({eventName:AccountInfo.Events.LoginStatus,payload:{status:status}});}}]);return AccountInfo;}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]),_class2.Events={LoginStatus:'accountInfo:login-status',Login:1,Logout:-1},_temp),(_applyDecoratedDescriptor(_class.prototype,'logout',[__WEBPACK_IMPORTED_MODULE_6_core_decorators__["a" /* autobind */],_dec],Object.getOwnPropertyDescriptor(_class.prototype,'logout'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onLogin',[__WEBPACK_IMPORTED_MODULE_6_core_decorators__["a" /* autobind */],_dec2],Object.getOwnPropertyDescriptor(_class.prototype,'onLogin'),_class.prototype)),_class));var noop=function noop(f){return f;};AccountInfo.defaultProps={isUsingMaskToUsername:true,usernameMaskSymbol:'*',renderDisplayUsername:function renderDisplayUsername(displayUsername){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,'\u60A8\u597D\uFF0C',displayUsername);},renderLoginDisplayContent:function renderLoginDisplayContent(onLogin){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:styles.displayName},'\u60A8\u597D,\u8BF7'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_link__["a" /* default */],{className:styles.login,onClick:onLogin},'\u3010\u767B\u5F55\u3011'));},makeLogoutRequest:function makeLogoutRequest(){return __WEBPACK_IMPORTED_MODULE_3__src_services_general__["a" /* default */].logout();},onBeforeLogoutSuccess:function onBeforeLogoutSuccess(){},isAllowLogout:true,onLoginSuccess:noop,onLogoutSuccess:noop};

/***/ }),

/***/ 1041:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile__ = __webpack_require__(376);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Toast=function(){function Toast(){_classCallCheck(this,Toast);}_createClass(Toast,null,[{key:'createAntdToastClickEventListener',value:function createAntdToastClickEventListener(_ref){var onClose=_ref.onClose;var amToastEl=document.querySelector('.am-toast');var dataId=String(+new Date());if(!amToastEl){return;}amToastEl.dataset.dataId=dataId;amToastEl.addEventListener('click',function(e){var createTime=Number(e.currentTarget.dataset.dataId);if(createTime){/**
         * 最小等待时间, 用于防止用户点击过快没有看到 toast 内容
         * @type {number}
         */var minimalDelay=800;var timeDiff=createTime+minimalDelay-+new Date();var delay=timeDiff>0?timeDiff:0;if(delay){return;}Toast.hide();onClose&&onClose();}});}},{key:'info',value:function info(content,duration){var onClose=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var mask=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var closable=arguments.length>4&&arguments[4]!==undefined?arguments[4]:true;__WEBPACK_IMPORTED_MODULE_0_antd_mobile__["b" /* Toast */].info(content,duration,onClose,mask);closable&&Toast.createAntdToastClickEventListener({onClose:onClose});}},{key:'offline',value:function offline(content,duration){var onClose=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var mask=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var closable=arguments.length>4&&arguments[4]!==undefined?arguments[4]:true;__WEBPACK_IMPORTED_MODULE_0_antd_mobile__["b" /* Toast */].offline(content,duration,onClose,mask);closable&&Toast.createAntdToastClickEventListener({onClose:onClose});}},{key:'success',value:function success(content,duration){var onClose=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var mask=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var closable=arguments.length>4&&arguments[4]!==undefined?arguments[4]:true;__WEBPACK_IMPORTED_MODULE_0_antd_mobile__["b" /* Toast */].success(content,duration,onClose,mask);closable&&Toast.createAntdToastClickEventListener({onClose:onClose});}},{key:'fail',value:function fail(content,duration){var onClose=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var mask=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var closable=arguments.length>4&&arguments[4]!==undefined?arguments[4]:true;__WEBPACK_IMPORTED_MODULE_0_antd_mobile__["b" /* Toast */].fail(content,duration,onClose,mask);closable&&Toast.createAntdToastClickEventListener({onClose:onClose});}},{key:'loading',value:function loading(){var content=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'加载中';var duration=arguments.length>1&&arguments[1]!==undefined?arguments[1]:999999;var onClose=arguments[2];var mask=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;__WEBPACK_IMPORTED_MODULE_0_antd_mobile__["b" /* Toast */].loading(content,duration,onClose,mask);}},{key:'hide',value:function hide(){__WEBPACK_IMPORTED_MODULE_0_antd_mobile__["b" /* Toast */].hide();}}]);return Toast;}();

/***/ }),

/***/ 1042:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lockAsync;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_EndThreadError__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__func_deco_util__ = __webpack_require__(1043);
var uniqueKey=0;var context={};/**
 * 锁定异步请求装饰器
 * 开发者可以通过 lockAsync 装饰器确保在 async 结束过程中不会有二次调用, 即防止一个按钮在"没完成"时被多次点击
 *
 * 使用方式1:
 *
 * class {
 *   @lockAsync()
 *   async onXXXClick() {
 *     await xxx.getUserInfo()
 *   }
 * }
 *
 * 使用方式2:
 * const locker = lockAsync();
 * locker(<函数>)
 *
 *
 * @param {string} [uniqueName] - 锁名, 一个锁名代表着一把锁, 开发者可以自定义使用同一个锁名去控制所有的锁,
 * 即当一个页面中都使用一个锁名时, 一个按钮触发的异步请求, 所有按钮都可以被锁定.
 *
 * 当不传入锁名时, 该装饰器会为每一个装饰函数设置一个唯一的锁, 即可以避免同一个按钮在"异步状态"未完成时候被多次点击
 * @returns {Function}
 */function lockAsync(){var uniqueName=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'__lock_async_'+uniqueKey++;return Object(__WEBPACK_IMPORTED_MODULE_1__func_deco_util__["a" /* async */])({/**
     * 函数调用前
     */before:function before(){var container=this||context;if(container[uniqueName]){throw new __WEBPACK_IMPORTED_MODULE_0__error_EndThreadError__["a" /* default */]();}container[uniqueName]=true;},/**
     * 函数调用后
     * @param result
     */after:function after(result){var container=this||context;if(result&&result.then){result.finally(function(){delete container[uniqueName];}).catch(function(f){return f;});}else{delete container[uniqueName];}}});}

/***/ }),

/***/ 1043:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sync */
/* harmony export (immutable) */ __webpack_exports__["a"] = async;
/* unused harmony export FunctionDecoIntercept */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_utils__ = __webpack_require__(1044);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/**
 * 装饰器辅助方法
 * 同步
 *
 * @example
 * @sync((e) => e.target.value)
 * onChange(value) {
 *   console.log(value);
 * }
 *
 * @example
 * @sync({before: (e) => e.target.value})
 * onChange(value) {
 *   console.log(value);
 * }
 *
 * @example
 * @sync({after: (result) => console.log(result)})
 * onChange(e) {
 *   return e.target.value
 * }
 */function sync(param){if(typeof param==='function'){param={before:param};}var _param=param,before=_param.before,after=_param.after;return function(Clazz,name,descriptor){var rawFunc=descriptor.value;descriptor.value=function(){/**
       * 执行前执行装饰器 before 钩子函数
       */var beforeResult=before&&before.apply(this,arguments);/**
       * 判断结果是不是 undefined,
       * 是, 直接使用之前的 arguments
       * 否, 将结果作为被装饰函数参数使用
       *
       * 这种做法是为了简化代码编写, 但有如下缺点:
       * 1. undefined 关键词被占用
       * 2. 当需要返回多个时候, 只能在被装饰函数中再次结构 array 使用
       */beforeResult===undefined?beforeResult=arguments:beforeResult=[beforeResult];/**
       * 执行被装饰函数
       */var result=rawFunc.apply(this,beforeResult);/**
       * 将结果交给 after result 进行再次加工
       */var afterResult=after&&after.call(this,result,arguments);/**
       * 将结果交给 after result 进行再次加工,
       * 这种做法是为了简化代码编写, 但有如下缺点:
       * 1. undefined 值被再次占用
       */afterResult===undefined&&(afterResult=result);return afterResult;};};}/**
 * 装饰器辅助方法
 * 异步
 *
 * @example
 * @async(() => wrapJsonp('https://apps-ws.xoyo.com/passport/get_info'))
 *
 * @example
 * @async({before: ()=> wrapJsonp('https://apps-ws.xoyo.com/passport/get_info')})
 *
 * @example
 * @async({after: ()=> wrapJsonp('https://apps-ws.xoyo.com/passport/get_info')})
 */function async(param){if(typeof param==='function'){param={before:param};}var _param2=param,before=_param2.before,after=_param2.after;return function(Clazz,name,descriptor){var rawFunc=descriptor.value;descriptor.value=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var beforeResult,result,afterResult,_args=arguments;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:/**
       * 执行前执行装饰器 before 钩子函数
       */beforeResult=before&&before.apply(this,_args);if(!(beforeResult===FunctionDecoIntercept)){_context.next=3;break;}return _context.abrupt('return');case 3:_context.t0=Object(__WEBPACK_IMPORTED_MODULE_1__type_utils__["a" /* isPromise */])(beforeResult);if(!_context.t0){_context.next=8;break;}_context.next=7;return beforeResult;case 7:beforeResult=_context.sent;case 8:/**
       * 判断结果是不是 undefined,
       * 是, 直接使用之前的 arguments
       * 否, 将结果作为被装饰函数参数使用
       *
       * 这种做法是为了简化代码编写, 但有如下缺点:
       * 1. undefined 关键词被占用
       * 2. 当需要返回多个时候, 只能在被装饰函数中再次结构 array 使用
       */beforeResult===undefined?beforeResult=_args:beforeResult=[beforeResult];/**
       * 执行被装饰函数
       */result=rawFunc.apply(this,beforeResult);/**
       * 将结果交给 after result 进行再次加工
       */afterResult=after&&after.call(this,result,_args);/**
       * 将结果交给 after result 进行再次加工,
       * 这种做法是为了简化代码编写, 但有如下缺点:
       * 1. undefined 值被再次占用
       */afterResult===undefined&&(afterResult=result);return _context.abrupt('return',afterResult);case 13:case'end':return _context.stop();}}},_callee,this);}));};}var FunctionDecoIntercept=function FunctionDecoIntercept(){_classCallCheck(this,FunctionDecoIntercept);};

/***/ }),

/***/ 1044:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isNumber */
/* unused harmony export isString */
/* unused harmony export isFunction */
/* unused harmony export isObjectLike */
/* unused harmony export isObject */
/* unused harmony export isArray */
/* unused harmony export isRegExp */
/* unused harmony export isTypeMatch */
/* unused harmony export isBoolean */
/* unused harmony export isUndefined */
/* unused harmony export isNullOrUndefined */
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/**
 * 是否数字
 * @param value
 * @return {boolean}
 */function isNumber(value){return typeof value==='number';}/**
 * 是否字符串
 * @param value
 * @return {boolean}
 */function isString(value){return typeof value==='string';}/**
 * 是否是函数
 * @param value
 * @return {boolean}
 */function isFunction(value){return typeof value==='function';}/**
 * 是否是类似对象
 * @param value
 * @return {boolean}
 */function isObjectLike(value){return(typeof value==='undefined'?'undefined':_typeof(value))==='object';}/**
 * 是否是对象
 * @param value
 * @return {*}
 */function isObject(value){return isTypeMatch(value,'Object');}/**
 * 是否是数组
 * @param value
 * @return {*}
 */function isArray(value){return isTypeMatch(value,'Array');}/**
 * 是否是正则
 * @param value
 * @return {*}
 */function isRegExp(value){return isTypeMatch(value,'RegExp');}/**
 * 匹配类型检测
 * @param value
 * @param typeName
 * @return {boolean}
 */function isTypeMatch(value,typeName){return Object.prototype.toString.call(value)==='[object '+typeName+']';}/**
 * 是否是布尔
 * @param value
 * @return {boolean}
 */function isBoolean(value){return typeof value==='boolean';}/**
 * 是否是undefined
 * @param value
 * @return {boolean}
 */function isUndefined(value){return typeof value==='undefined';}/**
 * 是否是null或者undefined
 * @param value
 * @return {boolean}
 */function isNullOrUndefined(value){return value===null||isUndefined(value);}/**
 * 是否是 promise
 * @param value
 * @return {boolean}
 */function isPromise(value){return __webpack_require__(384)(value);}

/***/ }),

/***/ 1045:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dispatchCustomEvent;
/* harmony export (immutable) */ __webpack_exports__["b"] = listenCustomEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_utils_error_utils__ = __webpack_require__(1046);
/**
 * 发送自定义事件
 *
 * @param {{eventName, payload, window}|string} params - 参数
 *
 * {string} eventName - 事件名
 * {object} payload - 请求数据
 * {object} window - 事件挂载元素, 默认 window
 *
 * 例如: (基本)
 *   dispatchCustomEvent({ eventName: Events.GameOver, payload: { score } });
 * 例如: (简写)
 *   dispatchCustomEvent(Events.GameOver);
 */function dispatchCustomEvent(params){var _params$eventName=params.eventName,eventName=_params$eventName===undefined?params:_params$eventName,payload=params.payload,_params$dom=params.dom,dom=_params$dom===undefined?window:_params$dom;var event=new CustomEvent(eventName,{detail:payload});dom.dispatchEvent(event);}/**
 * 处理监听事件
 * @param {{eventName, callback, dom}|string} params - 事件名
 *  {string} eventName - 事件名
 *  {object} callback - 回调
 *  {object} window - 事件挂载元素, 默认 window
 * @param {Function} [_callback] - 回调
 * @return {Function} - 返回销毁事件函数
 *
 * 例如: (基本)
 *    dispatchCustomEvent({ eventName: Events.GameOver, payload: { score } });
 *    const destroy = listenCustomEvent({eventName: Events.GameOver, callback: data => alert(JSON.stringify(data)));
 *    destroy();
 * 例如: (简写)
 *    const destroy = listenCustomEvent(Events.GameOver, callback: data => alert(JSON.stringify(data)));
 */function listenCustomEvent(params,_callback){Object(__WEBPACK_IMPORTED_MODULE_0__src_utils_error_utils__["a" /* invariant */])(params,'params is required, params = '+params);var _params$eventName2=params.eventName,eventName=_params$eventName2===undefined?params:_params$eventName2,_params$callback=params.callback,callback=_params$callback===undefined?_callback:_params$callback,_params$dom2=params.dom,dom=_params$dom2===undefined?window:_params$dom2;dom.addEventListener(eventName,function(e){callback(e.detail,e);},false);return function(){dom.removeEventListener(eventName,callback,false);};}

/***/ }),

/***/ 1046:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
var invariant=__WEBPACK_IMPORTED_MODULE_0_invariant__;

/***/ }),

/***/ 1047:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"textRoot":"index-textRoot-1ILVa","inlineText":"index-inlineText-2EQ4x","logout":"index-logout-Vj8ts","displayName":"index-displayName-3BMC-","login":"index-login-3Qn78"};

/***/ }),

/***/ 1052:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpdatePhoneVM; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_mobx_store_vm_view_model__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_utils_captcha_deco_util__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pages_app_router_route_configs__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_business_components_common_modal__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_services_general__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_utils_reload__ = __webpack_require__(997);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2,_this6=this;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdatePhoneVM=(_temp2=_class=function(_VM){_inherits(UpdatePhoneVM,_VM);function UpdatePhoneVM(){var _ref,_dec,_desc,_value,_obj;var _temp,_this,_ret;_classCallCheck(this,UpdatePhoneVM);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UpdatePhoneVM.__proto__||Object.getPrototypeOf(UpdatePhoneVM)).call.apply(_ref,[this].concat(args))),_this),_this.viewState={//用户名
account:'',//是否有绑定手机
isBindPhone:false,//绑定手机号(加密)
bindPhone:undefined,//手机验证码
code:undefined,//原手机号码
oldPhone:undefined,//新手机号码
newPhone:undefined,//步骤-修改绑定手机
stepperRebind:[{title:'1.绑定新手机',key:'bindNewPhone'},{title:'2.验证原手机',key:'verifyOldPhone'},{title:'3.完成',key:'complete'}],//当前执行步骤
currentStep:'bindNewPhone',//是否验证原手机
checkOldPhone:true},_this.computes={// get isValid() {
//   return Number(this.viewState.inputStore.value) > 100;
// }
},_this.mappers={// /**
//  * @this {MainVM}
//  */
// mapBusinessExampleNewsItems(items) {
//   debugger;
//   return Object.keys(items).map(key => {
//     const item = items[key];
//     return {
//       des: item.description,
//       title: item.title,
//       onClick: () => {
//         this.entry.onButtonClick({ id: item.id });
//       }
//     };
//   });
// }
},_this.entry=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__src_utils_captcha_deco_util__["a" /* default */])(),(_obj={onExitClick:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_5__src_services_general__["a" /* default */].logout().then(function(data){alert('退出成功');Object(__WEBPACK_IMPORTED_MODULE_6__src_utils_reload__["a" /* default */])();_this2.redirect(__WEBPACK_IMPORTED_MODULE_3__src_pages_app_router_route_configs__["a" /* default */].MAIN.getFormatPath());}).catch(function(err){var errCode=err.serviceResponse.code;var errMsg=err.serviceResponse.message;alert(errMsg);});case 2:case'end':return _context.stop();}}},_callee,this);}));function onExitClick(){return _ref2.apply(this,arguments);}return onExitClick;}(),onLoginClick:function onLoginClick(){this.redirect(__WEBPACK_IMPORTED_MODULE_3__src_pages_app_router_route_configs__["a" /* default */].LOGIN.getFormatPath({type:'updatephone'}));},/**
     * 输入
     * @param type
     * @param v
     */onValueChange:function onValueChange(type,v){var value=v.replace(/\s+/g,'');// console.info(value);
switch(type){case'newPhone':this.viewState.newPhone=value;break;case'code':this.viewState.code=value;break;default:break;}},/**
     * 下一步
     * @param type
     */onSubmit:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(type){var isBindPhone,isValid;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:isBindPhone=this.viewState.isBindPhone;isValid=this.validVerifyPhone();_context2.t0=type;_context2.next=_context2.t0==='bindNewPhone'?5:_context2.t0==='verifyOldPhone'?10:15;break;case 5:_context2.t1=isValid;if(!_context2.t1){_context2.next=9;break;}_context2.next=9;return this.verifyOldPhone();case 9:return _context2.abrupt('break',16);case 10:_context2.t2=isValid;if(!_context2.t2){_context2.next=14;break;}_context2.next=14;return this.bindNewPhoneWithUpsms();case 14:return _context2.abrupt('break',16);case 15:return _context2.abrupt('break',16);case 16:case'end':return _context2.stop();}}},_callee2,this);}));function onSubmit(_x){return _ref3.apply(this,arguments);}return onSubmit;}(),ongetPhoneCode:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref4){var authParams=_objectWithoutProperties(_ref4,[]);var _viewState,phone,checkOldPhone;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_viewState=this.viewState,phone=_viewState.newPhone,checkOldPhone=_viewState.checkOldPhone;_context3.next=3;return this.$ztServices.getPhoneCode(_extends({phone:phone,checkOldPhone:checkOldPhone},authParams)).then(function(data){// console.info(token,data);
alert('发送验证码成功');}).catch(function(err){if(err&&err.serviceResponse){var errCode=err.serviceResponse.code;var errMsg=err.serviceResponse.message;alert(errMsg);}});case 3:case'end':return _context3.stop();}}},_callee3,this);}));function ongetPhoneCode(_x2){return _ref5.apply(this,arguments);}return ongetPhoneCode;}()},(_applyDecoratedDescriptor(_obj,'ongetPhoneCode',[_dec],Object.getOwnPropertyDescriptor(_obj,'ongetPhoneCode'),_obj)),_obj)),_temp),_possibleConstructorReturn(_this,_ret);}/**
   * 页面状态
   * @type {{}}
   */_createClass(UpdatePhoneVM,[{key:'$$componentDidMount',value:function $$componentDidMount(){this.viewState.account=this.$rootStore.globalStore.currentAccount;this.getConfig();}/**
   * 推导类型
   * @type {{}}
   *//**
   * 数据映射
   *//**
   * 入口函数
   */},{key:'validVerifyPhone',/**
   * 校验手机号码和验证码
   * @returns {boolean}
   */value:function validVerifyPhone(){var isValid=false;var _viewState2=this.viewState,newPhone=_viewState2.newPhone,code=_viewState2.code;if(!newPhone){alert('手机号码不能为空');}else if(!code){alert('验证码不能为空');}else if(code&&code.length!==6){alert('请输入6位数字');}else{isValid=true;}return isValid;}/**
   * 获取全局配置
   * @returns {Promise<void>}
   */},{key:'getConfig',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return this.$ztServices.getConfig().then(function(data){// console.info(data);
var bind_phone=data.bind_phone,is_bind_phone=data.is_bind_phone;_this3.viewState.bindPhone=bind_phone;_this3.viewState.isBindPhone=is_bind_phone;if(!is_bind_phone&&!bind_phone){__WEBPACK_IMPORTED_MODULE_4__src_business_components_common_modal__["a" /* default */].append({desc:'您还没有绑定过手机号码，是否进行手机绑定？',onConfirmClick:function onConfirmClick(){_this3.redirect(__WEBPACK_IMPORTED_MODULE_3__src_pages_app_router_route_configs__["a" /* default */].MAIN.getFormatPath());}},_this3.context);}}).catch(function(err){if(err&&err.serviceResponse){var errCode=err.serviceResponse.code;if(errCode===-12816||errCode===-13403/*账号未登录  请先登录*/){_this3.redirect(__WEBPACK_IMPORTED_MODULE_3__src_pages_app_router_route_configs__["a" /* default */].LOGIN.getFormatPath({type:'updatephone'}));}else{var errMsg=err.serviceResponse.message;alert(errMsg);}}});case 2:case'end':return _context4.stop();}}},_callee4,this);}));function getConfig(){return _ref6.apply(this,arguments);}return getConfig;}()/**
   * 验证原手机
   * @returns {Promise<void>}
   */},{key:'verifyOldPhone',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var _this4=this;var _viewState3,newPhone,code;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_viewState3=this.viewState,newPhone=_viewState3.newPhone,code=_viewState3.code;_context5.next=3;return this.$ztServices.verifyOldPhone(newPhone,code).then(function(data){// console.info(token,data);
// alert('验证原手机成功');
_this4.viewState.currentStep='verifyOldPhone';}).catch(function(err){if(err&&err.serviceResponse){var errCode=err.serviceResponse.code;if(errCode===-12816||errCode===-13403/*账号未登录  请先登录*/){_this4.redirect(__WEBPACK_IMPORTED_MODULE_3__src_pages_app_router_route_configs__["a" /* default */].LOGIN.getFormatPath({type:'updatephone'}));}else{var errMsg=err.serviceResponse.message;alert(errMsg);}}});case 3:case'end':return _context5.stop();}}},_callee5,this);}));function verifyOldPhone(){return _ref7.apply(this,arguments);}return verifyOldPhone;}()/**
   * 更改绑定手机(用户已绑定过手机的情况)
   * @returns {Promise<void>}
   */},{key:'bindNewPhoneWithUpsms',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var _this5=this;var newPhone;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:newPhone=this.viewState.newPhone;_context6.next=3;return this.$ztServices.bindNewPhoneWithUpsms(newPhone).then(function(data){// console.info(token,data);
// alert('绑定新手机成功');
_this5.viewState.currentStep='complete';}).catch(function(err){if(err&&err.serviceResponse){var errCode=err.serviceResponse.code;var errMsg=err.serviceResponse.message;if(errCode===-12816||errCode===-13403/*账号未登录  请先登录*/){_this5.redirect(__WEBPACK_IMPORTED_MODULE_3__src_pages_app_router_route_configs__["a" /* default */].LOGIN.getFormatPath({type:'updatephone'}));}else if(errCode===-20403/*请先按相关短信内容提示操作回复短信*/){errMsg='验证失败，逍遥没有收到您的短信！\n\n 1.请检查您回复的短信内容是否正确；\n 2.一定要用原绑定手机号发送哦！\n 3.短信有效时间为5分钟，请在5分钟内回复短信内容。';alert(errMsg);}else{alert(errMsg);}}});case 3:case'end':return _context6.stop();}}},_callee6,this);}));function bindNewPhoneWithUpsms(){return _ref8.apply(this,arguments);}return bindNewPhoneWithUpsms;}()}]);return UpdatePhoneVM;}(__WEBPACK_IMPORTED_MODULE_1__src_mobx_store_vm_view_model__["a" /* default */]),_class.getInitialProps=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:return _context7.abrupt('return',{});case 1:case'end':return _context7.stop();}}},_callee7,_this6);})),_temp2);

/***/ }),

/***/ 1053:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"index-root-2M1ES","stepperGroup":"index-stepperGroup-3SEEI","step":"index-step-1tl9h","stepActive":"index-stepActive-5JR4r","tipSpan":"index-tipSpan-3edB5","hidden":"index-hidden-2gEMN","table":"index-table-3SIPP","tableLable":"index-tableLable-3-Bg9","tableInput":"index-tableInput-1nxFe","input":"index-input-1jlMq","inputButton":"index-inputButton-Bhfky","spanColor":"index-spanColor-oxiHp","tableSubmit":"index-tableSubmit-b7l66","complete":"index-complete-1ywOC","verityOld":"index-verityOld-2sYVl","verityText":"index-verityText-1Z_N9","inputText":"index-inputText-2Bzys","sendButton":"index-sendButton-8EXVE","warnText":"index-warnText-38NLK","info":"index-info-2WQeK"};

/***/ }),

/***/ 989:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UpdatePhone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_pages_update_phone_vm__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_vm_component__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_utils_com__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_account_info__ = __webpack_require__(1040);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=__webpack_require__(1053);var UpdatePhone=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3__src_utils_com__["a" /* default */])({getInitialProps:__WEBPACK_IMPORTED_MODULE_1__src_pages_update_phone_vm__["a" /* default */].getInitialProps}),_dec(_class=function(_VMComponent){_inherits(UpdatePhone,_VMComponent);function UpdatePhone(){_classCallCheck(this,UpdatePhone);return _possibleConstructorReturn(this,(UpdatePhone.__proto__||Object.getPrototypeOf(UpdatePhone)).apply(this,arguments));}_createClass(UpdatePhone,[{key:'renderCurrentStep',value:function renderCurrentStep(){var _vm$viewState=this.vm.viewState,currentStep=_vm$viewState.currentStep,newPhone=_vm$viewState.newPhone,bindPhone=_vm$viewState.bindPhone;var _vm$entry=this.vm.entry,onSubmit=_vm$entry.onSubmit,onValueChange=_vm$entry.onValueChange,ongetPhoneCode=_vm$entry.ongetPhoneCode;switch(currentStep){case'bindNewPhone':return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('table',{className:styles.table,align:'center'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tr',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{className:styles.tableLable},'\u65B0\u7ED1\u5B9A\u624B\u673A:',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('br',null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:styles.spanColor},'(1[3/4/5/6/7/8/9]\u5F00\u5934)')),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{className:styles.tableInput},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input',{className:styles.input,maxLength:'12',size:16,onChange:function onChange(event){return onValueChange('newPhone',event.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:styles.spanColor},'*'))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tr',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{className:styles.tableLable},'\u77ED\u4FE1\u9A8C\u8BC1\u7801:',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('br',null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:styles.spanColor},'(6\u4F4D\u6570\u5B57)')),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{className:styles.tableInput},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input',{className:styles.input,maxLength:'6',size:16,onChange:function onChange(event){return onValueChange('code',event.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input',{type:'button',value:'\u83B7\u53D6\u9A8C\u8BC1\u7801',className:styles.inputButton,onClick:ongetPhoneCode}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:styles.spanColor},'*'))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tr',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{className:styles.tableSubmit,colSpan:'2'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input',{type:'button',value:'\u4E0B \u4E00 \u6B65',className:styles.button,maxLength:'16',size:20,onClick:function onClick(){return onSubmit(currentStep);}})))));case'verifyOldPhone':return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:styles.verityOld},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:styles.verityText},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',null,'\u65B0\u7ED1\u5B9A\u624B\u673A\u53F7\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',null,newPhone)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',null,'\u5DF2\u5411\u539F\u7ED1\u5B9A\u624B\u673A',bindPhone,'\u53D1\u9001\u9A8C\u8BC1\u77ED\u4FE1\uFF0C\u8BF7\u4ED4\u7EC6\u786E\u8BA4\u5E76\u56DE\u590D\u77ED\u4FE1\uFF0C\u8C22\u8C22\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',null,'\u56DE\u590D\u77ED\u4FE1\u540E,\u8BF7\u70B9\u51FB\u201C\u6211\u5DF2\u53D1\u9001\u201D\uFF0C\u5B8C\u6210\u4FEE\u6539'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:styles.inputText},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input',{type:'button',value:'\u6211\u5DF2\u53D1\u9001',className:styles.sendButton,maxLength:'16',size:20,onClick:function onClick(){return onSubmit(currentStep);}}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:styles.warnText},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',null,'\u6E29\u99A8\u63D0\u793A\uFF1A\u82E5\u60A8\u65E0\u6CD5\u9A8C\u8BC1\u539F\u7ED1\u5B9A\u624B\u673A\uFF0C\u8BF7\u5411\u5BA2\u670D\u7533\u8BF7\u3010',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',null,'GM\u4FEE\u6539\u7ED1\u5B9A\u624B\u673A'),'\u3011\u4E1A\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',null,'(\u4EC5\u9488\u5BF9\u7AEF\u6E38\uFF0C\u624B\u6E38\u7528\u6237\u8BF7\u8054\u7CFB\u201C\u6E38\u620F\u5728\u7EBF\u5BA2\u670D\u201D\u54A8\u8BE2\u3002)')));case'complete':return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:styles.complete},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',null,'\u4FEE\u6539\u6210\u529F\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',null,'\u60A8\u76EE\u524D\u7ED1\u5B9A\u624B\u673A\u53F7\u662F',newPhone));default:return null;}}},{key:'render',value:function render(){var vm=this.vm;var entry=vm.entry,viewState=vm.viewState,computes=vm.computes;var stepperRebind=viewState.stepperRebind,currentStep=viewState.currentStep,account=viewState.account;var onExitClick=entry.onExitClick,onLoginClick=entry.onLoginClick;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:styles.root},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:styles.stepperGroup},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:styles.tipSpan},'\xB7\xB7\xB7\xB7\xB7\xB7'),stepperRebind.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()(styles.step,currentStep===item.key&&styles.stepActive),key:index},item.title,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()(styles.tipSpan,item.key==='complete'&&styles.hidden)},'\xB7\xB7\xB7>\xB7\xB7\xB7'));}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:styles.tipSpan},'\xB7\xB7\xB7\xB7\xB7\xB7'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:styles.info},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__src_components_account_info__["a" /* default */],{username:account,onLogoutClick:onExitClick,onLoginClick:onLoginClick}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:styles.currentStepper},this.renderCurrentStep()));}}]);return UpdatePhone;}(Object(__WEBPACK_IMPORTED_MODULE_2__src_components_vm_component__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__src_pages_update_phone_vm__["a" /* default */])))||_class);

/***/ }),

/***/ 991:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_error_class__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_error_code__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_error_error_codes__ = __webpack_require__(373);
/**
 * "组件已卸载"异常
 * @type {{name, new(...[*]): CustomClass, constructor: *, __proto__, prototype: CustomClass}}
 */var UnmountError=Object(__WEBPACK_IMPORTED_MODULE_0__create_error_class__["a" /* default */])('UnmountError',Object(__WEBPACK_IMPORTED_MODULE_1__create_error_code__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__src_error_error_codes__["a" /* default */].UnmountError,__WEBPACK_IMPORTED_MODULE_1__create_error_code__["a" /* ErrorCodeType */].OK),'current component has been unmounted');/* harmony default export */ __webpack_exports__["a"] = (UnmountError);

/***/ }),

/***/ 992:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_detect_mobile_device__ = __webpack_require__(1004);
/** @module device-utils */// /**
//  * 获取 UA
//  * @return {string}
//  */
// export declare function getUserAgent(): string;
// /**
//  * 判断是否是手机
//  */
// export declare function isMobile(): boolean;
// /**
//  * 判断是否是 android 设备
//  */
// export declare function isAndroid(): boolean;
// /**
//  * 判断是否 ios 设备
//  */
// export declare function isIOS(): boolean;
// /**
//  * 是否是 微信 设备
//  */
// export declare function isWeiXin(): boolean;
// /**
//  * 判断是否是 mobile 微信
//  */
// export declare function isMWeiXin(): boolean;
// /**
//  * 判断是否是手机qq
//  * @return {boolean}
//  */
// export declare function isMQQ(): boolean;
// /**
//  * 判断是否是手机微博 UA
//  * @return {boolean}
//  */
// export declare function isMWeibo(): boolean;
// /**
//  * 判断是否是江湖 daily App
//  */
// export declare function isJianghuDaily(): boolean;
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_detect_mobile_device__);

/***/ }),

/***/ 993:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createTracker;
var config={eventGroup:'剑网3'/* 确定一下这个应该是英文 */,name:'XXX',identify:'other',eventTags:['zshd','mo']};function createTracker(report,getDiffRouteTime){return{loadPage:function loadPage(){report({eventName:'load_page',eventDescription:'加载活动页',eventDataValue:{td_pl:getDiffRouteTime()}});},/**
     * @param {string} [status] - success/fail
     */clickConfirmInvited:function clickConfirmInvited(status){report({eventName:'click_confirm_invited',eventDescription:'点击确定加入（被邀请）',eventDataValue:{status:status},types:{status:checkTypeHOF('string')}});}};}Number.isInteger=Number.isInteger||function(value){return typeof value==='number'&&isFinite(value)&&Math.floor(value)===value;};function checkTypeHOF(type){switch(type){case'int':return Number.isInteger;case'float':return function(value){return typeof value==='number'&&!Number.isInteger(value);};case'boolean':return function(value){return typeof value==='boolean';};case'string':return function(value){return typeof value==='string';};default:setTimeout(function(){throw new Error('st-report: invalid value type = '+type);},0);return null;}}

/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Validator.js - v3.2
//
// JSON Schema Validator for API w/ a middleware for express
// Developed by Nijiko Yonskai <nijikokun@gmail.com>
// Copyright 2013
var Validator = function (schema, middleware) {
  this.schema = schema
  this.parameters = Object.keys(this.schema)
  this.errors = {}
  this.retrieved = {}
  this.debug = false

  if (middleware) {
    return this.middleware()
  }
};

Validator.index = function index(obj,is, value) {
  if (typeof is == 'string') {
    return index(obj,is.split('.'), value)
  }

  if (is.length === 1 && value !== undefined) {
    return obj[is[0]] = value
  }

  if (is.length === 0) {
    return obj
  }

  return index(obj[is[0]],is.slice(1), value)
}

// Plugin Containers
Validator.plugins = {}
Validator.plugins._objects = []

// Extend validator field possibilities
Validator.implement = function (field, isObject, callback) {
  if (typeof isObject === 'function') {
    callback = isObject
    isObject = false
  }

  if (isObject) {
    Validator.plugins._objects.push(field)
  }

  Validator.plugins[field] = function (details, key, data) {
    var $this = this
    var option = {
      details: details,
      field: field,
      value: details[field],
      key: key,
      data: data,
      error: function (type, message) {
        if (typeof message === 'undefined') {
          message = type
          type = undefined
        }

        $this.error(key, (type || field), message, option)
        return $this.errors
      }
    }

    callback.call(this, option)
    return this.checkErrors()
  }
}

// Validator Initialization Methods
Validator.prototype.middleware = function () {
  var self = this

  return function (req, res, next) {
    req.validated = self.check(req)

    if (req.validated._error) {
      return res.send(500, req.validated)
    }

    next()
  }
}

// Initializes validation against an object
Validator.prototype.check = function (against) {
  this.against = against
  return this.validate()
}

// Parameter Check
//
// Retrieves data from either an express method, or explicitly given object.
Validator.prototype.param = function (key) {
  if (this.against.param) {
    return this.against.param(key)
  }

  return this.against[key]
}

// Roundup
//
// Gathers all sent data either through a request, or given explicitly,
// for fields that exist inside of the current schema.
Validator.prototype.roundup = function () {
  var scheme;

  return this.loop(function (key, data) {
    var data

    if (scheme = this.schema[key]) {
      data = this.param(key)

      if (typeof data !== 'undefined') {
        this.retrieved[key] = data
      } else if (scheme.required && typeof scheme['default'] === 'undefined') {
        this.error(key, "required", "This parameter is required.")
      } else if (typeof scheme['default'] !== 'undefined') {
        this.retrieved[key] = scheme['default']
      }
    }
  });
};

// Validation
Validator.prototype.validate = function () {
  // Retrieve the data initially
  // Check for errors after initial fetching.
  if (this.roundup()) {
    return this.errors
  }

  // There has to be a better way to do nesting with default checks.
  function loop (fields, details, key, data, deep) {
    var i = 0
    var field

    fields.sort(function (a, b) {
      return (a === 'required') ? 0 : 1;
    });

    for (i; i < fields.length; i++) {
      if (field = fields[i].toLowerCase()) {
        if(field === "required" && (data === undefined || data === null) && details['required'] === false){
          return this.errors;
        }
        if (deep && field === 'required' || field === 'default') {
          if (field === 'required' && typeof details['default'] === 'undefined' && !data) {
            return this.error(key, "required", "This parameter is required.")
          } else if (field === 'default' && typeof details['default'] !== 'undefined') {
            Validator.index(this.retrieved, deep, details['default'])
            data = details['default']
          }

          continue;
        }

        if (Validator.plugins[field]) {
          if (Validator.plugins[field].call(this, details, key, data)) {
            return this.errors
          }
        } else if (Object.prototype.toString.call(this.schema[key][field]) == "[object Object]" && Validator.plugins._objects.indexOf(field) == -1) {
          if (loop.call(this, Object.keys(this.schema[key][field]), this.schema[key][field], field, this.retrieved[key][field], key + "." + field)) {
            return this.errors
          }
        }
      }
    }
  }

  // Loop through validations for each key
  if (this.loop(function (key, data) {
    var details = this.schema[key], fields = Object.keys(details)
    return loop.call(this, fields, details, key, data)
  })) {
    return this.errors
  }

  // Return retrieved data
  return this.retrieved
}

// Error Management
Validator.prototype.error = function (key, type, message, option) {
  this.errors._error = this.errors._error || true
  this.errors[key] = this.errors[key] || {}
  this.errors[key][type] = {
    message: message
  }

  if (option && this.debug && typeof option.data !== "undefined") {
    this.errors[key][type].value = typeof option.data === 'object' ? JSON.stringify(option.data) : option.data
  }
}

// Check length of error object
Validator.prototype.checkErrors = function () {
  return (Object.keys(this.errors).length > 0)
}

// Validation Looper
//
// Loops through the parameters in the schema, and gets the retrieved data which is then
// passed along to the given callback as `key` and `data` arguments.
Validator.prototype.loop = function (callback) {
  var i = 0
  var data
  var key

  for (i; i < this.parameters.length; i++) {
    key = this.parameters[i]
    data = this.retrieved[key]
    callback.call(this, key, data)
  }

  // Clear stored data
  key = data = i = null

  // Check errors
  return this.checkErrors()
};

// Validator Implementation
//
// Field: `type`
//
// Checks whether value is function to support using native words.
// Checks against `Object.prototype.toString.call` for exact type rather than `typeof`.
// By doing so it requires that the field starts with a capitol letter such as: `String`.
Validator.implement("type", function (options) {
  if (typeof options.value === 'function') {
    options.value = options.value.name
  }

  if (Object.prototype.toString.call(options.data) !== "[object " + options.value + "]") {
    options.error("Invalid parameter data type, expected: " + options.value);
  }
});

// Validator Implementation
//
// Field: `length`
//
// Supports: `Number` or `Object` with `min` and `max` values.
//
// Checks given data length against a numerical value, when the field is an object we check against
// the `min` and `max` values. If the field is simply a numeric value we check for equality.
Validator.implement("length", true, function (options) {
  if (typeof options.data === "undefined") {
    return;
  }

  // Check whether length exists, otherwise use value
  options.against = options.data.length ? options.data.length : options.data;

  // Checks
  if (typeof options.value === "object") {
    if (options.value.min) {
      if (options.value.min > options.against) {
        options.error("min", "Must be greater than " + options.value.min + (options.data.type === "string" ? " characters long." : ""))
      }
    }

    if (options.value.max) {
      if (options.value.max < options.against) {
        options.error("max", "Must be less than " + options.value.max + (options.data.type === "string" ? " characters long." : ""))
      }
    }
  } else if (typeof options.value === "number") {
    if (options.value != options.against) {
      options.error("Must be " + options.value + " characters long.")
    }
  }
});

// Validator Implementation
//
// Field: `test`
//
// Supports: `RegExp` or `Array` of `RegExp`
//
// Checks given data against a single `RegExp` using `.test` or an `Array` of `RegExp` using `.test`
Validator.implement("test", function (options) {
  if (Object.prototype.toString.call(options.value) === "[object Array]") {
    var i = 0
    var regex

    for (i; i < options.value.length; i++) {
      if (!options.value[i].test(options.data.toString())) {
        options.error("test-" + i, "Parameter data did not pass regex test.")
      }
    }
  } else {
    if (!options.value.test(options.data)) {
      options.error("Parameter data did not pass regex test.")
    }
  }
})

// Export our module
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Validator
} else {
  if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return Validator }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else window.Validator = Validator;
}


/***/ }),

/***/ 995:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_error_class__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_error_code__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_error_error_codes__ = __webpack_require__(373);
/**
 * "中断线程"异常
 * @type {{name, new(...[*]): CustomClass, constructor: *, __proto__, prototype: CustomClass}}
 */var EndThreadError=Object(__WEBPACK_IMPORTED_MODULE_0__create_error_class__["a" /* default */])('EndThreadError',Object(__WEBPACK_IMPORTED_MODULE_1__create_error_code__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__src_error_error_codes__["a" /* default */].EndThreadError,__WEBPACK_IMPORTED_MODULE_1__create_error_code__["a" /* ErrorCodeType */].OK),'end current thread');/* harmony default export */ __webpack_exports__["a"] = (EndThreadError);

/***/ }),

/***/ 996:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_append__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__alert__ = __webpack_require__(1035);
__WEBPACK_IMPORTED_MODULE_0__Modal__["a" /* default */].append=__WEBPACK_IMPORTED_MODULE_1__helper_append__["a" /* default */];__WEBPACK_IMPORTED_MODULE_0__Modal__["a" /* default */].alert=__WEBPACK_IMPORTED_MODULE_2__alert__["a" /* default */];/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Modal__["a" /* default */]);

/***/ }),

/***/ 997:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__device_utils__ = __webpack_require__(1023);
/**
 * 页面刷新, 针对微信中安卓 window.location['reload']() 无效的问题处理
 */function reload(){if(__WEBPACK_IMPORTED_MODULE_0__device_utils__["a" /* default */].isIOS()){/**
     * 绕过部署时检测, 允许这个行为
     */window.location.reload.apply(window.location);return;}var newTs='&ts='+Date.now();var search=window.location.search;var hasTs=/&ts=\d+/.test(search);if(hasTs){search=window.location.search.replace(/&ts=\d+/,newTs);}else{if(!search){search='?';}search+=newTs;}window.location.href=window.location.origin+window.location.pathname+search+window.location.hash;}

/***/ }),

/***/ 998:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 点击链接
 */var Link=function(_PureComponent){_inherits(Link,_PureComponent);function Link(){_classCallCheck(this,Link);return _possibleConstructorReturn(this,(Link.__proto__||Object.getPrototypeOf(Link)).apply(this,arguments));}_createClass(Link,[{key:'render',value:function render(){var _props=this.props,children=_props.children,className=_props.className,clickEffect=_props.clickEffect,restProps=_objectWithoutProperties(_props,['children','className','clickEffect']);var clickEffectClassName={opacity:__WEBPACK_IMPORTED_MODULE_1__index_less___default.a.opacity,brightness:__WEBPACK_IMPORTED_MODULE_1__index_less___default.a.brightness}[clickEffect];className=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__index_less___default.a.link,className,clickEffectClassName);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',_extends({className:className},restProps),children);}}]);return Link;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);Link.defaultProps={/**
   * clickEffect 有效值: opacity | brightness
   */clickEffect:'opacity'};

/***/ }),

/***/ 999:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_mobx_store_vm_dependency_view_model__ = __webpack_require__(1000);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ViewModel=function(_DependencyViewModel){_inherits(ViewModel,_DependencyViewModel);function ViewModel(){_classCallCheck(this,ViewModel);return _possibleConstructorReturn(this,(ViewModel.__proto__||Object.getPrototypeOf(ViewModel)).apply(this,arguments));}return ViewModel;}(__WEBPACK_IMPORTED_MODULE_0__src_mobx_store_vm_dependency_view_model__["a" /* default */]);var VM=ViewModel;/* harmony default export */ __webpack_exports__["a"] = (VM);

/***/ })

});


// WEBPACK FOOTER //
// assets/js/chunk/update-phone.5a6ae6fb.js